// @ts-strict-ignore
import Form, { FormInstance } from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import * as React from 'react';
import {
    AllAppStoreArtifactUploadRules,
    AllAutoCherryPickStrategies,
    AllAutoReleaseStrategies,
    AllAutoSubmitStrategies,
    AllAutoSyncTranslationsExportStrategies,
    AllBetaBuildNotesStrategies,
    AllBumpVersionStrategies,
    AllDaysOfTheWeek,
    AllReleaseNotesDataSources,
    ReleaseNotesDataSource,
    AllRollbackResigningStrategies,
    AndroidAutoRolloutStartStrategy,
    AppIdentifierForIntegration,
    AppMonitoringHealthMetric,
    AppPlatform,
    AppStoreArtifactUploadDestinationType,
    AppStoreArtifactUploadRule,
    AppStoreArtifactUploadWorkflowSettings,
    AppStoreType,
    ASCRole,
    AutoBackmergeStrategy,
    AutoCherryPickStrategy,
    PRCommentStrategy,
    AutoCreateTestRunsStrategy,
    Automation,
    AutomationApplyBetaBuildNotes,
    AppNotificationType,
    AutomationApplyMetadata,
    AutomationAssignBetaBuildGroups,
    AutomationBAAssignBetaBuildGroups,
    AutomationAutoCreateReleaseChannels,
    AutomationAutoCreateTestRuns,
    AutomationAutoRelease,
    AutomationAutoSelectLatestBuild,
    AutomationAutoStagedRollout,
    AutomationAutoSubmitRelease,
    AutomationPullSubmissionFromReview,
    AutomationAutoSyncAppleDevices,
    AutomationAutoSyncAppleProvisioningProfilesDevices,
    AutomationAutoAddMissingFAs,
    AutomationAutoApplyLabelsToFixTickets,
    AutomationAutoCreatePMTicketOnTriageIssueFixRequest,
    AutomationAutoCreateRunwayReleases,
    AutomationAutoTagReleases,
    AutomationAutoUploadBinaryArtifactToAppStore,
    AutomationAutoUploadDsymsToStabilityMonitoring,
    AutomationBAAutoTriggerBuildSystemWorkflow,
    AutomationBackmergeReleaseBranches,
    AutomationBumpVersion,
    AutomationCherryPickFromWorkingBranch,
    AutomationCreateIncidents,
    AutomationCreateIncidentsData,
    AutomationAutoTriggerCIWorkflow,
    AutoTriggerCIWorkflowData,
    TriggerCIWorkflowConditionGroup,
    UnhealthyMetricsTriggerConfig,
    AutomationCherryPickLocalizableStrings,
    AutomationDistributeReleaseSummary,
    AutomationHaltPromotePhasedReleaseData,
    AutomationHaltPromotePhasedReleaseConditionGroup,
    AutomationHaltUnstableRelease,
    AutomationKickoffRelease,
    AutomationPrepareRollbackRelease,
    AutomationPrepareRollbackReleaseData,
    AutomationPromoteBuildsToTestTrack,
    AutomationPromoteStablePhasedRelease,
    AutomationReleaseTypeOverride,
    AutomationReleaseTypes,
    AutomationAutoSyncSlackPilotUserGroup,
    AutomationAutoSyncTeamsPilotTag,
    AutomationSyncAppStoreUsers,
    AutomationSyncMetadataFromVCS,
    AutomationSyncMetadataTranslations,
    AutomationSyncTranslations,
    AutomationType,
    AutomationTypesWithSettings,
    AutoReleaseStrategy,
    AutoSelectLatestBuildStrategy,
    AutoStagedRolloutBlackoutDay,
    AutoStagedRolloutBlackoutSegmentsByDay,
    AutoSubmitStrategy,
    AutoSyncTranslationsExportStrategy,
    AutoTransitionIssueTrackingTickets,
    AutoTriggerBuildDistroBuildData,
    AzureActiveDirectoryTeam,
    BAAutomationAutoUploadBinaryArtifactToAppStore,
    BaseCIIntegrationData,
    BaseStabilityMonitoringIntegrationData,
    BetaGroup,
    BuildNotesAutomationStrategy,
    betaBuildNotesStrategyUsesCIMatchedBuild,
    isAIBetaBuildNotesStrategy,
    isSelectableAsBetaBuildNotesFallback,
    BumpVersionAutomationStrategy,
    ChecklistItemTemplate,
    DsymUploadDestinationOption,
    DayOfTheWeek,
    disallowedTokensForForAndroidTrackReleaseName,
    DsymsUploadWorkflowSettings,
    FileStats,
    FirebaseBetaGroup,
    GoogleAppStoreSettings,
    GooglePlayConsolePermission,
    Integration,
    IntegrationCapability,
    IntegrationFirebaseBeta,
    IntegrationGoogleBeta,
    IntegrationInstallationId,
    IntegrationProvider,
    IntegrationProviderApple,
    IntegrationProviderAzureActiveDirectory,
    IntegrationProviderGoogle,
    IntegrationProviderIncidentIo,
    IntegrationProviderPagerDuty,
    IntegrationProviderType,
    IntegrationTestFlight,
    IntegrationTestRail,
    IntegrationType,
    JiraIntegrationData,
    JiraProject,
    LinearIntegrationData,
    LinearTeam,
    MonitoringAutomationConditionType,
    NotificationTriggerConditionType,
    OrgUser,
    PatternToken,
    PullRequestType,
    ReleaseStepType,
    ReleaseTypesForNonBlockingSteps,
    RequireAtLeastOneOfTokensForAndroidTrackReleaseName,
    RoleSyncData,
    RollbackResigningStrategy,
    SettingType,
    UserGroup,
    UserGroupId,
    WorkflowType,
    AutomationBAAutoUpdatePRWithArtifactLink,
    AutoCherryPickMatchTokenOn,
    IncidentIoCreateIncidentsSettings,
    MicrosoftTeamsChannelLayoutType,
    MicrosoftTeamsChannelLayoutTypeDisplayNames,
    MicrosoftTeamsChannelMembershipType,
    MicrosoftTeamsChannelMembershipTypeDisplayNames,
    PagerDutyCreateIncidentsSettings,
    RunwayPRAssignee,
} from '../../types';
import Icon, {
    ClockCircleOutlined,
    CopyOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import Divider from 'antd/lib/divider';
import TimePicker from 'antd/lib/time-picker';
import { Link, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { useGetIssueTrackingLabelsQuery } from '@/middlewares/defaultApi';
import { UpdateAutomationSettingsRequest } from '../../actions/appSettings';
import {
    automationConditionsForAutomationType,
    availableAutoTransitionTicketsStatusesForIntegration,
    capitalizeFirstLetter,
    cherryPickPatternValidator,
    decodeAutoStagedRolloutBlackoutSegmentsByDay,
    displayNameForCapability,
    displayTextForCapability,
    docsLinkForAutomationType,
    encodeAutoStagedRolloutBlackoutSegmentsByDay,
    getIsAppleAppStore,
    getIsApplePlatform,
    hasSupportForAutoRelease,
    hasSupportForPhasedRelease,
    isAppPlatform,
    isBucketAutomation,
    isGoogleBetaIntegration,
    isGooglePlatform,
    isIosPlatform,
    sanitizeTrackName,
    syncableProvisioningProfileTypesForPlatform,
    unitForMonitoringMetric,
    validatePattern,
    metricBelongsToStepInstallations,
} from '../../helpers';
import {
    availableAndroidAutoRolloutStartStrategiesForStoreType,
    displayConsoleNameForAppStoreType,
    displayTextForAndroidAutoRolloutStartStrategy,
    displayTextForAppStoreUploadRule,
    displayTextForAutoApplyBuildNotesStrategy,
    displayTextForAutoBackmergeStrategy,
    displayTextForAutoCherryPickStrategy,
    displayTextForAutomationConditionType,
    displayTextForAutoReleaseStrategy,
    displayTextForAutoSubmitStrategy,
    displayTextForBumpVersionStrategy,
    displayTextForDayOfTheWeek,
    displayTextForMonitoringMetric,
    fullDisplayTextForMonitoringMetric,
    displayTextForPullRequestType,
    displayTextForProvisioningProfileTypeWithPlatform,
    displayTextForReleaseNotesDataSource,
    displayTextForPromoTextDataSource,
    displayTextForResigningStrategy,
    displayTextForSyncTranslationsExportStrategy,
    displayTextForUserChecklistGroup,
    displayTextForUserGroup,
    helperTextForAutoSubmitStrategy,
    helpTextForAutoCherryPickStrategy,
    iconForCapability,
    identifierForAppPlatform,
    placeholderForFileTypePlatform,
    ROLE_TITLE_BY_ASCROLE,
    ROLE_TITLE_BY_GPLAY_PERMISSION,
    warningTextForAutoSubmitStrategy,
    displayTextForReleaseTypeGroup,
    LIFECYCLE_AUTOMATION_TIMING_MESSAGE,
    phasedReleaseDisplayTextForAppStoreType,
} from '../../helpers/displayHelpers';
import {
    emailValidationRules,
    FieldType,
    filterOptionLabel,
    FormFieldData,
    renderFormField,
    renderFormFields,
    validateFileNameForAppStoreType,
} from '../../helpers/formHelpers';
import { RootState } from '../../reducers/reducers';
import {
    selectAllAppIdentifiers,
    selectAppIntegrations,
    selectAppHasRequiredCapabilitiesAndIntegrationsForAutomation,
    selectAppPlatform,
    selectAppStoreArtifactWorkflowUploadDestinationOptions,
    selectAppStoreType,
    selectConnectedCapabilitiesForApp,
    selectDefaultReviewAttachmentFromAutomation,
    selectFirstAutomationOfType,
    selectIntegrationWithCapabilityFromInstallations,
    selectIsPlayReleaseLifecycleEnabled,
    selectOrgGroups,
    selectProviderForIntegration,
    selectRegressionTestingIntegration,
    selectStabilityIntegrations,
    selectRequiresFixRequestsApprovals,
    selectVCSSupportsPRComments,
    selectShouldDisableAutomation,
    selectStepConfigDataFromStepGraphs,
    selectStepConfigsByType,
    selectWorkflowEnabledSteps,
    selectDestinationInfoByDestinationStepConfigId,
} from '../../selectors/selectors';
import {
    AppComponentProps,
    AppRouteComponentMatchParams,
    AppStoreArtifactUploadDestinationTypeOption,
    AppStoreArtifactUploadWorkflowOption,
    DsymsUploadWorkflowOption,
    InputFieldDataWithValidation,
    MonitoringConditionOption,
    Nullable,
} from '../../typescriptHelpers';
import Radio from 'antd/lib/radio';
import { globalMessage } from '../../utils/globalMessage';
import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import InputNumber from 'antd/lib/input-number';
import Popover from 'antd/lib/popover';
import Select from 'antd/lib/select';
import Typography from 'antd/lib/typography';
import { antGrey, colorWithAlpha, runwayColors, rwColors, titleStyle } from '../styles/globalStyles';
import { createAppSettingsRouteWithSettingType } from '../../helpers/routeHelpers';
import { iconAndAltForIntegrationType } from '../../helpers/integrationHelpers';
import { cloneDeep, isNil, sortBy } from 'lodash';
import { PlanRestrictedFeatureWrapper } from '../planRestrictions/PlanRestrictedFeatureWrapper';
import { AutomationPlanExecutionBlockedAlert } from '../planRestrictions/planRestrictionHelperComponents';
import { PatternTokenHelperTextComponent } from '../appSettings/PatternTokenHelperTextComponent';
import Tooltip from 'antd/lib/tooltip';
import { DEFAULT_ROLLOUT_SEQUENCE } from '../../constants';
import {
    DEFAULT_MAX_DATA_AGE_MINUTES,
    isCustomObaaMetric,
    MAX_DATA_AGE_MINUTES_LIMIT,
    metricMaxDataAgeMinutesFromFormValue,
    validatePositiveMaxDataAgeMinutes,
} from './healthMetricStaleness';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import ConfigProvider from 'antd/lib/config-provider';
import Tabs from 'antd/lib/tabs';
import { BetaBadge, UpdatedBadge } from './AppAutomationSettings';
import VCSDirectPushCheck from './VCSDirectPushCheck';
import { VCSDirectPushBranchTarget } from '../../types/automation';
import PermissionedActionButton from '../HOCs/PermissionedActionButton';
import { RunwayUserAction } from '../../helpers/aclHelpers';
import AutomationConfigurationHelpBanner from './AutomationConfigurationHelpBanner';
import { CreateRunwayReleasesDestinationSelector } from './CreateRunwayReleasesDestinationSelector';
import { dayjs } from '@/extendedDayjs';
import PropTypes from 'prop-types';
import { AndroidStagedRolloutPercentageInput } from '../sharedComponents/shared';
import { ExtendedThresholdDescription, NUMERIC_BADGE_INDENT } from '../appSettings/MonitoringMetricFormFields';
import { mapThresholdToFormValue } from '@/components/appSettings/AddEditMonitoringMetricModal';
import DefaultReviewAttachmentUpload from '@/components/automations/DefaultReviewAttachmentUpload';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Switch from 'antd/lib/switch';
import { selectAppOrgUsers } from '@/selectors/memoizedSelectors';
import { useAppSettings } from '@/utils/hooks/helpers';
import { StepConfigSelector } from '@/components/common/StepConfigSelector';
import { getAutoSelectLatestBuildStrategyFieldData } from './automationHelperComponents';
import { StepGraphStep } from '@/types/workflow';
import { allReleaseMilestones, ReleaseMilestone, releaseMilestoneLabels } from '@/types/automation';
import { AutomationGenerateCIBuildDiffSummary } from '@/types/ciBuildDiffSummary';
import { RelativeTimeTriggerSettings } from '../RelativeTimeTriggerSettings';
import { CompletedStepsTriggerSettings } from '../CompletedStepsTriggerSettings';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';
import { MonitoringMetricDescriptionIcon, renamedMetricTooltip } from '../monitoring/monitoringHelpers';
import {
    AutomationSettingsContext,
    renderReleaseTypesForAutomation,
    isAppLevelAutomationConfig,
} from '@/helpers/automationHelpers';
import { AutoCreateTestRuns } from './AutoCreateTestRuns/AutoCreateTestRunsSettings';
import { BlockingStepsSelector } from '../BlockingStepsSelector';
import { Flex } from 'antd/lib';
import FormItem from 'antd/lib/form/FormItem';
import { Destination } from '@/types/destinations';
import { TriggerCIWorkflowConditionGroups } from './TriggerCIWorkflowConditionGroups';

// Backend error message for missing default release settings
// Defined in: lib/runway/api_automation.go - appHasDefaultReleaseSettingsConfigured() and stepConfigHasDefaultReleaseSettingsConfigured()
const DEFAULT_RELEASE_SETTINGS_ERROR_MESSAGE = 'This automation requires default release settings be configured.';

const TRIGGER_CONDITION_GROUPS_FIELD_KEY = 'triggerConditionGroupsField';

const namespaceFormFields = (fields: FormFieldData[], namespace: string): FormFieldData[] => {
    return fields.map((field) => {
        const namespacedField = { ...field };
        if (field.name) {
            const nameParts = Array.isArray(field.name) ? field.name : [field.name];
            namespacedField.name = [namespace, ...nameParts] as any;
        }
        if (field.fieldType === FieldType.WrappedGroup && field.groupedFields) {
            namespacedField.groupedFields = namespaceFormFields(field.groupedFields, namespace);
        }
        if (field.data?.formListName) {
            const formListName =
                Array.isArray(field.data.formListName) ? field.data.formListName : [field.data.formListName];
            namespacedField.data = {
                ...field.data,
                formListName: [namespace, ...formListName],
            };
        }
        if (field.dependencies) {
            namespacedField.dependencies = (field.dependencies as string[]).map((dep) => [namespace, dep] as any);
        }

        // Passing the namespace to custom fields so they can access the right values
        if (field.fieldType === FieldType.Custom && field.renderField) {
            const renderField = field.renderField;
            namespacedField.renderField = (data: unknown, ...extraData: unknown[]) =>
                renderField(data, ...extraData, namespace);
        }

        return namespacedField;
    });
};

const ALL_RELEASE_TYPE_GROUPS: ReleaseTypesForNonBlockingSteps[] = [
    ReleaseTypesForNonBlockingSteps.Standard,
    ReleaseTypesForNonBlockingSteps.Hotfix,
    ReleaseTypesForNonBlockingSteps.Rollback,
];

interface ReleaseTypeTab {
    id: string;
    releaseTypes: ReleaseTypesForNonBlockingSteps[];
    initialEnabled?: boolean;
    // True for the tab that holds the automation's default settings (the ones used by any
    // release type without its own override). Saved as top-level enabled/data, not under
    // configPerReleaseType. Exists only when at least one release type has no override.
    isPrimary?: boolean;
}

function trimCustomRequiredStepsForReleaseTypes(
    automationType: AutomationType,
    data: AutomationTypesWithSettings['data'] | undefined,
    releaseTypes: ReleaseTypesForNonBlockingSteps[],
): AutomationTypesWithSettings['data'] | undefined {
    if (!data) {
        return data;
    }

    if (automationType === AutomationType.AutoSubmitRelease) {
        const autoSubmitData = data as AutomationAutoSubmitRelease['data'];
        if (!autoSubmitData.shouldUseCustomRequiredSteps || !autoSubmitData.customRequiredSteps) {
            return data;
        }

        const customRequiredSteps = releaseTypes.reduce(
            (acc, releaseType) => {
                if (releaseType in autoSubmitData.customRequiredSteps) {
                    acc[releaseType] = autoSubmitData.customRequiredSteps[releaseType];
                }
                return acc;
            },
            {} as Partial<Record<ReleaseTypesForNonBlockingSteps, ReleaseStepType[]>>,
        );

        return {
            ...autoSubmitData,
            customRequiredSteps: customRequiredSteps as AutomationAutoSubmitRelease['data']['customRequiredSteps'],
        };
    }

    if (automationType === AutomationType.AutoRelease) {
        const autoReleaseData = data as AutomationAutoRelease['data'];
        if (!autoReleaseData.shouldUseCustomRequiredSteps || !autoReleaseData.customRequiredSteps) {
            return data;
        }

        const customRequiredSteps = releaseTypes.reduce(
            (acc, releaseType) => {
                if (releaseType in autoReleaseData.customRequiredSteps) {
                    acc[releaseType] = autoReleaseData.customRequiredSteps[releaseType];
                }
                return acc;
            },
            {} as Partial<Record<ReleaseTypesForNonBlockingSteps, ReleaseStepType[]>>,
        );

        return {
            ...autoReleaseData,
            customRequiredSteps: customRequiredSteps as AutomationAutoRelease['data']['customRequiredSteps'],
        };
    }

    return data;
}

const PRIMARY_REQUIRED_STEPS_FIELD_KEYS = new Set([
    'primaryRequiredStepsToggleField',
    'primaryRequiredStepsConfigField',
]);

const CHERRY_PICK_TOKEN_GROUP_FIELD_KEY = 'cherryPickTokenGroupField';

// Release type override tabs rebuild these fields with their own namespaced names, so the
// copies inherited from the primary fields have to be dropped or they render twice.
const PRIMARY_CHERRY_PICK_TOKEN_FIELD_KEYS = new Set(['allowFixesWithToken', CHERRY_PICK_TOKEN_GROUP_FIELD_KEY]);

interface AutomationSettingsProps extends AppComponentProps {
    open: boolean;
    automation: Automation;
    onClose: () => void;
    onAfterClose: () => void;
    isLoading: boolean;
    sameTypeAutomations: Automation[];
    onSubmit: (request: UpdateAutomationSettingsRequest) => void;
    onAutomationSelected: Nullable<(automationId: string) => void>;
    context?: AutomationSettingsContext;
}

type ArtifactUploadOptions = {
    appIdentifiers: Map<IntegrationInstallationId, AppIdentifierForIntegration>;
    destinationOptions: AppStoreArtifactUploadDestinationTypeOption[];
    buildSystem?: Integration;
};

type DsymsUploadOptions = {
    buildSystem?: Integration;
    /** Deprecated legacy field — kept for the empty-state path. The destination options on the
     *  automation entity (`automation.dsymUploadDestinationOptions`) are what drive the per-row
     *  selector. */
    stabilityMonitoring?: Integration;
};

export const AutomationSettings: React.FC<AutomationSettingsProps> = (props: AutomationSettingsProps) => {
    const { orgIdParam, appIdParam } = useParams<AppRouteComponentMatchParams>();
    const [form] = Form.useForm();
    const releaseNotesSourceFormValue = Form.useWatch('releaseNotesSource', form);

    const sameTypeAutomations = props.sameTypeAutomations;
    const appPlatform = useSelector((state: RootState) => selectAppPlatform(state, props.appId));
    const stepGraphStepsMap = useSelector((state: RootState) => selectStepConfigDataFromStepGraphs(state, props.appId));

    // Selectors
    const appSettings = useAppSettings({ appId: props.appId, orgId: props.orgId });
    const appStoreType = useSelector((state: RootState) => selectAppStoreType(state, props.appId));
    const automation = props.automation;
    const appLevelAutomationConfig = isAppLevelAutomationConfig(automation.type);
    const automationForFormFields = React.useMemo<Automation>(() => {
        const standardOverride = automation.configPerReleaseType?.[ReleaseTypesForNonBlockingSteps.Standard];
        if (!appLevelAutomationConfig || !standardOverride) {
            return automation;
        }

        return {
            ...automation,
            enabled: standardOverride.enabled ?? automation.enabled,
            data: standardOverride.data ?? automation.data,
            relativeTimeTrigger: standardOverride.relativeTimeTrigger ?? automation.relativeTimeTrigger,
            completedStepsTrigger: standardOverride.completedStepsTrigger ?? automation.completedStepsTrigger,
        };
    }, [automation, appLevelAutomationConfig]);

    const shouldDisableAutomation = useSelector((state: RootState) => {
        return selectShouldDisableAutomation(state, props.orgId, automation.type);
    });

    const isPlayReleaseLifecycleEnabled = useSelector((state: RootState) =>
        selectIsPlayReleaseLifecycleEnabled(state, props.orgId),
    );

    const vcsIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.VersionControl,
            automation.integrationInstallationIds,
        ),
    );
    const appStoreIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.AppStore,
            automation.integrationInstallationIds,
        ),
    );
    const connectedCapabilities = useSelector((state: RootState) =>
        selectConnectedCapabilitiesForApp(state, props.appId),
    );
    const stabilityIntegrations = useSelector((state: RootState) => selectStabilityIntegrations(state, props.appId));
    const destinationOptions = useSelector((state: RootState) =>
        selectAppStoreArtifactWorkflowUploadDestinationOptions(state, props.appId, automation.id),
    );
    const buildSystem = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.BuildSystem,
            automation.integrationInstallationIds,
        ),
    );
    const connectedBuildSystemIntegrations = useSelector((state: RootState) =>
        selectAppIntegrations(state, props.appId).filter((integration) =>
            integration.capabilities.includes(IntegrationCapability.BuildSystem),
        ),
    );
    const triggerBuildAutomation = useSelector(
        (state: RootState) =>
            selectFirstAutomationOfType(state, props.appId, AutomationType.AutoTriggerCIWorkflow) ??
            selectFirstAutomationOfType(state, props.appId, AutomationType.AutoKickoffTriggerWorkflow),
    );
    const unsupportedBuildTriggerIntegration = connectedBuildSystemIntegrations.find((integration) =>
        (triggerBuildAutomation?.unsupportedIntegrations ?? []).includes(integration.id),
    );
    const rebuildByCIUnavailableReason =
        unsupportedBuildTriggerIntegration ?
            `${unsupportedBuildTriggerIntegration.name} does not support triggering builds from Runway.`
        :   null;
    const appIdentifiers = useSelector((state: RootState) => selectAllAppIdentifiers(state, props.appId));
    const stabilityMonitoring = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.StabilityMonitoring,
            automation.integrationInstallationIds,
        ),
    );

    const appUsers = useSelector((state: RootState) => selectAppOrgUsers(state, props.appId));
    const orgUserGroups = useSelector((state: RootState) => selectOrgGroups(state, props.orgId));

    const isBucketAutomationType = isBucketAutomation(automation.type);

    let [appHasRequiredServices, servicesErrorMessage] = useSelector(
        (state: RootState) =>
            selectAppHasRequiredCapabilitiesAndIntegrationsForAutomation(
                state,
                props.appId,
                automation.unsupportedIntegrations,
                automation.requiredCapabilities,
                automation.integrationInstallationIds,
                isBucketAutomationType,
            ),
        shallowEqual,
    );

    const betaTesting = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.BetaTesting,
            automation.integrationInstallationIds,
        ),
    );
    const betaTestingProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, props.orgId, betaTesting),
    );
    const notificationsIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.Notifications,
            automation.integrationInstallationIds,
        ),
    );
    const notificationsProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, props.orgId, notificationsIntegration),
    );

    const featureManagementIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.FeatureManagement,
            automation.integrationInstallationIds,
        ),
    );

    const schedulingIntegration = useSelector((state: RootState) =>
        selectIntegrationWithCapabilityFromInstallations(
            state,
            props.appId,
            IntegrationCapability.Scheduling,
            automation.integrationInstallationIds,
        ),
    );
    const schedulingProvider = useSelector((state: RootState) =>
        selectProviderForIntegration(state, props.orgId, schedulingIntegration),
    );

    const destinationInfoByStepConfigId = useSelector((state: RootState) =>
        selectDestinationInfoByDestinationStepConfigId(state, props.appId),
    );
    const allDestinations = React.useMemo(
        () => Object.values(destinationInfoByStepConfigId),
        [destinationInfoByStepConfigId],
    );

    // State
    const triggerWorkflowOptionInitialState =
        automation.type === AutomationType.BAAutoTriggerBuildSystemWorkflow ?
            (automation.data as AutoTriggerBuildDistroBuildData)?.timedTriggerEveryNHours !== null ?
                TriggerWorkflowOption.TriggerEveryNHours
            :   TriggerWorkflowOption.SmartMode
        :   null;

    // for BAAutoTriggerWorkflow
    const [triggerWorkflowOption, setTriggerWorkflowOption] = React.useState(triggerWorkflowOptionInitialState);

    // for AutoCherryPick
    const requiresFixRequestsApprovals = useSelector(selectRequiresFixRequestsApprovals(props.appId));
    const vcsSupportsPRComments = useSelector(selectVCSSupportsPRComments(props.appId, props.orgId));
    const cherryPickStrategyInitialState =
        automation.type === AutomationType.AutoCherryPickFromWorkingBranch ?
            (automation as AutomationCherryPickFromWorkingBranch).data?.strategy ||
            AutoCherryPickStrategy.SingleInSequence
        :   null;
    const [cherryPickStrategyState, setCherryPickStrategyState] = React.useState(cherryPickStrategyInitialState);
    const [cherryPickStrategyHelpMessage, setCherryPickStrategyHelpMessage] = React.useState(() =>
        helpTextForAutoCherryPickStrategy(cherryPickStrategyState),
    );

    const autoSubmitStragyInitialState =
        automation.type === AutomationType.AutoSubmitRelease ?
            ((automation as AutomationAutoSubmitRelease).data?.submitStrategy ?? AutoSubmitStrategy.OnceStepsComplete)
        :   AutoSubmitStrategy.OnceStepsComplete;
    const [autoSubmitStrategy, setAutoSubmitStrategy] = React.useState(autoSubmitStragyInitialState);

    const resigningStrategyInitialState =
        automation.type === AutomationType.AutoPrepareRollbackRelease ?
            ((automation as AutomationPrepareRollbackRelease).data?.strategy ?? RollbackResigningStrategy.LocalResign)
        :   RollbackResigningStrategy.LocalResign;
    const [resigningStrategy, setResigningStrategy] = React.useState(resigningStrategyInitialState);

    const workflowEnabledSteps = useSelector((state: RootState) => selectWorkflowEnabledSteps(state, props.appId));
    const isWorkflowsCIStepEnabled = !!workflowEnabledSteps[ReleaseStepType.ReleaseCandidate];
    const isWorkflowsSubmissionStepEnabled = !!workflowEnabledSteps[ReleaseStepType.Submission];
    const isWorkflowsTakeoffStepEnabled = !!workflowEnabledSteps[ReleaseStepType.Takeoff];
    const isWorkflowsRolloutStepEnabled = !!workflowEnabledSteps[ReleaseStepType.Rollout];

    const regressionTestStepConfigs = useSelector((state: RootState) =>
        selectStepConfigsByType(state, props.appId, ReleaseStepType.RegressionTesting),
    );
    const regressionTestStepConfigIds = Object.keys(regressionTestStepConfigs).map((configId) => configId);

    const selectedAutomation = sameTypeAutomations.find((auto) => auto.id === automation.id);
    const [selectedStepConfigId, setSelectedStepConfigId] = React.useState(selectedAutomation?.stepConfigId);

    React.useEffect(() => {
        setCherryPickStrategyHelpMessage(helpTextForAutoCherryPickStrategy(cherryPickStrategyState));
    }, [cherryPickStrategyState]);

    // for AutoSyncTranslations
    const syncTranslationsBeforeKickoffInitialState =
        automation.type === AutomationType.AutoSyncTranslations ?
            !!(automation as AutomationSyncTranslations).data?.daysBeforeKickoffForUpload
        :   false;
    const [autoSyncTranslationsBeforeKickoffEnabled, setAutoSyncTranslationsBeforeKickoffEnabled] = React.useState(
        syncTranslationsBeforeKickoffInitialState,
    );

    const syncTranslationsBeforeSubmissionInitialState =
        automation.type === AutomationType.AutoSyncTranslations ?
            !!(automation as AutomationSyncTranslations).data?.daysBeforeSubmissionForExport
        :   false;
    const [autoSyncTranslationsBeforeSubmissionEnabled, setAutoSyncTranslationsBeforeSubmissionEnabled] =
        React.useState(syncTranslationsBeforeSubmissionInitialState);

    // for AutoSyncMetadataTranslations
    const syncMetadataTranslationsBeforeSubmissionInitialState =
        automation.type === AutomationType.AutoSyncMetadataTranslations ?
            !!(automation as AutomationSyncMetadataTranslations).data?.daysBeforeSubmissionForExport
        :   false;
    const [
        autoSyncMetadataTranslationsBeforeSubmissionEnabled,
        setAutoSyncMetadataTranslationsBeforeSubmissionEnabled,
    ] = React.useState(syncMetadataTranslationsBeforeSubmissionInitialState);

    const [autoSelectLatestBuildStrategy, setAutoSelectLatestBuildStrategy] = React.useState(
        (automation as AutomationAutoSelectLatestBuild).data?.strategy ||
            AutoSelectLatestBuildStrategy.LatestAvailableBuild,
    );

    const [regressionStepsToConsider, setRegressionStepsToConsider] = React.useState(
        regressionTestStepConfigIds?.length === 1 ?
            regressionTestStepConfigIds
        :   (automation as AutomationAutoSelectLatestBuild).data?.regressionStepsToConsider,
    );

    const initializeTabs = React.useCallback(
        (configPerReleaseType: Automation['configPerReleaseType']): ReleaseTypeTab[] => {
            if (appLevelAutomationConfig) {
                const standardOverride = configPerReleaseType?.[ReleaseTypesForNonBlockingSteps.Standard];
                return [
                    {
                        id: 'tab-0',
                        releaseTypes: [ReleaseTypesForNonBlockingSteps.Standard],
                        initialEnabled: standardOverride?.enabled ?? automationForFormFields.enabled,
                    },
                ];
            }

            const overrideKeys = Object.keys(configPerReleaseType ?? {}) as ReleaseTypesForNonBlockingSteps[];
            const primaryTypes = ALL_RELEASE_TYPE_GROUPS.filter((t) => !overrideKeys.includes(t));
            if (overrideKeys.length === 0) {
                return [{ id: 'tab-0', releaseTypes: [...ALL_RELEASE_TYPE_GROUPS], isPrimary: true }];
            }
            // Group overrides with identical configs onto one tab, in canonical order.
            const canonicalIndex = (t: ReleaseTypesForNonBlockingSteps) => ALL_RELEASE_TYPE_GROUPS.indexOf(t);
            const orderedOverrideKeys = [...overrideKeys].sort((a, b) => canonicalIndex(a) - canonicalIndex(b));
            // Drop disabled trigger fields before fingerprinting so configs that differ only in
            // leftover disabled triggers still group together.
            const fingerprintConfig = (c: AutomationReleaseTypeOverride) => {
                return JSON.stringify({
                    enabled: c.enabled,
                    data: c.data,
                    relativeTimeTrigger: c.relativeTimeTrigger?.enabled ? c.relativeTimeTrigger : undefined,
                    completedStepsTrigger: c.completedStepsTrigger?.enabled ? c.completedStepsTrigger : undefined,
                });
            };
            const groups = new Map<string, ReleaseTypesForNonBlockingSteps[]>();
            for (const key of orderedOverrideKeys) {
                const fingerprint = fingerprintConfig(configPerReleaseType![key]);
                if (!groups.has(fingerprint)) {
                    groups.set(fingerprint, []);
                }
                groups.get(fingerprint)!.push(key);
            }
            const overrideGroups = Array.from(groups.values()).sort(
                (a, b) => canonicalIndex(a[0]) - canonicalIndex(b[0]),
            );
            const allTabs: ReleaseTypeTab[] = [];
            if (primaryTypes.length > 0) {
                allTabs.push({ id: 'tab-0', releaseTypes: primaryTypes, isPrimary: true });
            }
            for (const types of overrideGroups) {
                allTabs.push({ id: `tab-${allTabs.length}`, releaseTypes: types });
            }
            return allTabs;
        },
        [appLevelAutomationConfig, automationForFormFields.enabled],
    );

    const [tabs, setTabs] = React.useState<ReleaseTypeTab[]>(() => initializeTabs(automation.configPerReleaseType));
    const [activeTab, setActiveTab] = React.useState<string>('tab-0');
    const [nextTabId, setNextTabId] = React.useState(() => initializeTabs(automation.configPerReleaseType).length);
    // Save the config as text so the same values stay the same after an app settings refresh.
    const configPerReleaseTypeSnapshot = JSON.stringify(automation.configPerReleaseType ?? {});

    // Reset the tabs when the modal opens or the saved config changes.
    React.useEffect(() => {
        if (!props.open) return;

        const configPerReleaseType = JSON.parse(configPerReleaseTypeSnapshot) as Automation['configPerReleaseType'];
        const newTabs = initializeTabs(configPerReleaseType);
        setTabs(newTabs);
        setNextTabId(newTabs.length);
        setActiveTab((currentActiveTab) => {
            if (newTabs.some((tab) => tab.id === currentActiveTab)) {
                return currentActiveTab;
            }
            return newTabs[0]?.id ?? 'tab-0';
        });
    }, [automation.id, props.open, configPerReleaseTypeSnapshot, initializeTabs]);

    const getOverrideConfigForTab = (tab: ReleaseTypeTab) => {
        if (appLevelAutomationConfig) {
            return automation.configPerReleaseType?.[ReleaseTypesForNonBlockingSteps.Standard];
        }
        if (tab.releaseTypes.length === 0) return undefined;
        return automation.configPerReleaseType?.[tab.releaseTypes[0]];
    };

    const [tabTriggerState, setTabTriggerState] = React.useState<
        Record<string, { relativeTimeTrigger: boolean; completedStepsTrigger: boolean }>
    >(() => {
        const state: Record<string, { relativeTimeTrigger: boolean; completedStepsTrigger: boolean }> = {};
        const initialTabs = initializeTabs(automation.configPerReleaseType);
        for (const tab of initialTabs) {
            const cfg = getOverrideConfigForTab(tab);
            if (!cfg) continue;
            state[tab.id] = {
                relativeTimeTrigger: cfg?.relativeTimeTrigger?.enabled ?? false,
                completedStepsTrigger: cfg?.completedStepsTrigger?.enabled ?? false,
            };
        }
        return state;
    });

    const onSubmit = (form) => {
        if (shouldDisableAutomation) {
            return;
        }

        form.validateFields()
            .then((values) => {
                const data = automationUpdateRequestDataFromValues(
                    automationForFormFields as AutomationTypesWithSettings,
                    {
                        ...values,
                        regressionStepsToConsider,
                    },
                    appSettings.monitoringSettings.metrics,
                );

                if (!data) {
                    throw Error('Something went wrong, please try again');
                }

                if (appLevelAutomationConfig) {
                    const request: UpdateAutomationSettingsRequest = {
                        orgId: props.orgId,
                        appId: props.appId,
                        automationId: automation.id,
                        enabled: values.enabled,
                        data: data,
                        configPerReleaseType: undefined,
                        relativeTimeTrigger: values.relativeTimeTrigger,
                        completedStepsTrigger: values.completedStepsTrigger,
                        automationReleaseTypes: AutomationReleaseTypes.All,
                    };

                    props.onSubmit(request);
                    return;
                }

                let configPerReleaseType: UpdateAutomationSettingsRequest['configPerReleaseType'];
                // Skip the primary tab here — it's saved as the automation's main settings,
                // not as a per-release-type override.
                const tabsForSave = tabs
                    .map((tab, index) => ({ tab, index }))
                    .filter(({ tab }) => tab.releaseTypes.length > 0 && !tab.isPrimary);

                if (tabsForSave.length > 0) {
                    configPerReleaseType = {};
                    const groupedOverrides = new Map<
                        string,
                        {
                            releaseTypes: ReleaseTypesForNonBlockingSteps[];
                            config: {
                                enabled: boolean;
                                data?: AutomationTypesWithSettings['data'];
                                relativeTimeTrigger: any;
                                completedStepsTrigger: any;
                            };
                        }
                    >();

                    for (const { tab, index } of tabsForSave) {
                        // Tab values are namespaced for non-primary tabs; first tab can be top-level.
                        const tabValues = values[tab.id] ?? (index === 0 ? values : undefined);

                        let normalizedOverride:
                            | {
                                  enabled: boolean;
                                  data?: AutomationTypesWithSettings['data'];
                                  relativeTimeTrigger: any;
                                  completedStepsTrigger: any;
                              }
                            | undefined;

                        if (!tabValues) {
                            // Tab was never visited (antd lazy rendering) — preserve existing overrides unchanged
                            const existingOverride = tab.releaseTypes
                                .map((rt) => automation.configPerReleaseType?.[rt])
                                .find((override) => !!override);
                            if (!existingOverride) {
                                continue;
                            }
                            normalizedOverride = {
                                enabled: existingOverride.enabled,
                                data: trimCustomRequiredStepsForReleaseTypes(
                                    automation.type,
                                    existingOverride.data as AutomationTypesWithSettings['data'],
                                    tab.releaseTypes,
                                ),
                                relativeTimeTrigger: existingOverride.relativeTimeTrigger,
                                completedStepsTrigger: existingOverride.completedStepsTrigger,
                            };
                        } else {
                            const tabData = automationUpdateRequestDataFromValues(
                                automationForFormFields as AutomationTypesWithSettings,
                                {
                                    ...tabValues,
                                    regressionStepsToConsider,
                                },
                                appSettings.monitoringSettings.metrics,
                            );
                            if (!tabData) {
                                throw Error('Something went wrong, please try again');
                            }
                            normalizedOverride = {
                                enabled: tabValues.enabled,
                                data: trimCustomRequiredStepsForReleaseTypes(
                                    automation.type,
                                    tabData,
                                    tab.releaseTypes,
                                ),
                                relativeTimeTrigger: tabValues.relativeTimeTrigger,
                                completedStepsTrigger: tabValues.completedStepsTrigger,
                            };
                        }

                        const fingerprint = JSON.stringify(normalizedOverride);
                        const existingGroup = groupedOverrides.get(fingerprint);
                        if (existingGroup) {
                            existingGroup.releaseTypes = Array.from(
                                new Set([...existingGroup.releaseTypes, ...tab.releaseTypes]),
                            );
                            continue;
                        }

                        groupedOverrides.set(fingerprint, {
                            releaseTypes: [...tab.releaseTypes],
                            config: normalizedOverride,
                        });
                    }

                    for (const groupedOverride of groupedOverrides.values()) {
                        for (const rt of groupedOverride.releaseTypes) {
                            configPerReleaseType[rt] = groupedOverride.config;
                        }
                    }

                    if (Object.keys(configPerReleaseType).length === 0) {
                        configPerReleaseType = undefined;
                    }
                }

                // `values` reflects the first tab, which is the top-level config only when a
                // primary tab exists. With no primary tab, derive top-level state from the
                // overrides so it doesn't flip when tabs get re-sorted on the next render.
                const hasPrimaryTab = tabs[0]?.isPrimary === true;
                const anyOverrideEnabled = Object.values(configPerReleaseType ?? {}).some(
                    (override) => override.enabled,
                );

                const request: UpdateAutomationSettingsRequest = {
                    orgId: props.orgId,
                    appId: props.appId,
                    automationId: automation.id,
                    enabled: hasPrimaryTab ? values.enabled : anyOverrideEnabled,
                    data: data,
                    configPerReleaseType,
                    relativeTimeTrigger: hasPrimaryTab ? values.relativeTimeTrigger : automation.relativeTimeTrigger,
                    completedStepsTrigger:
                        hasPrimaryTab ? values.completedStepsTrigger : automation.completedStepsTrigger,
                    automationReleaseTypes: AutomationReleaseTypes.All,
                };

                props.onSubmit(request);
            })
            .catch((error) => {
                globalMessage.error(error.message);
            });
    };

    let artifactUploadOptions: ArtifactUploadOptions;
    if (
        automation.type == AutomationType.AutoUploadBinaryArtifactToAppStore ||
        automation.type == AutomationType.BAAutoUploadBinaryArtifactToAppStore
    ) {
        artifactUploadOptions = {
            appIdentifiers: appIdentifiers,
            destinationOptions: destinationOptions,
            buildSystem: buildSystem,
        };
    }

    let dsymsUploadOptions: DsymsUploadOptions;
    if (automation.type == AutomationType.AutoUploadDsymsToStabilityMonitoring) {
        dsymsUploadOptions = {
            buildSystem: buildSystem,
            stabilityMonitoring: stabilityMonitoring,
        };
    }

    const isGithubVCS = vcsIntegration?.id === IntegrationType.GitHubVCS;
    const shouldShowAutoKickoffDirectMergeOption = isGithubVCS && appSettings.usesStaticReleaseBranchForNonHotfixes;

    const regressionTesting = useSelector((state: RootState) => selectRegressionTestingIntegration(state, props.appId));

    servicesErrorMessage = servicesErrorMessage || automation.automationRequirementsErrorMessage;

    const appSettingsRoute = createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.General);
    const appStoreDefaultsRoute = createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.AppStore);

    const renderErrorMessage = (errorMessage: string) => {
        if (errorMessage === DEFAULT_RELEASE_SETTINGS_ERROR_MESSAGE) {
            return (
                <Text style={{ color: runwayColors.statusRed, marginTop: -16 }}>
                    This automation requires{' '}
                    <Link
                        to={appStoreDefaultsRoute}
                        style={{ color: runwayColors.primary, textDecoration: 'underline' }}
                    >
                        default release settings
                    </Link>{' '}
                    be configured.
                </Text>
            );
        }
        return <Text style={{ color: runwayColors.statusRed, marginTop: -16 }}>{errorMessage}</Text>;
    };

    const baseFieldHelpMessage = defaultHelpMessage(automation.type);

    // display required capabilities in a bulleted list if we are displaying both required and also A OR B capability requirements
    const capabilitiesShouldBeBulleted =
        automation.requiredCapabilities &&
        automation.requiredCapabilities.length > 1 &&
        automation.requiredCapabilities.some((capabilityArray) => capabilityArray.length > 1);

    const availableAutoTransitionTicketsStatuses = availableAutoTransitionTicketsStatusesForIntegration(
        featureManagementIntegration,
        props.orgId,
    );

    const isApplyLabelsToFixTicketsAutomation = automation.type === AutomationType.AutoApplyLabelsToFixTickets;
    const { data: issueTrackingLabelsResponse } = useGetIssueTrackingLabelsQuery(
        { orgId: props.orgId, appId: props.appId },
        { skip: !props.open || !isApplyLabelsToFixTicketsAutomation, refetchOnMountOrArgChange: false },
    );
    const availableIssueTrackingLabels = issueTrackingLabelsResponse?.data?.labels ?? [];

    // All CLI templates available to be selected
    const checklistItems = appSettings.stepChecklistItems;
    const monitoringChecklistItemTemplates = checklistItems.filter(
        (cli) =>
            cli.releaseStepType === ReleaseStepType.Rollout ||
            (cli.stepConfigId && cli.stepConfigId === selectedStepConfigId),
    );

    const automationPlatform = automation.platform || appPlatform;
    const automationAppStoreType = automation.appStoreType || appStoreType;

    // For scheduled automations
    const [isRelativeTimeTriggerEnabled, setIsRelativeTimeTriggerEnabled] = React.useState(
        automation.relativeTimeTrigger.enabled,
    );
    const [isCompletedStepsTriggerEnabled, setIsCompletedStepsTriggerEnabled] = React.useState(
        automation.completedStepsTrigger.enabled,
    );

    const triggerConditionFormFields = (): FormFieldData[] => {
        const hasAnySupportedTrigger =
            automation.hasSupportForRelativeTimeTrigger || automation.hasSupportForCompletedStepsTrigger;

        const automationData = automation?.data as AutoTriggerCIWorkflowData | undefined;
        const conditionGroupsUIEnabled =
            !!appSettings?.useTriggerCIWorkflowConditionGroups &&
            automation.type === AutomationType.AutoTriggerCIWorkflow;
        if (
            !hasAnySupportedTrigger ||
            !automation.stepConfigId ||
            (conditionGroupsUIEnabled && automationData?.conditionGroups?.length)
        ) {
            return [];
        }

        const fields: FormFieldData[] = [
            {
                label: (
                    <div>
                        <Divider style={{ marginTop: '10px', marginBottom: '10px', width: '664px' }} />
                    </div>
                ),
                fieldType: FieldType.Custom,
                name: 'automationTriggerConditions',
                renderField: () => (
                    <div
                        style={{
                            fontWeight: 600,
                            fontSize: 14,
                            marginBottom: 0,
                            marginTop: 0,
                            display: 'block',
                            color: runwayColors.black,
                        }}
                    >
                        Trigger conditions
                    </div>
                ),
                extraFormItemProps: { style: { marginBottom: 10 } },
            },
            ...(automation.hasSupportForRelativeTimeTrigger ?
                [
                    {
                        data: (
                            <div>
                                Eligible to run no earlier than...
                                <Tooltip title="Runway will trigger the automation at the specified target time.">
                                    <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                                </Tooltip>
                            </div>
                        ),
                        name: ['relativeTimeTrigger', 'enabled'],
                        initialValue: isRelativeTimeTriggerEnabled,
                        fieldType: FieldType.Checkbox,
                        onChange: (e) => {
                            setIsRelativeTimeTriggerEnabled(e.target.checked);
                        },
                        extraFormItemProps: {
                            style: { marginBottom: 10 },
                        },
                    },
                ]
            :   []),
        ];

        if (automation.hasSupportForRelativeTimeTrigger && isRelativeTimeTriggerEnabled) {
            fields.push({
                label: '',
                name: 'relativeTimeTrigger',
                fieldType: FieldType.Custom,
                rules: [],
                renderField: () => (
                    <RelativeTimeTriggerSettings
                        orgId={props.orgId}
                        appId={props.appId}
                        stepConfigId={automation.stepConfigId}
                        initialValues={automation.relativeTimeTrigger}
                        isOrgLevelItem={false}
                        showAllowTriggeringBasedOnTargetDate
                    />
                ),
                extraFormItemProps: {
                    style: { marginBottom: 10 },
                },
            });
        }

        if (automation.hasSupportForCompletedStepsTrigger) {
            fields.push({
                label: '',
                data: (
                    <div>
                        Require previous release steps to be complete (green)
                        <Tooltip
                            title={
                                <span>
                                    Only blocking steps can be included as trigger conditions. Go to{' '}
                                    <Link to={appSettingsRoute} style={{ color: 'white', textDecoration: 'underline' }}>
                                        App settings
                                    </Link>{' '}
                                    to configure blocking and non-blocking steps.
                                </span>
                            }
                        >
                            <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                        </Tooltip>
                    </div>
                ),
                name: ['completedStepsTrigger', 'enabled'],
                initialValue: isCompletedStepsTriggerEnabled,
                fieldType: FieldType.Checkbox,
                onChange: (e) => {
                    setIsCompletedStepsTriggerEnabled(e.target.checked);
                },
                extraFormItemProps: {
                    style: { marginBottom: 10 },
                },
            });
        }

        if (automation.hasSupportForCompletedStepsTrigger && isCompletedStepsTriggerEnabled) {
            fields.push({
                label: '',
                name: 'completedStepsTrigger',
                fieldType: FieldType.Custom,
                initialValue: automation.completedStepsTrigger,
                rules: [],
                renderField: () => (
                    <CompletedStepsTriggerSettings
                        orgId={props.orgId}
                        appId={props.appId}
                        platform={automationPlatform}
                        appStoreType={automationAppStoreType}
                        stepGraphStepsMap={stepGraphStepsMap}
                    />
                ),
                extraFormItemProps: {
                    style: { marginBottom: 0 },
                },
            });
        }

        return fields;
    };

    const monitoringMetricsForAutomationStep = appSettings.monitoringSettings.metrics.filter((metric) =>
        metricBelongsToStepInstallations(
            metric,
            stepGraphStepsMap[automation.stepConfigId]?.integrationInstallationIds,
        ),
    );

    var formFields = automationSettingFormFieldsForAutomation(
        props.appId,
        props.orgId,
        orgIdParam,
        appIdParam,
        automationForFormFields,
        automationPlatform,
        automationAppStoreType,
        appHasRequiredServices,
        shouldDisableAutomation,
        connectedCapabilities,
        shouldShowAutoKickoffDirectMergeOption,
        isGithubVCS,
        baseFieldHelpMessage,
        requiresFixRequestsApprovals,
        vcsSupportsPRComments,
        monitoringMetricsForAutomationStep,
        artifactUploadOptions,
        dsymsUploadOptions,
        notificationsProvider,
        regressionTesting,
        availableAutoTransitionTicketsStatuses,
        triggerWorkflowOption,
        setTriggerWorkflowOption,
        betaTesting,
        betaTestingProvider,
        cherryPickStrategyState,
        cherryPickStrategyHelpMessage,
        setCherryPickStrategyState,
        autoSyncTranslationsBeforeKickoffEnabled,
        autoSyncTranslationsBeforeSubmissionEnabled,
        setAutoSyncTranslationsBeforeKickoffEnabled,
        setAutoSyncTranslationsBeforeSubmissionEnabled,
        autoSyncMetadataTranslationsBeforeSubmissionEnabled,
        setAutoSyncMetadataTranslationsBeforeSubmissionEnabled,
        monitoringChecklistItemTemplates,
        orgUserGroups,
        appUsers,
        autoSubmitStrategy,
        setAutoSubmitStrategy,
        resigningStrategy,
        setResigningStrategy,
        regressionTestStepConfigs,
        regressionTestStepConfigIds,
        regressionStepsToConsider,
        setRegressionStepsToConsider,
        autoSelectLatestBuildStrategy,
        setAutoSelectLatestBuildStrategy,
        rebuildByCIUnavailableReason,
        featureManagementIntegration,
        !!isWorkflowsRolloutStepEnabled,
        schedulingIntegration,
        schedulingProvider,
        form,
        isPlayReleaseLifecycleEnabled,
        stabilityIntegrations,
        allDestinations,
        !!appStoreIntegration,
        availableIssueTrackingLabels,
        appSettings?.useTriggerCIWorkflowConditionGroups,
        stepGraphStepsMap,
    );

    formFields = [...formFields, ...triggerConditionFormFields()];
    const primaryFormFields = formFields.filter((f) => f.name !== 'automationReleaseTypes');

    const formInitialValues: Record<string, any> = {};
    primaryFormFields.forEach((field) => {
        if (field.fieldType === FieldType.WrappedGroup) {
            field.groupedFields?.forEach((gf) => {
                formInitialValues[gf.name as string] = gf.initialValue ?? null;
            });
        } else if (field.name) {
            formInitialValues[field.name as string] = field.initialValue ?? null;
        }
    });

    const triggerFieldNames = new Set(['automationTriggerConditions', 'relativeTimeTrigger', 'completedStepsTrigger']);
    const isTriggerField = (name: FormFieldData['name']): boolean => {
        if (!name) return false;
        const rootName = Array.isArray(name) ? name[0] : name;
        return triggerFieldNames.has(rootName as string);
    };

    const automationSpecificFields = primaryFormFields.filter(
        (f) =>
            f.name !== 'enabled' &&
            !isTriggerField(f.name) &&
            !PRIMARY_REQUIRED_STEPS_FIELD_KEYS.has(f.name as string) &&
            !PRIMARY_CHERRY_PICK_TOKEN_FIELD_KEYS.has(f.name as string),
    );
    const primaryHasTriggerFields = primaryFormFields.some((f) => isTriggerField(f.name));

    const buildOverrideFieldsForTab = (tab: ReleaseTypeTab, namespace?: string): FormFieldData[] => {
        const overrideCfg = getOverrideConfigForTab(tab);
        const dataObj = (overrideCfg?.data ?? automationForFormFields.data ?? {}) as Record<string, any>;

        const withOverrideInitialValue = (field: FormFieldData): FormFieldData => {
            if (field.fieldType === FieldType.WrappedGroup && field.groupedFields) {
                return { ...field, groupedFields: field.groupedFields.map(withOverrideInitialValue) };
            }

            if (field.name === TRIGGER_CONDITION_GROUPS_FIELD_KEY) {
                return {
                    ...field,
                    data: { ...(field.data as object), initialValue: dataObj.conditionGroups ?? [] },
                };
            }

            if (!field.name || Array.isArray(field.name)) return field;
            const val = dataObj[field.name as string];
            if (val === null || val === undefined || val === '') return field;

            // autoStagedRolloutCustomHour is persisted as a number (the hour) but
            // the form's TimePicker requires a Dayjs object.
            if (field.name === 'autoStagedRolloutCustomHour' && typeof val === 'number') {
                const tz = (dataObj.autoStagedRolloutBlackoutTimezone as string)?.trim() || dayjs.tz.guess();
                return {
                    ...field,
                    initialValue: dayjs()
                        .tz(tz)
                        .set('hour', val)
                        .set('minute', 0)
                        .set('second', 0)
                        .set('millisecond', 0),
                };
            }

            if (field.name === 'autoStagedRolloutBlackoutSegmentsByDay') {
                return {
                    ...field,
                    initialValue: decodeAutoStagedRolloutBlackoutSegmentsByDay(
                        val as AutoStagedRolloutBlackoutSegmentsByDay,
                    ),
                };
            }

            return { ...field, initialValue: val };
        };

        const rawSpecificFields: FormFieldData[] = automationSpecificFields.map(withOverrideInitialValue);
        const specificFields = namespace ? namespaceFormFields(rawSpecificFields, namespace) : rawSpecificFields;
        const enabledFieldName = namespace ? [namespace, 'enabled'] : 'enabled';
        const relativeTimeTriggerEnabledFieldName =
            namespace ? [namespace, 'relativeTimeTrigger', 'enabled'] : ['relativeTimeTrigger', 'enabled'];
        const relativeTimeTriggerFieldName = namespace ? [namespace, 'relativeTimeTrigger'] : 'relativeTimeTrigger';
        const completedStepsTriggerEnabledFieldName =
            namespace ? [namespace, 'completedStepsTrigger', 'enabled'] : ['completedStepsTrigger', 'enabled'];
        const completedStepsTriggerFieldName =
            namespace ? [namespace, 'completedStepsTrigger'] : 'completedStepsTrigger';
        const selectedReleaseTypesFieldName = namespace ? [namespace, 'selectedReleaseTypes'] : 'selectedReleaseTypes';

        const fields: FormFieldData[] = [
            {
                name: namespace ? `${namespace}SelectedReleaseTypesField` : 'selectedReleaseTypesField',
                fieldType: FieldType.Custom,
                skipFormItemWrapper: true,
                renderField: () => (
                    <FormItem hidden name={selectedReleaseTypesFieldName} initialValue={tab.releaseTypes}>
                        <Input />
                    </FormItem>
                ),
            },
            {
                label: 'Enabled',
                name: enabledFieldName,
                initialValue: tab.initialEnabled !== undefined ? tab.initialEnabled : (overrideCfg?.enabled ?? true),
                fieldType: FieldType.Switch,
            },
            ...specificFields,
        ];

        if (primaryHasTriggerFields) {
            const trigState = tabTriggerState[tab.id] ?? { relativeTimeTrigger: false, completedStepsTrigger: false };

            fields.push(
                {
                    label: '',
                    fieldType: FieldType.Custom,
                    name: 'overrideTriggerConditionsHeader',
                    renderField: () => (
                        <div
                            style={{
                                fontWeight: 600,
                                fontSize: 14,
                                marginBottom: 0,
                                marginTop: 0,
                                display: 'block',
                                color: runwayColors.black,
                            }}
                        >
                            Trigger conditions
                        </div>
                    ),
                    extraFormItemProps: { style: { marginBottom: 10 } },
                },
                {
                    data: (
                        <div>
                            Eligible to run no earlier than...
                            <Tooltip title="Runway will trigger the automation at the specified target time.">
                                <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                            </Tooltip>
                        </div>
                    ),
                    name: relativeTimeTriggerEnabledFieldName,
                    initialValue: trigState.relativeTimeTrigger,
                    fieldType: FieldType.Checkbox,
                    onChange: (e) =>
                        setTabTriggerState((prev) => ({
                            ...prev,
                            [tab.id]: {
                                ...(prev[tab.id] ?? { relativeTimeTrigger: false, completedStepsTrigger: false }),
                                relativeTimeTrigger: e.target.checked,
                            },
                        })),
                    extraFormItemProps: { style: { marginBottom: 10 } },
                },
            );

            if (trigState.relativeTimeTrigger) {
                fields.push({
                    label: '',
                    name: relativeTimeTriggerFieldName,
                    fieldType: FieldType.Custom,
                    rules: [],
                    renderField: () => (
                        <RelativeTimeTriggerSettings
                            orgId={props.orgId}
                            appId={props.appId}
                            stepConfigId={automation.stepConfigId}
                            initialValues={overrideCfg?.relativeTimeTrigger ?? automation.relativeTimeTrigger}
                            isOrgLevelItem={false}
                            showAllowTriggeringBasedOnTargetDate
                        />
                    ),
                    extraFormItemProps: { style: { marginBottom: 10 } },
                });
            }

            fields.push({
                label: '',
                data: (
                    <div>
                        Require previous release steps to be complete (green)
                        <Tooltip
                            title={
                                <span>
                                    Only blocking steps can be included as trigger conditions. Go to{' '}
                                    <Link to={appSettingsRoute} style={{ color: 'white', textDecoration: 'underline' }}>
                                        App settings
                                    </Link>{' '}
                                    to configure blocking and non-blocking steps.
                                </span>
                            }
                        >
                            <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                        </Tooltip>
                    </div>
                ),
                name: completedStepsTriggerEnabledFieldName,
                initialValue: trigState.completedStepsTrigger,
                fieldType: FieldType.Checkbox,
                onChange: (e) =>
                    setTabTriggerState((prev) => ({
                        ...prev,
                        [tab.id]: {
                            ...(prev[tab.id] ?? { relativeTimeTrigger: false, completedStepsTrigger: false }),
                            completedStepsTrigger: e.target.checked,
                        },
                    })),
                extraFormItemProps: { style: { marginBottom: 10 } },
            });

            if (trigState.completedStepsTrigger) {
                fields.push({
                    label: '',
                    name: completedStepsTriggerFieldName,
                    fieldType: FieldType.Custom,
                    initialValue: overrideCfg?.completedStepsTrigger ?? automation.completedStepsTrigger,
                    rules: [],
                    renderField: () => (
                        <CompletedStepsTriggerSettings
                            orgId={props.orgId}
                            appId={props.appId}
                            platform={automationPlatform}
                            appStoreType={automationAppStoreType}
                            stepGraphStepsMap={stepGraphStepsMap}
                        />
                    ),
                    extraFormItemProps: { style: { marginBottom: 0 } },
                });
            }
        }

        const overrideData = overrideCfg?.data as
            | (AutomationAutoSubmitRelease['data'] & AutomationAutoRelease['data'])
            | undefined;

        if (automation.type === AutomationType.AutoSubmitRelease) {
            fields.push(
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    automation as AutomationAutoSubmitRelease,
                    props.appId,
                    automationPlatform,
                    automationAppStoreType,
                    {
                        fieldKeyPrefix: namespace ? `${namespace}OverrideRequiredSteps` : 'overrideRequiredSteps',
                        submitStrategyFieldName: namespace ? [namespace, 'submitStrategy'] : 'submitStrategy',
                        shouldUseCustomRequiredStepsFieldName:
                            namespace ? [namespace, 'shouldUseCustomRequiredSteps'] : 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix:
                            namespace ? [namespace, 'customRequiredSteps'] : ['customRequiredSteps'],
                        releaseTypesFieldName: selectedReleaseTypesFieldName,
                        shouldUseCustomRequiredStepsInitialValue: overrideData?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: overrideData?.customRequiredSteps,
                    },
                ),
            );
        }

        if (automation.type === AutomationType.AutoRelease) {
            fields.push(
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    automation as AutomationAutoRelease,
                    props.appId,
                    automationPlatform,
                    automationAppStoreType,
                    {
                        fieldKeyPrefix: namespace ? `${namespace}OverrideRequiredSteps` : 'overrideRequiredSteps',
                        submitStrategyFieldName: namespace ? [namespace, 'strategy'] : 'strategy',
                        shouldUseCustomRequiredStepsFieldName:
                            namespace ? [namespace, 'shouldUseCustomRequiredSteps'] : 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix:
                            namespace ? [namespace, 'customRequiredSteps'] : ['customRequiredSteps'],
                        releaseTypesFieldName: selectedReleaseTypesFieldName,
                        shouldUseCustomRequiredStepsInitialValue: overrideData?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: overrideData?.customRequiredSteps,
                    },
                ),
            );
        }

        if (automation.type === AutomationType.AutoCherryPickFromWorkingBranch) {
            const cherryPickAutomation = automation as AutomationCherryPickFromWorkingBranch;
            const cherryPickData =
                (overrideCfg?.data as AutomationCherryPickFromWorkingBranch['data'] | undefined) ??
                cherryPickAutomation.data;
            const allowFixesWithTokenFieldName = namespace ? [namespace, 'allowFixesWithToken'] : 'allowFixesWithToken';
            const tokensFieldName = namespace ? [namespace, 'tokens'] : 'tokens';
            const matchTokenOnFieldName = namespace ? [namespace, 'matchTokenOn'] : 'matchTokenOn';

            fields.push(
                ...buildAutoCherryPickTokenFields(
                    allowFixesWithTokenFieldName,
                    tokensFieldName,
                    matchTokenOnFieldName,
                    cherryPickData,
                    form,
                ),
            );
        }

        return fields;
    };

    // When all types have overrides, the first tab is an override tab rendered without namespacing
    // (its values map to the top-level request fields on submit)
    const hasPrimaryTab = tabs[0]?.isPrimary === true;
    const firstTabOverrideFields = !hasPrimaryTab && tabs.length > 0 ? buildOverrideFieldsForTab(tabs[0]) : [];

    const overrideTabData = tabs.slice(1).map((tab) => {
        return { tab, namespacedFields: buildOverrideFieldsForTab(tab, tab.id) };
    });

    const allInitialValues = { ...formInitialValues };

    // When every release type has an override (no primary tab), the first tab reuses the form's
    // top-level fields. Seed those fields with the first tab's override values, otherwise the
    // tab would show the automation's old default settings instead of its own.
    if (!hasPrimaryTab && firstTabOverrideFields.length > 0) {
        for (const field of firstTabOverrideFields) {
            if (field.fieldType === FieldType.WrappedGroup) {
                field.groupedFields?.forEach((gf) => {
                    if (gf.name && !Array.isArray(gf.name)) {
                        allInitialValues[gf.name as string] = gf.initialValue ?? null;
                    }
                });
            } else if (field.name && !Array.isArray(field.name)) {
                allInitialValues[field.name as string] = field.initialValue ?? null;
            }
        }
    }

    const filterAccelerateFieldByReleaseTypes = (
        fields: FormFieldData[],
        releaseTypes: ReleaseTypesForNonBlockingSteps[],
    ): FormFieldData[] => {
        if (releaseTypes.includes(ReleaseTypesForNonBlockingSteps.Standard)) return fields;
        const isPreviousReleaseRolloutField = (field: FormFieldData) =>
            [acceleratePreviousReleaseFieldName, waitForPreviousRolloutFieldName].includes(
                lastFieldNamePart(field.name),
            );
        return fields.map((f) => {
            if (f.fieldType === FieldType.WrappedGroup && f.groupedFields?.some(isPreviousReleaseRolloutField)) {
                return {
                    ...f,
                    groupedFields: f.groupedFields.map((gf) =>
                        isPreviousReleaseRolloutField(gf) ? { ...gf, disabled: true } : gf,
                    ),
                };
            }
            if (isPreviousReleaseRolloutField(f)) return { ...f, disabled: true };
            return f;
        });
    };

    const getTabTitle = (tab: ReleaseTypeTab): string => {
        if (appLevelAutomationConfig) return 'Configuration';
        if (tab.releaseTypes.length === 0) return 'New configuration';
        const sorted = [...tab.releaseTypes].sort(
            (a, b) => ALL_RELEASE_TYPE_GROUPS.indexOf(a) - ALL_RELEASE_TYPE_GROUPS.indexOf(b),
        );
        return sorted.map(displayTextForReleaseTypeGroup).join(', ');
    };

    const handleReleaseTypeChange = (tabIndex: number, selected: ReleaseTypesForNonBlockingSteps[]) => {
        if (appLevelAutomationConfig) return;

        const currentTab = tabs[tabIndex];
        const previousTypes = currentTab.releaseTypes;
        const added = selected.filter((t) => !previousTypes.includes(t));
        const removed = previousTypes.filter((t) => !selected.includes(t));

        // Prepare updated tabs copy and apply the selection change to the current tab
        const updated = tabs.map((t) => ({ ...t, releaseTypes: [...t.releaseTypes] }));
        updated[tabIndex].releaseTypes = selected;

        // Remove added types from other tabs to ensure uniqueness
        for (const addedType of added) {
            for (let i = 0; i < updated.length; i++) {
                if (i === tabIndex) continue;
                updated[i].releaseTypes = updated[i].releaseTypes.filter((t) => t !== addedType);
            }
        }

        const currentFormValues = form.getFieldsValue();
        const sourceTabValues =
            tabIndex === 0 ?
                Object.keys(currentFormValues).reduce((sourceValues, fieldName) => {
                    if (!tabs.some((tab) => tab.id === fieldName)) {
                        sourceValues[fieldName] = currentFormValues[fieldName];
                    }
                    return sourceValues;
                }, {})
            :   (currentFormValues[currentTab.id] ?? {});
        const sourceTabEnabled = sourceTabValues.enabled ?? true;

        let localNextTabId = nextTabId;

        // For every removed type, create a new tab containing that single release type.
        for (const removedType of removed) {
            const newId = `tab-${localNextTabId}`;
            localNextTabId++;
            updated.push({ id: newId, releaseTypes: [removedType], initialEnabled: sourceTabEnabled });
            // Copy all settings because the new tab is not shown right away. If we only copy
            // some fields, the other settings can be lost when the user saves.
            form.setFieldValue(newId, {
                ...cloneDeep(sourceTabValues),
                selectedReleaseTypes: [removedType],
            });
        }

        if (tabIndex === 0) {
            form.setFieldValue('selectedReleaseTypes', selected);
            form.setFieldValue('primaryReleaseTypes', selected);
        } else {
            form.setFieldValue([currentTab.id, 'selectedReleaseTypes'], selected);
        }

        if (localNextTabId !== nextTabId) setNextTabId(localNextTabId);

        // Filter out duplicate releaseTypes across tabs (keep first occurrence)
        const seen = new Set<ReleaseTypesForNonBlockingSteps>();
        let final = updated.map((t) => ({
            ...t,
            releaseTypes: t.releaseTypes.filter((rt) => {
                if (seen.has(rt)) return false;
                seen.add(rt);
                return true;
            }),
        }));

        // Remove tabs that became empty as a side-effect of moving types, except keep the tab
        // the user is actively editing (so it becomes a 'New configuration' if emptied)
        const currentTabId = currentTab.id;
        final = final.filter((t) => !(t.releaseTypes.length === 0 && t.id !== currentTabId));

        setTabs(final);

        // Keep focus on the tab the user was editing
        setActiveTab(currentTabId);
    };

    const handleAddTab = () => {
        if (appLevelAutomationConfig) return;

        const newId = `tab-${nextTabId}`;
        setNextTabId((n) => n + 1);
        setTabs((prev) => [...prev, { id: newId, releaseTypes: [] }]);
        setActiveTab(newId);
    };

    const handleCloseTab = (tabId: string) => {
        if (appLevelAutomationConfig) return;

        const tabToClose = tabs.find((t) => t.id === tabId);
        if (!tabToClose) return;
        setTabs((prev) => {
            const updated = prev.filter((t) => t.id !== tabId);
            if (updated.length === 0) return updated;
            // Merge closed tab's releaseTypes into last remaining tab, preserving uniqueness
            if (tabToClose.releaseTypes.length > 0) {
                const last = updated[updated.length - 1];
                const merged = Array.from(new Set([...last.releaseTypes, ...tabToClose.releaseTypes]));
                updated[updated.length - 1] = { ...last, releaseTypes: merged };
            }
            return updated;
        });
        // Switch to the last remaining tab if any
        const remainingTabs = tabs.filter((t) => t.id !== tabId);
        if (remainingTabs.length > 0) setActiveTab(remainingTabs[remainingTabs.length - 1].id);
    };

    const tabContentStyle: React.CSSProperties = {
        background: runwayColors.white,
        borderRadius: '0 0 8px 8px',
        padding: 16,
        border: `1px solid ${antGrey.grey4}`,
        borderTop: 'none',
    };
    const appLevelConfigContentStyle: React.CSSProperties = {
        ...tabContentStyle,
        borderRadius: 8,
        borderTop: `1px solid ${antGrey.grey4}`,
    };

    const didMountRef = React.useRef(false);
    React.useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        form.resetFields();
    }, [automation.id]);

    const watchedFormValues = Form.useWatch([], form) as any;
    const activeWorkflowHaltConditionGroups: HaltPhasedRolloutConditionGroupFormValue[] =
        activeTab === 'tab-0' ?
            (watchedFormValues?.conditionGroups ?? form.getFieldValue('conditionGroups') ?? [])
        :   (watchedFormValues?.[activeTab]?.conditionGroups ??
            form.getFieldValue([activeTab, 'conditionGroups']) ??
            []);
    const workflowHaltConditionGroupsSaveDisabled =
        automation.type === AutomationType.AutoHaltUnstablePhasedReleases &&
        !!isWorkflowsRolloutStepEnabled &&
        (activeWorkflowHaltConditionGroups.length === 0 ||
            !activeWorkflowHaltConditionGroups.some(haltConditionGroupHasSelectedCondition));

    const automationDocsLink = docsLinkForAutomationType(automation.type);

    const automationSettingsFooter = footerComponentForAutomationType(automation.type, automationPlatform);

    const cannotSaveAutomationSettingsDueToPlan = shouldDisableAutomation;

    const shouldShowDelayWarningForLifecycleAutomations =
        (!isWorkflowsSubmissionStepEnabled && automation.type === AutomationType.AutoSubmitRelease) ||
        (!isWorkflowsTakeoffStepEnabled && automation.type === AutomationType.AutoRelease);

    return (
        <Modal
            open={props.open}
            width={720}
            destroyOnClose
            title={
                <div style={{ paddingRight: 24 }}>
                    <Space size={12}>
                        <PlanRestrictedFeatureWrapper
                            automationType={automation.type}
                            requiresTooltip
                            shouldFakeDisabledState
                        >
                            <Text>{automation.name}</Text>
                        </PlanRestrictedFeatureWrapper>
                        {automation.isBeta && <BetaBadge />}
                        {automation.isUpdated && <UpdatedBadge />}
                    </Space>
                </div>
            }
            onCancel={props.onClose}
            footer={[
                <Button key="cancel" onClick={props.onClose}>
                    Cancel
                </Button>,
                <PermissionedActionButton
                    key="save"
                    actionType={RunwayUserAction.UAEditAutomations}
                    type="primary"
                    loading={props.isLoading}
                    disabled={cannotSaveAutomationSettingsDueToPlan || workflowHaltConditionGroupsSaveDisabled}
                    onClick={() => {
                        if (!cannotSaveAutomationSettingsDueToPlan && !workflowHaltConditionGroupsSaveDisabled) {
                            form.submit();
                        }
                    }}
                >
                    Save
                </PermissionedActionButton>,
            ]}
            afterClose={() => {
                form.resetFields();
                props.onAfterClose();
            }}
            focusTriggerAfterClose={false}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
                <AutomationPlanExecutionBlockedAlert
                    visible={shouldDisableAutomation && automation.enabled}
                    style={{ marginBottom: 0 }}
                />
                <PlanRestrictedFeatureWrapper automationType={automation.type} shouldFakeDisabledState>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '16px',
                            width: '100%',
                        }}
                    >
                        <AutomationConfigurationHelpBanner
                            automationType={automation.type}
                            appStoreDefaultsSet={!!appSettings.appStoreDefaults}
                            stagedRolloutEnabled={
                                appSettings.appStoreDefaults ?
                                    (appSettings.appStoreDefaults as GoogleAppStoreSettings).stagedRelease === true
                                :   false
                            }
                            platform={automationPlatform}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                            {props.context !== AutomationSettingsContext.App &&
                                !(shouldDisableAutomation && automation.enabled) && (
                                    <Alert
                                        showIcon
                                        closable={false}
                                        message={
                                            <Text>
                                                These settings will apply to all releases of the specified type (not
                                                only to the current release).
                                            </Text>
                                        }
                                        type="warning"
                                    />
                                )}
                            {automation.description && <Text>{automation.description}</Text>}
                            {automationDocsLink && (
                                <Text>
                                    Read more about this automation in our{' '}
                                    <Typography.Link href={automationDocsLink} target="_blank">
                                        docs.
                                    </Typography.Link>
                                </Text>
                            )}
                            <Space size={10} wrap direction="vertical">
                                {automation.requiredCapabilities?.length > 0 && capabilitiesShouldBeBulleted ?
                                    <>
                                        <Text style={{ color: antGrey.grey8 }}>Required integrations:</Text>
                                        {automation.requiredCapabilities.map((requiredArray) => {
                                            return (
                                                <>
                                                    <ul style={{ margin: 0 }}>
                                                        <li style={{ color: antGrey.grey8 }}>
                                                            {requiredCapabilitiesComponent(requiredArray)}
                                                        </li>
                                                    </ul>
                                                </>
                                            );
                                        })}
                                    </>
                                : automation.requiredCapabilities?.length > 0 ?
                                    <Space size={10} wrap>
                                        <Text style={{ color: antGrey.grey7 }}>Required:</Text>
                                        {automation.requiredCapabilities.map((requiredArray) => {
                                            return requiredCapabilitiesComponent(requiredArray);
                                        })}
                                    </Space>
                                :   null}
                            </Space>
                            {servicesErrorMessage &&
                                !(
                                    servicesErrorMessage === DEFAULT_RELEASE_SETTINGS_ERROR_MESSAGE &&
                                    releaseNotesSourceFormValue === ReleaseNotesDataSource.PreviousRelease
                                ) &&
                                renderErrorMessage(servicesErrorMessage)}
                        </div>
                        {sameTypeAutomations.length > 1 && (
                            <StepConfigSelector
                                value={automation.id}
                                sameTypeAutomations={sameTypeAutomations}
                                stepGraphStepsMap={stepGraphStepsMap}
                                platform={automationPlatform}
                                appStoreType={automationAppStoreType}
                                isWorkflowsCIStepEnabled={isWorkflowsCIStepEnabled}
                                onChange={(automationId) => {
                                    props.onAutomationSelected?.(automationId);
                                    const selectedAutomation = sameTypeAutomations.find(
                                        (auto) => auto.id === automationId,
                                    );
                                    setSelectedStepConfigId(selectedAutomation?.stepConfigId);
                                }}
                            />
                        )}
                        {!isBucketAutomationType ?
                            <Form
                                form={form}
                                autoComplete="off"
                                layout="vertical"
                                initialValues={allInitialValues}
                                onFinish={() => onSubmit(form)}
                                disabled={shouldDisableAutomation}
                            >
                                {appLevelAutomationConfig ?
                                    tabs[0] && (
                                        <div style={appLevelConfigContentStyle}>
                                            {renderFormFields(
                                                filterAccelerateFieldByReleaseTypes(
                                                    firstTabOverrideFields,
                                                    tabs[0].releaseTypes,
                                                ),
                                            )}
                                        </div>
                                    )
                                :   <Tabs
                                        activeKey={activeTab}
                                        onChange={setActiveTab}
                                        type="editable-card"
                                        hideAdd={false}
                                        tabBarStyle={{ marginBottom: 0 }}
                                        onEdit={(targetKey, action) => {
                                            if (action === 'add') {
                                                handleAddTab();
                                            } else if (action === 'remove' && typeof targetKey === 'string') {
                                                handleCloseTab(targetKey);
                                            }
                                        }}
                                        items={tabs.map((tab, index) => {
                                            const isEmptyNonPrimary = index > 0 && tab.releaseTypes.length === 0;
                                            const overrideData = overrideTabData.find((d) => d.tab.id === tab.id);
                                            return {
                                                key: tab.id,
                                                label: getTabTitle(tab),
                                                closable: tabs.length > 1,
                                                children: (
                                                    <div style={tabContentStyle}>
                                                        {index === 0 && (
                                                            <FormItem
                                                                hidden
                                                                name="primaryReleaseTypes"
                                                                initialValue={tab.releaseTypes}
                                                            >
                                                                <Input />
                                                            </FormItem>
                                                        )}
                                                        <Form.Item label="Release types" style={{ marginBottom: 16 }}>
                                                            <Select
                                                                mode="multiple"
                                                                value={tab.releaseTypes}
                                                                onChange={(selected) =>
                                                                    handleReleaseTypeChange(index, selected)
                                                                }
                                                                options={ALL_RELEASE_TYPE_GROUPS.map((t) => ({
                                                                    value: t,
                                                                    label: displayTextForReleaseTypeGroup(t),
                                                                }))}
                                                            />
                                                        </Form.Item>
                                                        <div
                                                            style={
                                                                isEmptyNonPrimary ?
                                                                    {
                                                                        opacity: 0.5,
                                                                        filter: 'grayscale(100%)',
                                                                        pointerEvents: 'none',
                                                                    }
                                                                :   undefined
                                                            }
                                                        >
                                                            {index === 0 ?
                                                                renderFormFields(
                                                                    filterAccelerateFieldByReleaseTypes(
                                                                        hasPrimaryTab ? primaryFormFields : (
                                                                            firstTabOverrideFields
                                                                        ),
                                                                        tab.releaseTypes,
                                                                    ),
                                                                )
                                                            :   renderFormFields(
                                                                    filterAccelerateFieldByReleaseTypes(
                                                                        overrideData?.namespacedFields ?? [],
                                                                        tab.releaseTypes,
                                                                    ),
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                ),
                                            };
                                        })}
                                    />
                                }
                            </Form>
                        :   <Form
                                form={form}
                                autoComplete="off"
                                layout="vertical"
                                initialValues={allInitialValues}
                                onFinish={() => onSubmit(form)}
                                disabled={shouldDisableAutomation}
                            >
                                {renderFormFields(primaryFormFields)}
                            </Form>
                        }
                        {automation.additionalInfo && (
                            <div>
                                <Text type="secondary">{automation.additionalInfo}</Text>
                            </div>
                        )}
                        {/* Only show a warning about potential delay for non-migrated steps */}
                        {/* For workflow apps, we have scheduled actions enabled */}
                        {shouldShowDelayWarningForLifecycleAutomations && (
                            <Alert
                                showIcon
                                closable={false}
                                message={<Text>{LIFECYCLE_AUTOMATION_TIMING_MESSAGE}</Text>}
                                type="info"
                            />
                        )}
                        {automationSettingsFooter}
                    </div>
                </PlanRestrictedFeatureWrapper>
            </div>
        </Modal>
    );
};

const footerComponentForAutomationType = (automationType: AutomationType, platform: AppPlatform) => {
    switch (automationType) {
        case AutomationType.AutoCreateAppStoreVersions:
            return getIsApplePlatform(platform) ?
                    <Text type="warning">
                        For this automation to work correctly, please ensure that App Store versions are not updated by
                        any existing CI/CD workflows (for example, if you&apos;re using{' '}
                        <Text code>fastlane deliver</Text>).
                    </Text>
                :   null;
        default:
            return null;
    }
};

enum TriggerWorkflowOption {
    SmartMode,
    TriggerEveryNHours,
}

type AutoSubmitOrReleaseAutomationName = 'auto-submit' | 'auto-release';

const acceleratePreviousReleaseTooltip = (
    <>
        <p>
            By default, your prior release will NOT automatically accelerate to 100% when releasing the next version.
            With multiple subsequent incomplete rollouts, this may mean that some of your users will continue on older
            (n-2, n-3) versions even if they have enabled automatic updates. Choose this option to ensure all your users
            will be on at least your prior release when they update.
        </p>
        <p style={{ marginBottom: 0 }}>
            Releases that were previously halted, or releases before a rollback or hotfix, will not be accelerated to
            100% automatically.
        </p>
    </>
);

const waitForPreviousRolloutTooltip = (
    <>
        <p>
            While your previous release is still rolling out, Runway holds the automation and adds a timeline event
            explaining the wait. It picks back up on its own once that rollout reaches 100%.
        </p>
        <p style={{ marginBottom: 0 }}>
            A rollout that was halted or paused never reaches 100%, so Runway treats it as finished and moves forward.
            Hotfix and rollback releases are never delayed.
        </p>
    </>
);

const continueIncrementingAfterManualUpdateTooltip = (
    <>
        <p>
            Applies whether the percentage was changed from Runway or straight from your store console — Runway treats
            both the same way.
        </p>
        <p>
            <strong>Checked:</strong> Runway matches the new percentage to the day it corresponds to in the sequence
            above, and carries on from the next day. With a 1 / 2 / 5 / 10 / 20 / 50 / 100 sequence, a manual jump to
            20% counts as day 5, so the next increment Runway makes is to 50%. The wait before that next increment
            starts from the manual change, not from Runway's last one.
        </p>
        <p style={{ marginBottom: 0 }}>
            <strong>Unchecked:</strong> Runway keeps walking the sequence one day at a time and only writes a new
            percentage once the day it has reached is scheduled for more than what is already live. After that same jump
            to 20%, the rollout sits at 20% while Runway works through days 4 and 5, and only moves when it reaches day
            6 (50%).
        </p>
    </>
);

const infoTooltipIcon = (tooltip: React.ReactNode) => (
    <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
    </Tooltip>
);

const acceleratePreviousReleaseLabel = (
    <div>
        (Standard releases only) Accelerate previous release to 100% of users if needed before releasing new version
        {infoTooltipIcon(acceleratePreviousReleaseTooltip)}
    </div>
);

const waitForPreviousRolloutLabel = (automationName: AutoSubmitOrReleaseAutomationName) => (
    <div>
        {`Do not ${automationName === 'auto-submit' ? 'submit' : 'release'} until the previous release is 100% rolled out, or has been halted/paused`}
        {infoTooltipIcon(waitForPreviousRolloutTooltip)}
    </div>
);

const acceleratePreviousReleaseFieldName = 'shouldReleasePreviousSubmissionToAllUsersFirst';
const waitForPreviousRolloutFieldName = 'shouldWaitForPreviousReleaseToBeFullyRolledOut';

const lastFieldNamePart = (name: FormFieldData['name']): string =>
    Array.isArray(name) && name.length ? String(name[name.length - 1]) : String(name);

const buildPreviousReleaseRolloutFields = (
    automationName: AutoSubmitOrReleaseAutomationName,
    automationData:
        | {
              shouldReleasePreviousSubmissionToAllUsersFirst?: boolean;
              shouldWaitForPreviousReleaseToBeFullyRolledOut?: boolean;
          }
        | undefined,
    formInstance?: FormInstance,
): FormFieldData => ({
    name: `previousReleaseRolloutOptions-${automationName}`,
    fieldType: FieldType.WrappedGroup,
    groupedFields: [
        {
            label: '',
            data: acceleratePreviousReleaseLabel,
            name: acceleratePreviousReleaseFieldName,
            fieldType: FieldType.Checkbox,
            initialValue: automationData?.shouldReleasePreviousSubmissionToAllUsersFirst ?? false,
            rules: [],
        },
        {
            label: '',
            data: waitForPreviousRolloutLabel(automationName),
            name: waitForPreviousRolloutFieldName,
            fieldType: FieldType.Checkbox,
            initialValue: automationData?.shouldWaitForPreviousReleaseToBeFullyRolledOut ?? false,
            rules: [],
        },
    ],
    groupChildrenWrapper:
        formInstance ?
            (_, wrappedFields, renderFields) => (
                <Form.Item shouldUpdate noStyle>
                    {() => {
                        const isChecked = (fieldName: string) =>
                            !!formInstance.getFieldValue(
                                wrappedFields.find((f) => lastFieldNamePart(f.name) === fieldName)?.name,
                            );

                        return renderFields(
                            wrappedFields.map((field) => {
                                const otherFieldName =
                                    lastFieldNamePart(field.name) === acceleratePreviousReleaseFieldName ?
                                        waitForPreviousRolloutFieldName
                                    :   acceleratePreviousReleaseFieldName;

                                return { ...field, disabled: field.disabled || isChecked(otherFieldName) };
                            }),
                        );
                    }}
                </Form.Item>
            )
        :   undefined,
});

const buildAutoCherryPickTokenFields = (
    allowFixesWithTokenFieldName: FormFieldData['name'],
    tokensFieldName: FormFieldData['name'],
    matchTokenOnFieldName: FormFieldData['name'],
    cherryPickData: AutomationCherryPickFromWorkingBranch['data'] | undefined,
    formInstance?: FormInstance,
): FormFieldData[] => {
    const currentTokens = cherryPickData?.tokens ?? ['[runway:fix-{version}]'];
    const currentMatchTokenOn = cherryPickData?.matchTokenOn ?? [AutoCherryPickMatchTokenOn.Title];
    const matchTokenOnToLabel = (tokenOn: AutoCherryPickMatchTokenOn) => {
        switch (tokenOn) {
            case AutoCherryPickMatchTokenOn.Title:
                return 'PR title';
            case AutoCherryPickMatchTokenOn.Label:
                return 'PR label';
            default:
                return tokenOn;
        }
    };

    const tokenGroup: FormFieldData = {
        name: CHERRY_PICK_TOKEN_GROUP_FIELD_KEY,
        fieldType: FieldType.WrappedGroup,
        groupedFields: [
            {
                label: `Fix token patterns`,
                tooltip: `Include a string to flag it as a fix for this automation. Pattern must include {version}, or {versionConcise}, or no tokens at all.`,
                name: tokensFieldName,
                fieldType: FieldType.Custom,
                initialValue: currentTokens,
                rules: [
                    { required: true },
                    {
                        validator: (_, value) => {
                            return cherryPickPatternValidator(value);
                        },
                    },
                ],
                renderField: () => {
                    return (
                        <Select
                            style={{ width: '100%' }}
                            allowClear
                            mode="tags"
                            notFoundContent={null}
                            placeholder="Select"
                        />
                    );
                },
            } as FormFieldData,
            {
                label: `Match token on...`,
                name: matchTokenOnFieldName,
                fieldType: FieldType.Custom,
                initialValue: currentMatchTokenOn,
                data: Object.values(AutoCherryPickMatchTokenOn).map((tokenOn) => {
                    return { value: tokenOn, label: matchTokenOnToLabel(tokenOn) };
                }),
                rules: [{ required: true }],
                renderField: (data: { value: string; label: string }[]) => {
                    return (
                        <Select
                            style={{ width: '100%' }}
                            allowClear
                            showSearch={false}
                            mode="multiple"
                            placeholder="Select"
                        >
                            {data.map(({ value, label }, index) => {
                                return (
                                    <Select.Option value={value} key={index}>
                                        {label}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    );
                },
            } as FormFieldData,
        ],
    };

    return [
        {
            label: '',
            data: 'Allow PRs to be flagged as fixes using a token',
            name: allowFixesWithTokenFieldName,
            fieldType: FieldType.Checkbox,
            initialValue: cherryPickData?.allowFixesWithToken ?? true,
            rules: [],
        },
        formInstance ?
            {
                ...tokenGroup,
                groupChildrenWrapper: (_, wrappedFields, renderFields) => {
                    return (
                        <Form.Item shouldUpdate noStyle>
                            {() => {
                                const allowTokensValue =
                                    formInstance.getFieldValue(allowFixesWithTokenFieldName) ?? true;
                                const tokenFields = wrappedFields.map((field) => {
                                    const fieldName =
                                        typeof field.name === 'string' ? field.name
                                        : Array.isArray(field.name) ? field.name[field.name.length - 1]
                                        : undefined;

                                    if (fieldName === 'tokens' || fieldName === 'matchTokenOn') {
                                        return { ...field, disabled: !allowTokensValue };
                                    }

                                    return field;
                                });

                                return (
                                    <Form.Item wrapperCol={{ span: 23, offset: 1 }}>
                                        {renderFields(tokenFields)}
                                    </Form.Item>
                                );
                            }}
                        </Form.Item>
                    );
                },
            }
        :   tokenGroup,
    ];
};

const automationSettingFormFieldsForAutomation: (
    appId: string,
    orgId: string,
    appIdParam: string,
    orgIdParam: string,
    automation: Automation,
    appPlatform: AppPlatform,
    appStoreType: AppStoreType,
    hasRequiredCapabilities: boolean,
    shouldDisableAutomationForPlan: boolean,
    connectedCapabilities: IntegrationCapability[],
    shouldShowAutoKickoffDirectMergeOption: boolean,
    isGithubVCS: boolean,
    baseFieldHelpMessage: React.ReactNode,
    requiresFixRequestsApprovals: boolean,
    vcsSupportsPRComments: boolean,
    monitoringMetrics?: AppMonitoringHealthMetric[],
    artifactUploadOptions?: ArtifactUploadOptions,
    dsymsUploadOptions?: DsymsUploadOptions,
    notificationsProvider?: IntegrationProvider,
    regressionTesting?: Integration,
    availableAutoTransitionTicketsStatuses?: [string, string][],
    triggerWorkflowOption?: TriggerWorkflowOption,
    onSelectTriggerWorkflowOption?: (option: TriggerWorkflowOption) => void,
    betaTesting?: Integration,
    betaTestingProvider?: IntegrationProvider,
    cherryPickStrategyState?: AutoCherryPickStrategy,
    cherryPickStrategyHelpMessage?: string,
    onSelectCherryPickStrategyState?: (strategy: AutoCherryPickStrategy) => void,
    autoSyncTranslationsBeforeKickoffEnabled?: boolean,
    autoSyncTranslationsBeforeSubmissionEnabled?: boolean,
    onSelectAutoSyncTranslationsBeforeKickoffEnabled?: (enabled: boolean) => void,
    onSelectAutoSyncTranslationsBeforeSubmissionEnabled?: (enabled: boolean) => void,
    autoSyncMetadataTranslationsBeforeSubmissionEnabled?: boolean,
    onSelectAutoSyncMetadataTranslationsBeforeSubmissionEnabled?: (enabled: boolean) => void,
    monitoringChecklistItemTemplates?: ChecklistItemTemplate[],
    orgUserGroups?: Record<UserGroupId, UserGroup>,
    appUsers?: OrgUser[],
    autoSubmitStrategy?: AutoSubmitStrategy,
    onSelectAutoSubmitStrategy?: (strategy: AutoSubmitStrategy) => void,
    resigningStrategy?: RollbackResigningStrategy,
    onSelectResigningStrategy?: (strategy: RollbackResigningStrategy) => void,
    regressionTestStepConfigs?: Record<string, StepGraphStep>,
    regressionTestStepConfigIds?: string[],
    regressionStepsToConsider?: string[],
    setRegressionStepsToConsider?: (steps: string[]) => void,
    autoSelectLatestBuildStrategy?: AutoSelectLatestBuildStrategy,
    setAutoSelectLatestBuildStrategy?: (strategy: AutoSelectLatestBuildStrategy) => void,
    rebuildByCIUnavailableReason?: string | null,
    featureManagementIntegration?: Integration,
    isWorkflowsRolloutStepEnabled?: boolean,
    schedulingIntegration?: Integration,
    schedulingProvider?: IntegrationProvider | null,
    form?: FormInstance,
    isPlayReleaseLifecycleEnabled?: boolean,
    stabilityIntegrations?: Integration[],
    allDestinations?: Destination[],
    hasAppStoreIntegration?: boolean,
    availableIssueTrackingLabels?: string[],
    useTriggerCIWorkflowConditionGroups?: boolean,
    stepGraphStepsMap?: Record<string, StepGraphStep>,
) => FormFieldData[] = (
    appId,
    orgId,
    orgIdParam,
    appIdParam,
    automation,
    platform,
    appStoreType,
    hasRequiredCapabilities,
    shouldDisableAutomationForPlan,
    connectedCapabilities,
    shouldShowAutoKickoffDirectMergeOption,
    isGithubVCS,
    baseFieldHelpMessage,
    requiresFixRequestsApprovals,
    vcsSupportsPRComments,
    monitoringMetrics,
    artifactUploadOptions,
    dsymsUploadOptions,
    notificationsProvider,
    regressionTesting,
    availableAutoTransitionTicketsStatuses,
    triggerWorkflowOption,
    onSelectTriggerWorkflowOption,
    betaTesting,
    betaTestingProvider,
    cherryPickStrategyState,
    cherryPickStrategyHelpMessage,
    onSelectCherryPickStrategyState,
    autoSyncTranslationsBeforeKickoffEnabled,
    autoSyncTranslationsBeforeSubmissionEnabled,
    onSelectAutoSyncTranslationsBeforeKickoffEnabled,
    onSelectAutoSyncTranslationsBeforeSubmissionEnabled,
    autoSyncMetadataTranslationsBeforeSubmissionEnabled,
    onSelectAutoSyncMetadataTranslationsBeforeSubmissionEnabled,
    monitoringChecklistItemTemplates,
    orgUserGroups,
    appUsers,
    autoSubmitStrategy,
    onSelectAutoSubmitStrategy,
    resigningStrategy,
    onSelectResigningStrategy,
    regressionTestStepConfigs,
    regressionTestStepConfigIds,
    regressionStepsToConsider,
    setRegressionStepsToConsider,
    autoSelectLatestBuildStrategy,
    setAutoSelectLatestBuildStrategy,
    rebuildByCIUnavailableReason,
    featureManagementIntegration,
    isWorkflowsRolloutStepEnabled,
    schedulingIntegration,
    schedulingProvider,
    form,
    isPlayReleaseLifecycleEnabled,
    stabilityIntegrations = [],
    allDestinations = [],
    hasAppStoreIntegration = false,
    availableIssueTrackingLabels = [],
    useTriggerCIWorkflowConditionGroups = false,
    stepGraphStepsMap = {},
) => {
    if (!automation) {
        return [];
    }

    const baseField: FormFieldData = {
        label: 'Enabled',
        name: 'enabled',
        helpMessage: baseFieldHelpMessage,
        initialValue: automation.enabled,
        fieldType: FieldType.Switch,
        rules: [
            {
                validator: (_, enabled) => {
                    if (enabled && !hasRequiredCapabilities) {
                        return Promise.reject(
                            'Required integrations not configured. Please disable automation to save settings.',
                        );
                    }

                    return Promise.resolve();
                },
            },
        ],
        // disabled: !hasRequiredCapabilities && !automation.enabled,
        disabled: !hasRequiredCapabilities && !automation.enabled,
        extraFormItemProps: {
            validateTrigger: false,
        },
    };

    const automationPlatform = automation.platform ?? platform;

    const releaseTypesField: FormFieldData | null = renderReleaseTypesForAutomation(
        automation.type,
        automationPlatform,
        !hasRequiredCapabilities && !automation.enabled,
        automation.automationReleaseTypes,
    );

    const baseFields: FormFieldData[] = [baseField, ...(releaseTypesField ? [releaseTypesField] : [])];

    switch (automation.type) {
        case AutomationType.AutoBumpVersion: {
            const bumpVersionAutomation = automation as AutomationBumpVersion;
            const data = AllBumpVersionStrategies.filter((strategy) => {
                if (isAppPlatform(platform)) {
                    return true;
                }
                switch (strategy) {
                    case BumpVersionAutomationStrategy.PreKickoffToCurrentVersionOnWorkingBranch:
                        return true;
                    case BumpVersionAutomationStrategy.PostKickoffToCurrentVersionOnReleaseBranch:
                        return true;
                    case BumpVersionAutomationStrategy.PostKickoffToNextVersionOnWorkingBranch:
                        return true;
                    case BumpVersionAutomationStrategy.PostSubmitToNextVersionOnWorkingBranch:
                        return false; // no submission on non-app platforms
                    case BumpVersionAutomationStrategy.PostReleaseToNextVersionOnWorkingBranch:
                        return true;
                }
            }).map((strategy) => {
                const displayText = displayTextForBumpVersionStrategy(strategy);

                return {
                    value: strategy,
                    displayValue: displayText,
                };
            });
            return [
                ...baseFields,
                {
                    label: 'Bump version strategy',
                    name: 'strategy',
                    tooltip: 'Choose when Runway should bump the version for each release.',
                    fieldType: FieldType.Select,
                    initialValue: bumpVersionAutomation.data?.strategy ?? null,
                    data: data,
                    rules: [],
                },
                ...generateSkipInvalidFilesAutomationFields(bumpVersionAutomation),
                ...generateBypassPullRequestsFields(bumpVersionAutomation, {
                    orgId,
                    appId,
                    isGithubVCS,
                    createsMergeCommit: false,
                    canWaitForRequiredStatusChecks: true,
                    branchTargetForValues: (values) => {
                        const strategy = values.strategy as BumpVersionAutomationStrategy | null;
                        if (!strategy) {
                            return null;
                        }
                        return strategy === BumpVersionAutomationStrategy.PostKickoffToCurrentVersionOnReleaseBranch ?
                                'releaseBranch'
                            :   'workingBranch';
                    },
                    disabledReasonForValues: (values) => {
                        if (!values.strategy) {
                            return 'Choose a bump version strategy first, so Runway knows which branch to check.';
                        }
                        return undefined;
                    },
                }),
                ...generateAssignPrToAutomationFields(bumpVersionAutomation, {
                    includeFixOwner: false,
                    disableWhenBypassingPullRequests: true,
                }),
            ];
        }

        case AutomationType.AutoKickoffRelease: {
            const kickoffAutomation = automation as AutomationKickoffRelease;

            return [
                ...baseFields,
                {
                    label: 'Allow kickoff when previous release not complete?',
                    name: 'allowKickoffWhenPreviousNotComplete',
                    fieldType: FieldType.Custom,
                    initialValue: kickoffAutomation.data?.allowKickoffWhenPreviousNotComplete ?? null,
                    rules: [],

                    renderField: () => {
                        return (
                            <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        );
                    },
                },
                ...(shouldShowAutoKickoffDirectMergeOption ?
                    generateBypassPullRequestsFields(kickoffAutomation, {
                        orgId,
                        appId,
                        isGithubVCS,
                        createsMergeCommit: true,
                        canWaitForRequiredStatusChecks: false,
                        branchTargetForValues: () => 'releaseBranch',
                    })
                :   []),
            ];
        }
        case AutomationType.AutoAddMissingFAs: {
            const addMissingFAsAutomation = automation as AutomationAutoAddMissingFAs;
            const isLinear = featureManagementIntegration?.id === IntegrationType.Linear;

            return [
                ...baseFields,
                ...(isLinear ?
                    [
                        {
                            label: '',
                            data: 'Create labels at workspace level instead of team level.',
                            name: 'useWorkspaceLabels',
                            fieldType: FieldType.Checkbox,
                            initialValue: addMissingFAsAutomation.data?.useWorkspaceLabels ?? false,
                            rules: [],
                        },
                    ]
                :   []),
            ];
        }
        case AutomationType.AutoApplyLabelsToFixTickets: {
            const applyLabelsAutomation = automation as AutomationAutoApplyLabelsToFixTickets;
            const isLinear = featureManagementIntegration?.id === IntegrationType.Linear;
            const labelSelect = () => (
                <Select
                    mode="tags"
                    allowClear
                    tokenSeparators={[',', '\n']}
                    filterOption={filterOptionLabel}
                    style={{ width: '100%' }}
                >
                    {availableIssueTrackingLabels.map((label) => (
                        <Select.Option value={label} key={label}>
                            {label}
                        </Select.Option>
                    ))}
                </Select>
            );

            const initialApplyApprovedLabels = (applyLabelsAutomation.data?.approvedLabels?.length ?? 0) > 0;
            const initialApplyRejectedLabels = (applyLabelsAutomation.data?.rejectedLabels?.length ?? 0) > 0;
            const showApprovedLabels = form?.getFieldValue('applyApprovedLabels') ?? initialApplyApprovedLabels;
            const showRejectedLabels = form?.getFieldValue('applyRejectedLabels') ?? initialApplyRejectedLabels;

            return [
                ...baseFields,
                {
                    label: 'Label(s) to apply to tickets associated with fixes:',
                    name: 'fixLabels',
                    fieldType: FieldType.Custom,
                    initialValue: applyLabelsAutomation.data?.fixLabels ?? [],
                    extraFormItemProps: { validateTrigger: 'onSubmit' },
                    rules: [
                        ({ getFieldValue }) => ({
                            validator: (_, value) => {
                                const approved =
                                    getFieldValue('applyApprovedLabels') ? (getFieldValue('approvedLabels') ?? []) : [];
                                const rejected =
                                    getFieldValue('applyRejectedLabels') ? (getFieldValue('rejectedLabels') ?? []) : [];
                                if (!value.length && !approved.length && !rejected.length) {
                                    return Promise.reject('At least one label must be set');
                                }
                                return Promise.resolve();
                            },
                        }),
                    ],
                    renderField: () => labelSelect(),
                },
                {
                    label: '',
                    data: 'Apply additional labels when a fix is approved',
                    name: 'applyApprovedLabels',
                    fieldType: FieldType.Checkbox,
                    initialValue: initialApplyApprovedLabels,
                    rules: [],
                },
                ...(showApprovedLabels ?
                    [
                        {
                            name: 'approvedLabels',
                            fieldType: FieldType.Custom,
                            initialValue: applyLabelsAutomation.data?.approvedLabels ?? [],
                            style: { marginLeft: 24 },
                            renderField: () => labelSelect(),
                            rules: [
                                () => ({
                                    validator: (_, value) => {
                                        if (!value?.length) {
                                            return Promise.reject('At least one label must be set');
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ],
                        },
                    ]
                :   []),
                {
                    label: '',
                    data: 'Apply additional labels when a fix is rejected',
                    name: 'applyRejectedLabels',
                    fieldType: FieldType.Checkbox,
                    initialValue: initialApplyRejectedLabels,
                    rules: [],
                },
                ...(showRejectedLabels ?
                    [
                        {
                            name: 'rejectedLabels',
                            fieldType: FieldType.Custom,
                            initialValue: applyLabelsAutomation.data?.rejectedLabels ?? [],
                            style: { marginLeft: 24 },
                            renderField: () => labelSelect(),
                            rules: [
                                () => ({
                                    validator: (_, value) => {
                                        if (!value?.length) {
                                            return Promise.reject('At least one label must be set');
                                        }
                                        return Promise.resolve();
                                    },
                                }),
                            ],
                        },
                    ]
                :   []),
                ...(isLinear ?
                    [
                        {
                            label: '',
                            data: 'Create labels at workspace level instead of team level',
                            name: 'useWorkspaceLabels',
                            fieldType: FieldType.Checkbox,
                            initialValue: applyLabelsAutomation.data?.useWorkspaceLabels ?? false,
                        },
                    ]
                :   []),
            ];
        }
        case AutomationType.AutoCreatePMTicketOnTriageIssueFixRequest: {
            const triagePMAutomation = automation as AutomationAutoCreatePMTicketOnTriageIssueFixRequest;
            const integrationId = featureManagementIntegration?.id;

            if (integrationId === IntegrationType.Jira) {
                const projects = (featureManagementIntegration?.data as JiraIntegrationData)?.selectedProjects ?? [];
                return [
                    ...baseFields,
                    {
                        label: 'Jira project',
                        helpMessage: 'New triage issues will create a ticket in this Jira project.',
                        name: 'jiraProjectKey',
                        fieldType: FieldType.Custom,
                        initialValue: triagePMAutomation.data?.jiraProjectKey,
                        data: projects,
                        rules: [{ required: true, message: 'Select a Jira project' }],
                        renderField: (data: JiraProject[]) => {
                            return (
                                <Select
                                    placeholder="Select a project"
                                    filterOption={filterOptionLabel}
                                    style={{ width: '100%' }}
                                >
                                    {data.map((project) => (
                                        <Select.Option
                                            value={project.key}
                                            key={project.key}
                                            label={`${project.name} (${project.key})`}
                                        >
                                            {project.name} ({project.key})
                                        </Select.Option>
                                    ))}
                                </Select>
                            );
                        },
                    },
                ];
            }

            if (integrationId === IntegrationType.Linear) {
                const teams = (featureManagementIntegration?.data as LinearIntegrationData)?.selectedTeams ?? [];
                return [
                    ...baseFields,
                    {
                        label: 'Linear team',
                        helpMessage: 'New triage issues will create a ticket on this Linear team.',
                        name: 'linearTeamId',
                        fieldType: FieldType.Custom,
                        initialValue: triagePMAutomation.data?.linearTeamId,
                        data: teams,
                        rules: [{ required: true, message: 'Select a Linear team' }],
                        renderField: (data: LinearTeam[]) => {
                            return (
                                <Select
                                    placeholder="Select a team"
                                    filterOption={filterOptionLabel}
                                    style={{ width: '100%' }}
                                >
                                    {data.map((team) => (
                                        <Select.Option value={team.id} key={team.id} label={team.name}>
                                            {team.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            );
                        },
                    },
                ];
            }

            return [...baseFields];
        }
        case AutomationType.AutoTagReleases: {
            const autotagAutomation = automation as AutomationAutoTagReleases;

            return [
                ...baseFields,
                {
                    label: 'Allow fallback to tagging HEAD of release branch if Runway is unable to match released build to specific commit',
                    name: 'fallbackToHeadIfNeeded',
                    fieldType: FieldType.Switch,
                    initialValue: autotagAutomation.data?.fallbackToHeadIfNeeded ?? false,
                    rules: [],
                },
            ];
        }
        case AutomationType.AutoCreateRunwayReleases: {
            const createRunwayReleasesAutomation = automation as AutomationAutoCreateRunwayReleases;

            return [
                ...baseFields,
                allDestinations?.length > 1 && {
                    name: 'destinations',
                    fieldType: FieldType.Custom,
                    initialValue: createRunwayReleasesAutomation.data?.destinations,
                    rules: [],
                    renderField: () => <CreateRunwayReleasesDestinationSelector appId={appId} />,
                },
                {
                    label: '',
                    data: (
                        <div>
                            Wait until current release&apos;s backmerge is merged
                            <Tooltip title="Do not create the new release until the current release's backmerge PR is merged. This option requires the 'Backmerge changes from the release branch' automation to be enabled.">
                                <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                            </Tooltip>
                        </div>
                    ),
                    initialValue: createRunwayReleasesAutomation.data?.delayUntilBackmergeMerged ?? false,
                    name: 'delayUntilBackmergeMerged',
                    fieldType: FieldType.Checkbox,
                    rules: [],
                },
            ].filter(Boolean);
        }
        case AutomationType.AutoApplyMetadata: {
            const applyMetadataAutomation = automation as AutomationApplyMetadata;

            const releaseNotesOrWhatsNewLabel = isIosPlatform(platform) ? "'What's new' text" : 'release notes';

            const releaseNotesSourceOptions = AllReleaseNotesDataSources.map((dataSource) => {
                return {
                    value: dataSource,
                    displayValue: displayTextForReleaseNotesDataSource(dataSource, platform),
                };
            });

            return [
                ...baseFields,
                {
                    label: isIosPlatform(platform) ? `'What's new' text` : 'Release notes',
                    name: 'releaseNotesSource',
                    helpMessage: `You can set default ${releaseNotesOrWhatsNewLabel} from App settings > Flightpath > Metadata`,
                    fieldType: FieldType.Select,
                    initialValue: applyMetadataAutomation.data?.releaseNotesSource ?? false,
                    data: releaseNotesSourceOptions,
                    rules: [],
                },
                ...(isIosPlatform(platform) ?
                    [
                        {
                            label: 'Promotional text',
                            name: 'promoTextSource',
                            helpMessage:
                                'You can set default promotional text from App settings > Flightpath > Metadata',
                            fieldType: FieldType.Select,
                            initialValue: applyMetadataAutomation.data?.promoTextSource ?? ReleaseNotesDataSource.None,
                            data: AllReleaseNotesDataSources.map((dataSource) => ({
                                value: dataSource,
                                displayValue: displayTextForPromoTextDataSource(dataSource),
                            })),
                            rules: [],
                        },
                    ]
                :   []),
            ];
        }
        case AutomationType.AutoBackmergeReleaseBranches: {
            const backmergeAutomation = automation as AutomationBackmergeReleaseBranches;

            return [
                ...baseFields,
                {
                    label: 'Backmerge strategy',
                    name: 'strategy',
                    fieldType: FieldType.Select,
                    initialValue: backmergeAutomation.data?.strategy ?? AutoBackmergeStrategy.OnReleaseCompletion,
                    data: (
                        backmergeAutomation.data?.availableStrategies ?? [
                            AutoBackmergeStrategy.OnReleaseCompletion,
                            AutoBackmergeStrategy.Continuous,
                        ]
                    ).map((strategy) => ({
                        value: strategy,
                        displayValue: displayTextForAutoBackmergeStrategy(strategy),
                    })),
                    rules: [],
                },
                {
                    label: '',
                    name: 'cherryPickOptions',
                    fieldType: FieldType.Custom,
                    rules: [],
                    renderField: () => {
                        return (
                            <Form.Item shouldUpdate noStyle>
                                {(form) => {
                                    const strategy = form.getFieldValue('strategy');
                                    if (strategy !== AutoBackmergeStrategy.ContinuousCherryPick) {
                                        return null;
                                    }
                                    return (
                                        <Space direction="vertical" style={{ width: '100%', marginTop: 12 }} size={16}>
                                            <Form.Item
                                                label="PR types to skip"
                                                name="runwayPRTypesToSkip"
                                                initialValue={backmergeAutomation.data?.runwayPRTypesToSkip ?? []}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Select
                                                    mode="multiple"
                                                    allowClear
                                                    placeholder="Select PR types to skip"
                                                    style={{ width: '100%' }}
                                                >
                                                    {Object.values(PullRequestType).reduce<React.JSX.Element[]>(
                                                        (options, prType) => {
                                                            if (prType === PullRequestType.BackmergeReleaseBranch) {
                                                                return options;
                                                            }
                                                            options.push(
                                                                <Select.Option key={prType} value={prType}>
                                                                    {displayTextForPullRequestType(prType)}
                                                                </Select.Option>,
                                                            );
                                                            return options;
                                                        },
                                                        [],
                                                    )}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                name="shouldBackmergeOnlyMergeCommits"
                                                valuePropName="checked"
                                                initialValue={
                                                    !!backmergeAutomation.data?.shouldBackmergeOnlyMergeCommits
                                                }
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Checkbox>Only backmerge merge commits</Checkbox>
                                            </Form.Item>
                                        </Space>
                                    );
                                }}
                            </Form.Item>
                        );
                    },
                },
                ...generateAssignPrToAutomationFields(backmergeAutomation, { includeFixOwner: true }),
            ];
        }
        case AutomationType.AutoApplyBetaBuildNotes: {
            const buildNotesAutomation = automation as AutomationApplyBetaBuildNotes;
            const currentlySelectedStrategy =
                buildNotesAutomation?.data?.strategy ?? BuildNotesAutomationStrategy.CarryOver;

            return [
                ...baseFields,
                {
                    label: 'Beta notes source:',
                    fieldType: FieldType.Select,
                    style: { wordWrap: 'break-word' },
                    name: 'strategy',
                    initialValue: currentlySelectedStrategy,
                    data: AllBetaBuildNotesStrategies.map((strategy) => {
                        return {
                            value: strategy,
                            displayValue: displayTextForAutoApplyBuildNotesStrategy(strategy),
                        };
                    }),
                    rules: [],
                },
                {
                    label: '',
                    name: 'ciBuildVariableOptions',
                    fieldType: FieldType.Custom,
                    rules: [],
                    renderField: () => (
                        <Form.Item shouldUpdate={(prev, cur) => prev.strategy !== cur.strategy} noStyle>
                            {(form) => {
                                const strategy = form.getFieldValue('strategy') as BuildNotesAutomationStrategy;
                                const strategySupportsFallback =
                                    betaBuildNotesStrategyUsesCIMatchedBuild(strategy) ||
                                    isAIBetaBuildNotesStrategy(strategy);
                                if (!strategySupportsFallback) {
                                    return null;
                                }
                                return (
                                    <Space direction="vertical" style={{ width: '100%' }} size={16}>
                                        {strategy === BuildNotesAutomationStrategy.CIBuildVariable && (
                                            <Form.Item
                                                label="CI build workflow argument"
                                                name="ciBuildVariableKey"
                                                initialValue={buildNotesAutomation.data?.ciBuildVariableKey ?? ''}
                                                preserve={false}
                                                rules={[
                                                    {
                                                        required: true,
                                                        type: 'string',
                                                    },
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input />
                                            </Form.Item>
                                        )}
                                        <Form.Item
                                            label="Fallback beta notes source:"
                                            name="fallbackStrategy"
                                            initialValue={
                                                buildNotesAutomation.data?.fallbackStrategy ??
                                                BuildNotesAutomationStrategy.CarryOver
                                            }
                                            preserve={false}
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select>
                                                {AllBetaBuildNotesStrategies.filter((s) =>
                                                    isSelectableAsBetaBuildNotesFallback(s, strategy),
                                                ).map((strat) => (
                                                    <Select.Option key={strat} value={strat}>
                                                        {displayTextForAutoApplyBuildNotesStrategy(strat)}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Space>
                                );
                            }}
                        </Form.Item>
                    ),
                },
            ];
        }
        case AutomationType.AutoGenerateCIBuildDiffSummary: {
            const diffSummaryAutomation = automation as AutomationGenerateCIBuildDiffSummary;
            return [
                ...baseFields,
                {
                    label: '',
                    data: 'Show summary on the CI step',
                    name: 'showSummaryOnCIStep',
                    fieldType: FieldType.Checkbox,
                    initialValue: diffSummaryAutomation.data?.showSummaryOnCIStep ?? true,
                    rules: [],
                },
                {
                    label: 'Include summary in build notifications',
                    name: 'notificationIdsToInclude',
                    fieldType: FieldType.Select,
                    initialValue: diffSummaryAutomation.data?.notificationIdsToInclude ?? [],
                    data: [
                        { value: AppNotificationType.BuildAvail, displayValue: 'New build available' },
                        {
                            value: AppNotificationType.BuildAvailArtifacts,
                            displayValue: 'New build available with artifacts',
                        },
                    ],
                    rules: [],
                    inputProps: {
                        mode: 'multiple',
                    },
                },
            ];
        }
        case AutomationType.AutoSyncAppStoreUsers: {
            const syncAutomation = automation as AutomationSyncAppStoreUsers;
            const appStoreName = displayConsoleNameForAppStoreType(appStoreType);

            return generateAutoSyncAppStoreUsersFields(
                baseField,
                syncAutomation,
                appStoreName,
                appStoreType,
                Object.values(orgUserGroups),
            );
        }
        case AutomationType.AutoTriggerCIWorkflow: {
            const triggerCIData = (automation as AutomationAutoTriggerCIWorkflow).data;
            const fields: FormFieldData[] = [
                ...baseFields,
                {
                    label: '',
                    name: 'skipIfBuildAlreadyExists',
                    fieldType: FieldType.Checkbox,
                    initialValue: !!triggerCIData?.skipIfBuildAlreadyExists,
                    data: 'Skip execution if a CI build has already been triggered for version',
                },
            ];

            if (useTriggerCIWorkflowConditionGroups) {
                fields.push({
                    name: TRIGGER_CONDITION_GROUPS_FIELD_KEY,
                    fieldType: FieldType.Custom,
                    skipFormItemWrapper: true,
                    data: {
                        formListName: 'conditionGroups',
                        initialValue: triggerCIData?.conditionGroups ?? [],
                    },
                    renderField: ({ formListName, initialValue }) => (
                        <TriggerCIWorkflowConditionGroups
                            orgId={orgId}
                            appId={appId}
                            stepConfigId={automation.stepConfigId}
                            initialGroups={initialValue}
                            formListName={formListName}
                            platform={platform}
                            appStoreType={appStoreType}
                            stepGraphStepsMap={stepGraphStepsMap}
                        />
                    ),
                });
            }

            return fields;
        }
        case AutomationType.AutoCreateIncidents: {
            const createIncidentAutomation = automation as AutomationCreateIncidents;
            const unhealthyTrigger = createIncidentAutomation.data?.unhealthyMetricsTrigger;

            const visibleIncidentMetrics =
                monitoringMetrics?.filter(
                    (item) => !item.hideOnRolloutView || unhealthyTrigger?.monitoringConditions?.includes(item.id),
                ) ?? [];

            const incidentConditionOptions: MonitoringConditionOption[] = automationConditionsForAutomationType(
                automation.type,
                appStoreType,
            ).map((type) => ({ id: type, title: displayTextForAutomationConditionType(type) }));

            const incidentConditionFields: { id: MonitoringAutomationConditionType; threshold: number }[] = [];
            if (unhealthyTrigger?.adoptionThreshold != null) {
                incidentConditionFields.push({
                    id: MonitoringAutomationConditionType.Adoption,
                    threshold: unhealthyTrigger.adoptionThreshold,
                });
            }
            if (unhealthyTrigger?.phasedReleaseDayThreshold != null) {
                incidentConditionFields.push({
                    id: MonitoringAutomationConditionType.PhasedReleaseDay,
                    threshold: unhealthyTrigger.phasedReleaseDayThreshold,
                });
            }
            if (unhealthyTrigger?.stagedRolloutPercentageThreshold != null) {
                incidentConditionFields.push({
                    id: MonitoringAutomationConditionType.StagedRolloutPercentage,
                    threshold: unhealthyTrigger.stagedRolloutPercentageThreshold,
                });
            }

            const appStoreTriggersDisabled = !hasAppStoreIntegration;
            const healthMetricsTriggerDisabled = visibleIncidentMetrics.length === 0;
            const healthMetricsLink = createAppSettingsRouteWithSettingType(
                orgIdParam,
                appIdParam,
                SettingType.HealthMetrics,
            );
            const appStoreTriggerLabel = (label: string): React.ReactNode =>
                appStoreTriggersDisabled ?
                    <Tooltip title="Requires an app store integration">
                        <span>{label}</span>
                    </Tooltip>
                :   label;
            const healthMetricsTriggerLabel = (label: string): React.ReactNode =>
                healthMetricsTriggerDisabled ?
                    <Tooltip
                        title={
                            <span>
                                Requires at least one health metric.{' '}
                                <Link
                                    to={healthMetricsLink}
                                    style={{
                                        color: 'white',
                                        textDecorationLine: 'underline',
                                        textDecorationStyle: 'dotted',
                                        textUnderlineOffset: 3,
                                    }}
                                >
                                    Manage health metrics
                                </Link>
                            </span>
                        }
                    >
                        <span>{label}</span>
                    </Tooltip>
                :   label;
            const atLeastOneTriggerSelectedRule = (form) => ({
                validator: () => {
                    const anyTriggerSelected =
                        (!appStoreTriggersDisabled &&
                            (form.getFieldValue('shouldTriggerOnReviewRejection') ||
                                form.getFieldValue('shouldTriggerOnRolloutHalted'))) ||
                        (!healthMetricsTriggerDisabled && form.getFieldValue('shouldTriggerOnUnhealthyMetrics'));
                    if (!anyTriggerSelected) {
                        return Promise.reject('Select at least one trigger.');
                    }
                    return Promise.resolve();
                },
            });
            const clearAtLeastOneTriggerError = () => {
                form?.setFields([{ name: 'shouldTriggerOnUnhealthyMetrics', errors: [] }]);
            };
            const clearUnhealthyMetricsError = () => {
                form?.setFields([{ name: 'shouldTriggerOnUnhealthyMetrics', errors: [] }]);
            };
            const unhealthyMetricsValidationRule = (form) => ({
                validator: (_, shouldTrigger) => {
                    if (!shouldTrigger || healthMetricsTriggerDisabled) {
                        return Promise.resolve();
                    }
                    const monitoringConditions: { id?: string }[] = form.getFieldValue('monitoringConditions') ?? [];
                    const hasSelectedMetric = monitoringConditions.some((c) => !!c?.id);
                    if (!hasSelectedMetric) {
                        return Promise.reject(
                            'At least one health metric is required to trigger on unhealthy metrics.',
                        );
                    }
                    return Promise.resolve();
                },
            });
            const incidentMetricsInitialValue = (unhealthyTrigger?.monitoringConditions ?? [])
                .filter((id) => visibleIncidentMetrics.find((m) => m.id === id)?.thresholds?.length > 0)
                .map((id) => ({ id }));

            const isIncidentIoScheduling = schedulingIntegration?.id === IntegrationType.IncidentIoScheduling;
            const incidentIoSeverities = (
                (schedulingProvider as IntegrationProviderIncidentIo | null)?.data?.severities ?? []
            ).map((severity) => ({ value: severity.id, displayValue: severity.name }));
            const incidentIoSettings = createIncidentAutomation.data
                ?.integrationSpecificSettings as IncidentIoCreateIncidentsSettings;
            const incidentIoFields: FormFieldData[] =
                isIncidentIoScheduling ?
                    [
                        {
                            label: 'Severity',
                            name: 'incidentIoSeverityId',
                            fieldType: FieldType.Select,
                            initialValue: incidentIoSettings?.severityId ?? null,
                            data: incidentIoSeverities,
                            helpMessage: 'The severity assigned to incidents created on incident.io.',
                            rules: [{ required: true, message: 'Severity is required.' }],
                            style: { marginTop: 16 },
                        },
                    ]
                :   [];

            const isPagerDutyScheduling = schedulingIntegration?.id === IntegrationType.PagerDutyScheduling;
            const pagerDutyServices = (
                (schedulingProvider as IntegrationProviderPagerDuty | null)?.data?.services ?? []
            ).map((service) => ({ value: service.id, displayValue: `${service.name} (${service.id})` }));
            const pagerDutySettings = createIncidentAutomation.data
                ?.integrationSpecificSettings as PagerDutyCreateIncidentsSettings;
            const pagerDutyFields: FormFieldData[] =
                isPagerDutyScheduling ?
                    [
                        {
                            label: 'PagerDuty Service',
                            name: 'pagerDutyServiceId',
                            fieldType: FieldType.Select,
                            initialValue: pagerDutySettings?.serviceId ?? null,
                            data: pagerDutyServices,
                            helpMessage: 'The PagerDuty service that incidents will be created on.',
                            rules: [{ required: true, message: 'PagerDuty Service is required.' }],
                            style: { marginTop: 16 },
                        },
                        {
                            label: 'PagerDuty From Email',
                            name: 'pagerDutyFromEmail',
                            fieldType: FieldType.Input,
                            placeholder: 'Email',
                            initialValue: pagerDutySettings?.fromEmail ?? '',
                            helpMessage:
                                'Email of the PagerDuty user that incidents will be created from. Must be a valid PagerDuty user.',
                            rules: [
                                { required: true, message: 'PagerDuty From Email is required.' },
                                { type: 'email', message: 'Please enter a valid email.' },
                            ],
                        },
                    ]
                :   [];

            return [
                ...baseFields,
                {
                    label: 'Create an incident/alert when...',
                    data: appStoreTriggerLabel('Submission is rejected during app store review'),
                    name: 'shouldTriggerOnReviewRejection',
                    fieldType: FieldType.Checkbox,
                    initialValue:
                        !appStoreTriggersDisabled &&
                        (createIncidentAutomation.data?.reviewRejectionTrigger?.enabled ?? false),
                    rules: [],
                    style: { marginBottom: 0 },
                    disabled: appStoreTriggersDisabled,
                    onChange: clearAtLeastOneTriggerError,
                },
                {
                    label: '',
                    data: appStoreTriggerLabel(
                        `An active ${phasedReleaseDisplayTextForAppStoreType(appStoreType) || 'rollout'} is halted`,
                    ),
                    name: 'shouldTriggerOnRolloutHalted',
                    fieldType: FieldType.Checkbox,
                    initialValue:
                        !appStoreTriggersDisabled &&
                        (createIncidentAutomation.data?.rolloutHaltedTrigger?.enabled ?? false),
                    rules: [],
                    style: { marginTop: 0, marginBottom: 0 },
                    disabled: appStoreTriggersDisabled,
                    onChange: clearAtLeastOneTriggerError,
                },
                {
                    label: '',
                    data: healthMetricsTriggerLabel('One or more health metrics become unhealthy'),
                    name: 'shouldTriggerOnUnhealthyMetrics',
                    fieldType: FieldType.Checkbox,
                    initialValue: unhealthyTrigger?.enabled ?? false,
                    rules: [unhealthyMetricsValidationRule, atLeastOneTriggerSelectedRule],
                    style: { marginTop: 0, marginBottom: 12 },
                    disabled: healthMetricsTriggerDisabled,
                    extraFormItemProps: { validateTrigger: [] },
                    onChange: () => {
                        clearUnhealthyMetricsError();
                        clearAtLeastOneTriggerError();
                    },
                },
                {
                    label: '',
                    name: 'incidentMetricSelector',
                    fieldType: FieldType.Custom,
                    rules: [],
                    style: { marginTop: 0, marginBottom: 0, paddingLeft: 32 },
                    renderField: () => (
                        <Form.Item shouldUpdate noStyle>
                            {(form) => {
                                if (
                                    healthMetricsTriggerDisabled ||
                                    !form.getFieldValue('shouldTriggerOnUnhealthyMetrics')
                                ) {
                                    return null;
                                }
                                const conditionsField = {
                                    ...generateThresholdConditionsField(
                                        'conditions',
                                        'Apply under the following conditions:',
                                        incidentConditionFields,
                                        connectedCapabilities,
                                        incidentConditionOptions,
                                    ),
                                    showDivider: false,
                                };
                                const metricField = {
                                    ...generateMonitoringConditionsField(
                                        'Trigger if any of these health metric conditions are not met:',
                                        unhealthyTrigger?.monitoringConditions ?? [],
                                        false,
                                        'OR',
                                        visibleIncidentMetrics,
                                    ),
                                    showDivider: true,
                                    initialValue: incidentMetricsInitialValue,
                                };
                                return (
                                    <>
                                        {renderFormField(conditionsField)}
                                        {renderFormField(metricField)}
                                        {renderFormField(
                                            generateLinkToHealthMetricsField(
                                                'Constraints for health metrics can be managed from',
                                                healthMetricsLink,
                                            ),
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    ),
                },
                ...incidentIoFields,
                ...pagerDutyFields,
            ];
        }
        case AutomationType.AutoHaltUnstablePhasedReleases:
        case AutomationType.AutoPromoteStablePhasedReleases: {
            return generateAutoHaltOrPromoteFields(
                baseField,
                automation,
                appStoreType,
                connectedCapabilities,
                stabilityIntegrations,
                monitoringMetrics,
                createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.HealthMetrics),
                monitoringChecklistItemTemplates,
                !!isWorkflowsRolloutStepEnabled,
            );
        }
        case AutomationType.AutoStagedRollout: {
            const autoStagedRolloutAutomation = automation as AutomationAutoStagedRollout;
            const initialValue = autoStagedRolloutAutomation?.data?.daysToPercent ?? [];
            const initialTimezone =
                autoStagedRolloutAutomation?.data?.autoStagedRolloutBlackoutTimezone?.trim() ?
                    autoStagedRolloutAutomation.data.autoStagedRolloutBlackoutTimezone?.trim()
                :   dayjs.tz.guess();
            const rawHour = autoStagedRolloutAutomation?.data?.autoStagedRolloutCustomHour;
            const customRolloutHourDefault =
                typeof rawHour === 'number' ?
                    dayjs()
                        .tz(initialTimezone)
                        .set('hour', rawHour)
                        .set('minute', 0)
                        .set('second', 0)
                        .set('millisecond', 0)
                :   undefined;

            const androidRolloutStartStrategiesData = availableAndroidAutoRolloutStartStrategiesForStoreType(
                appStoreType,
            ).map((strategy) => {
                const displayText = displayTextForAndroidAutoRolloutStartStrategy(strategy, appStoreType);

                return {
                    value: strategy,
                    displayValue: displayText,
                };
            });

            const shouldAllowCustomizedRollouts =
                appStoreType === AppStoreType.Google || appStoreType === AppStoreType.Huawei;

            const shouldShowRolloutStartStrategy = !(
                appStoreType === AppStoreType.Google && isPlayReleaseLifecycleEnabled
            );

            return [
                ...baseFields,
                ...(shouldAllowCustomizedRollouts ?
                    [
                        {
                            name: 'daysToPercent',
                            fieldType: FieldType.List,
                            initialValue,
                            rules: [
                                {
                                    validator: async (_, values) => {
                                        if (!values || values?.length === 0) {
                                            return Promise.reject(new Error('Percentages need at least 1 day'));
                                        }
                                        if (values.length === 1) {
                                            return Promise.resolve();
                                        }
                                        const numericValues = values.map((value) => Number(value));
                                        for (let i = 0; i < values.length; i++) {
                                            if (numericValues[i - 1] > numericValues[i]) {
                                                return Promise.reject(
                                                    new Error('Percentages must increase over rollout'),
                                                );
                                            }
                                        }
                                        if (numericValues.includes(0)) {
                                            return Promise.reject(new Error('Percentages must be greater than 0'));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ],
                            listChildrenWrapper: (children, _, { errors }) => {
                                return (
                                    <Space
                                        direction="vertical"
                                        style={{
                                            width: '100%',
                                        }}
                                        size={16}
                                    >
                                        <Form.Item
                                            label="Number of days"
                                            rules={[{ required: true }]}
                                            required
                                            shouldUpdate
                                        >
                                            {(form) => {
                                                return (
                                                    <Select
                                                        defaultValue={initialValue.length}
                                                        style={{ width: 120 }}
                                                        onChange={(value) => {
                                                            const selectedDays = Math.trunc(value);
                                                            const sequence = [...DEFAULT_ROLLOUT_SEQUENCE].reverse();
                                                            const updatedSequence = [];

                                                            [...Array(selectedDays)].forEach((_, i) => {
                                                                updatedSequence.push(sequence[selectedDays - i - 1]);
                                                            });

                                                            form.setFieldsValue({
                                                                daysToPercent: updatedSequence,
                                                            });
                                                        }}
                                                    >
                                                        {[...DEFAULT_ROLLOUT_SEQUENCE].slice(1).map((_, i) => {
                                                            const day = i + 2;
                                                            return (
                                                                <Select.Option value={day} key={i}>
                                                                    {day}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                );
                                            }}
                                        </Form.Item>
                                        <Form.Item shouldUpdate noStyle>
                                            {(form) => {
                                                const daysToPercent = form.getFieldValue('daysToPercent');
                                                if (!daysToPercent || daysToPercent.length === 0) {
                                                    return null;
                                                }
                                                return (
                                                    <Form.Item
                                                        label="Rollout percentage per day"
                                                        required
                                                        style={{
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: 'grid',
                                                                gridTemplateColumns: `repeat(3, 1fr)`,
                                                            }}
                                                        >
                                                            {children}
                                                        </div>
                                                    </Form.Item>
                                                );
                                            }}
                                        </Form.Item>
                                        <div
                                            style={{
                                                color: runwayColors.statusRed,
                                            }}
                                        >
                                            <Form.ErrorList errors={errors?.errors} />
                                        </div>
                                    </Space>
                                );
                            },
                            nestedListFields: [
                                {
                                    fieldType: FieldType.Custom,
                                    renderField: ({ index, listFieldData }) => {
                                        const day = index + 1;
                                        return (
                                            <Space size={6}>
                                                <Text>Day {day}</Text>
                                                <Form.Item
                                                    noStyle
                                                    validateTrigger="onSubmit"
                                                    {...listFieldData}
                                                    style={{
                                                        marginBottom: 8,
                                                    }}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: `Day ${day} is required `,
                                                        },
                                                        {
                                                            validator(_rule, value) {
                                                                if (value === 0 || value > 100) {
                                                                    return Promise.reject();
                                                                }

                                                                return Promise.resolve();
                                                            },
                                                            message:
                                                                'Staged rollout percentage must be greater than zero and less than or equal to 100. Up to 6 decimal points are allowed.',
                                                        },
                                                    ]}
                                                    hasFeedback={false}
                                                >
                                                    <AndroidStagedRolloutPercentageInput
                                                        style={{
                                                            width: 140,
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Space>
                                        );
                                    },
                                },
                            ],
                        },
                        ...(shouldShowRolloutStartStrategy ?
                            [
                                {
                                    label: 'Rollout start strategy',
                                    name: 'autoStagedRolloutStartStrategy',
                                    showsDivider: true,
                                    helpMessage:
                                        appStoreType == AppStoreType.Google ?
                                            <Text type="secondary">
                                                Teams who have managed publishing enabled in Play Console or
                                                consistently get pulled for long reviews by Google should not choose the
                                                &apos;Start automatically on submission&apos; option. For more info on
                                                this setting and store email forwarding, see our{' '}
                                                <Typography.Link
                                                    href={
                                                        'https://docs.runway.team/automations/types-of-automations#rollout-start-strategy'
                                                    }
                                                    target="_blank"
                                                >
                                                    docs.
                                                </Typography.Link>
                                            </Text>
                                        :   null,
                                    fieldType: FieldType.Select,
                                    initialValue:
                                        autoStagedRolloutAutomation.data?.autoStagedRolloutStartStrategy ??
                                        AndroidAutoRolloutStartStrategy.Manual,
                                    data: androidRolloutStartStrategiesData,
                                    rules: [],
                                },
                            ]
                        :   []),
                    ]
                :   []),
                {
                    fieldType: FieldType.Select,
                    initialValue:
                        autoStagedRolloutAutomation.data?.autoStagedRolloutBlackoutTimezone || dayjs.tz.guess(),
                    inputProps: {
                        showSearch: true,
                        allowClear: true,
                    },
                    name: 'autoStagedRolloutBlackoutTimezone',
                    data: Intl.supportedValuesOf('timeZone').map((timezone) => {
                        return {
                            value: timezone,
                            displayValue: `${timezone} (${dayjs().tz(timezone).format('z')})`,
                        };
                    }),
                    rules: [
                        (form) => ({
                            validator: async (_, value) => {
                                const autoStagedRolloutBlackoutSegmentsByDay = form.getFieldValue(
                                    'autoStagedRolloutBlackoutSegmentsByDay',
                                ) as AutoStagedRolloutBlackoutSegmentsByDay;

                                const hasAtLeastOneBlackout = Object.values(
                                    autoStagedRolloutBlackoutSegmentsByDay,
                                ).some((day) => day.isBlackedOut);

                                if (!hasAtLeastOneBlackout) {
                                    return Promise.resolve(); // no blackouts, then this field is not required
                                }

                                if (!value) {
                                    return Promise.reject(new Error('Please select a timezone'));
                                }

                                if (Intl.supportedValuesOf('timeZone').includes(value)) {
                                    return Promise.resolve();
                                } else {
                                    return Promise.reject(new Error('Invalid timezone'));
                                }
                            },
                        }),
                    ],
                    showDivider: true,
                    label: 'Timezone',
                    helpMessage: `Choose the timezone for your blackout periods${shouldAllowCustomizedRollouts ? ' and the hour at which your rollout should be incremented' : ''}. Your browser's current timezone is ${dayjs.tz.guess()}.`,
                },
                shouldAllowCustomizedRollouts && {
                    fieldType: FieldType.Custom,
                    name: 'autoStagedRolloutCustomHour',
                    initialValue: customRolloutHourDefault,
                    label: 'Update staged rollout percentage at',
                    helpMessage:
                        'Runway will update the staged rollout percentage each day at the specified hour. If not set, the staged rollout will be updated every 24 hours starting from the time at which the rollout was started.',
                    inputProps: {
                        showSearch: true,
                        allowClear: true,
                    },
                    renderField: () => {
                        return (
                            <TimePicker
                                defaultValue={customRolloutHourDefault}
                                use12Hours
                                format="h A"
                                style={{ width: '100%' }}
                            />
                        );
                    },
                },
                ...(shouldAllowCustomizedRollouts ?
                    [
                        {
                            fieldType: FieldType.Checkbox,
                            name: 'shouldAccountBlackoutsForHoursSinceLastIncrement',
                            initialValue:
                                autoStagedRolloutAutomation.data?.shouldAccountBlackoutsForHoursSinceLastIncrement ??
                                false,
                            data: 'Include time passed during blackout period towards overall time in between rollout increments',
                        },
                        {
                            fieldType: FieldType.Checkbox,
                            name: 'shouldAccountHaltedPeriodsForHoursSinceLastIncrement',
                            initialValue:
                                autoStagedRolloutAutomation.data
                                    ?.shouldAccountHaltedPeriodsForHoursSinceLastIncrement ?? true,
                            data: 'Include time passed during halted period towards overall time in between rollout increments',
                        },
                        {
                            fieldType: FieldType.Checkbox,
                            name: 'shouldContinueIncrementingAfterManualUpdate',
                            initialValue:
                                autoStagedRolloutAutomation.data?.shouldContinueIncrementingAfterManualUpdate ?? true,
                            data: checkboxLabelWithTooltip(
                                'Continue incrementing rollout even when rollout percentage is manually updated (in Runway or externally)',
                                continueIncrementingAfterManualUpdateTooltip,
                            ),
                        },
                    ]
                :   []),
                {
                    fieldType: FieldType.Custom,
                    showDivider: false,
                    renderField: () => {
                        return shouldAllowCustomizedRollouts ?
                                <Text>
                                    Specify <strong>blackout days</strong> (and optionally, windows of time) for your
                                    staged rollout. Your staged rollout <strong>will not be incremented</strong>{' '}
                                    automatically by Runway during blackout days or hours.
                                </Text>
                            :   <Text>
                                    Specify <strong>blackout days</strong> (and optionally, windows of time) for your
                                    phased rollout. Your phased rollout <strong>will be paused</strong> automatically by
                                    Runway during blackout days or hours.
                                </Text>;
                    },
                },
                {
                    fieldType: FieldType.Custom,
                    initialValue: decodeAutoStagedRolloutBlackoutSegmentsByDay(
                        autoStagedRolloutAutomation.data?.autoStagedRolloutBlackoutSegmentsByDay,
                    ),
                    name: 'autoStagedRolloutBlackoutSegmentsByDay',
                    extraFormItemProps: {
                        name: undefined, // this will override the name in the field which fixes a bug with checkbox overriding the whole object value
                    },
                    showDivider: false,
                    renderField: () => {
                        return (
                            <Space
                                direction="vertical"
                                style={{
                                    width: '100%',
                                    marginTop: 16,
                                }}
                                split={
                                    <Divider
                                        style={{
                                            margin: '8px 0',
                                        }}
                                    />
                                }
                            >
                                {AllDaysOfTheWeek.map((day) => (
                                    <React.Fragment key={day}>
                                        {generateDayRow('autoStagedRolloutBlackoutSegmentsByDay', day)}
                                    </React.Fragment>
                                ))}
                            </Space>
                        );
                    },
                },
            ];
        }
        case AutomationType.AutoUploadBinaryArtifactToAppStore: {
            if (!artifactUploadOptions) {
                return [];
            }
            const isCustomCI = artifactUploadOptions?.buildSystem?.id === IntegrationType.CustomCI;
            const buildSystemData = artifactUploadOptions.buildSystem?.data as BaseCIIntegrationData;
            let workflowName: string;
            let prodWorkflowName: string;
            if (buildSystemData) {
                workflowName = buildSystemData.workflowName;
                prodWorkflowName = buildSystemData.prodWorkflowName;
            }

            if (
                connectedCapabilities.includes(IntegrationCapability.BuildSystem) &&
                buildSystemData &&
                (workflowName || prodWorkflowName || isCustomCI) &&
                artifactUploadOptions.appIdentifiers.size > 0
            ) {
                return generateAutoUploadBinaryArtifactToAppStoreFields(
                    baseField,
                    automation,
                    platform,
                    appStoreType,
                    artifactUploadOptions.destinationOptions,
                    buildSystemData,
                    isCustomCI,
                );
            } else {
                return [
                    {
                        ...baseField,
                        disabled: true,
                    },
                    {
                        name: 'ciCdMessage',
                        showDivider: true,
                        fieldType: FieldType.Custom,
                        renderField: () => {
                            const platformIdentifier = identifierForAppPlatform(platform);
                            // default message for null buildSystemData or no workflows configured
                            let message =
                                'A Release Candidate or production workflow must be configured in order to enable this automation. Configure workflows by visiting CI/CD integration settings.';
                            if (artifactUploadOptions.appIdentifiers.size == 0 && !workflowName && !prodWorkflowName) {
                                message = `At least one workflow and either a Beta Testing or App Store ${platformIdentifier} must be configured in order to enable this automation. Configure by visiting CI/CD and Beta and/or App Store integration settings.`;
                            } else if (artifactUploadOptions.appIdentifiers.size == 0) {
                                message = `A Beta Testing or App Store ${platformIdentifier} must be configured in order to enable this automation. Configure by visiting Beta and/or App Store integration settings.`;
                            }
                            return <Text style={{ color: antGrey.grey7 }}>{message}</Text>;
                        },
                    },
                ];
            }
        }
        case AutomationType.AutoUploadDsymsToStabilityMonitoring: {
            if (!dsymsUploadOptions) {
                return [];
            }
            const isCustomCI = dsymsUploadOptions.buildSystem?.id === IntegrationType.CustomCI;
            const buildSystemData = dsymsUploadOptions.buildSystem?.data as BaseCIIntegrationData;
            let workflowName: string;
            let prodWorkflowName: string;
            if (buildSystemData) {
                workflowName = buildSystemData.workflowName;
                prodWorkflowName = buildSystemData.prodWorkflowName;
            }

            const stabilityMonitoring = dsymsUploadOptions.stabilityMonitoring
                ?.data as BaseStabilityMonitoringIntegrationData;

            if (
                connectedCapabilities.includes(IntegrationCapability.BuildSystem) &&
                buildSystemData &&
                (workflowName || prodWorkflowName || isCustomCI) &&
                stabilityMonitoring != null
            ) {
                return generateAutoUploadDsymsToStabilityMonitoringFields(
                    baseField,
                    automation,
                    buildSystemData,
                    automation.dsymUploadDestinationOptions ?? [],
                );
            } else {
                return [
                    {
                        ...baseField,
                        disabled: true,
                    },
                    {
                        name: 'ciCdMessage',
                        showDivider: true,
                        fieldType: FieldType.Custom,
                        renderField: () => {
                            // default message for null buildSystemData or no workflows configured
                            let message =
                                'A Release Candidate or production workflow must be configured in order to enable this automation. Configure workflows by visiting CI/CD integration settings.';
                            if (!stabilityMonitoring && !workflowName && !prodWorkflowName) {
                                message = `At least one workflow and a stability monitoring integration must be configured in order to enable this automation. Configure by visiting CI/CD and stability monitoring integration settings.`;
                            } else if (!stabilityMonitoring) {
                                message = `A stability monitoring integration must be configured in order to enable this automation. Configure by visiting stability monitoring integration settings.`;
                            }
                            return <Text style={{ color: antGrey.grey7 }}>{message}</Text>;
                        },
                    },
                ];
            }
        }
        case AutomationType.AutoCherryPickFromWorkingBranch: {
            const cherryPickAutomation = automation as AutomationCherryPickFromWorkingBranch;
            return [
                ...baseFields,
                {
                    label: 'Pull over fixes...',
                    name: 'strategy',
                    fieldType: FieldType.Custom,
                    initialValue: cherryPickStrategyState,
                    data: AllAutoCherryPickStrategies,
                    rules: [{ required: true, message: 'Please select how fixes should be pulled over' }],
                    helpMessage: cherryPickStrategyHelpMessage,
                    renderField: (data: AutoCherryPickStrategy[]) => {
                        return (
                            <Select style={{ width: '100%' }} onChange={onSelectCherryPickStrategyState}>
                                {data.map((strategy) => {
                                    return (
                                        <Select.Option value={strategy} key={strategy}>
                                            {`...${displayTextForAutoCherryPickStrategy(strategy)}`}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        );
                    },
                },
                {
                    label: '',
                    data: checkboxLabelWithTooltip(
                        'Require fix approval before performing cherry-pick',
                        `Fixes must be approved in Runway before they can be automatically cherry-picked. 'Fix approvals' must be enabled from App settings > General > Fixes.`,
                    ),
                    name: 'requiresFixApprovalToCherryPick',
                    fieldType: FieldType.Checkbox,
                    initialValue: cherryPickAutomation.data?.requiresFixApprovalToCherryPick ?? false,
                    disabled: !requiresFixRequestsApprovals,
                    rules: [],
                },
                {
                    label: '',
                    data: 'Notify the original author when a PR has been cherry-picked',
                    name: 'shouldNotifyPRAuthors',
                    fieldType: FieldType.Checkbox,
                    initialValue: cherryPickAutomation.data?.shouldNotifyPRAuthors ?? false,
                    rules: [],
                },
                ...(vcsSupportsPRComments ?
                    [
                        {
                            label: '',
                            data: checkboxLabelWithTooltip(
                                'Skip posting PR comments on cherry-pick success',
                                'By default Runway comments on the original pull-request once its commits have been cherry-picked. Check this to stop posting that comment.',
                            ),
                            name: 'skipPostingPRCommentsOnCherryPickSuccess',
                            fieldType: FieldType.Checkbox,
                            initialValue: cherryPickAutomation.data?.skipPostingPRCommentsOnCherryPickSuccess ?? false,
                            rules: [],
                        },
                        {
                            label: '',
                            data: checkboxLabelWithTooltip(
                                'Skip posting PR comments on cherry-pick merge conflicts',
                                'By default Runway comments on the original pull-request when a cherry-pick hits a merge conflict. Check this to stop posting that comment.',
                            ),
                            name: 'skipPostingPRCommentsOnCherryPickMergeConflicts',
                            fieldType: FieldType.Checkbox,
                            initialValue:
                                cherryPickAutomation.data?.skipPostingPRCommentsOnCherryPickMergeConflicts ?? false,
                            rules: [],
                        },
                    ]
                :   []),
                ...buildAutoCherryPickTokenFields(
                    'allowFixesWithToken',
                    'tokens',
                    'matchTokenOn',
                    cherryPickAutomation.data,
                ),
                ...generateAssignPrToAutomationFields(cherryPickAutomation, { includeFixOwner: true }),
            ];
        }

        case AutomationType.AutoSyncAppleDevices: {
            const syncAutomation = automation as AutomationAutoSyncAppleDevices;

            return [
                ...baseFields,
                {
                    label: `Register devices for app users in Runway user groups`,
                    name: 'autoSyncAppleDevicesPossibleUserGroups',
                    fieldType: FieldType.Select,
                    initialValue: syncAutomation.data?.autoSyncAppleDevicesPossibleUserGroups ?? [],
                    data: Object.values(orgUserGroups)
                        .filter((group) => !group.disabled)
                        .map((group) => {
                            return {
                                value: group.id,
                                displayValue: displayTextForUserGroup(group),
                            };
                        }),
                    required: false,
                    rules: [],
                    helpMessage: `Only devices associated with users that have one of the selected user groups will be synced. Leave blank to sync devices for all app users`,
                    inputProps: {
                        mode: 'multiple',
                    },
                },
                {
                    label: '',
                    data: `Include test devices`,
                    helpMessage: `Runway will sync devices that have been added to the app as test devices`,
                    name: 'autoSyncAppleDevicesShouldIncludeTestDevices',
                    fieldType: FieldType.Checkbox,
                    initialValue: syncAutomation.data?.autoSyncAppleDevicesShouldIncludeTestDevices ?? true,
                    rules: [],
                },
                {
                    label: '',
                    data: `Disable devices for users that are removed from apps in Runway`,
                    name: 'autoSyncAppleDevicesShouldDisableDevices',
                    fieldType: FieldType.Checkbox,
                    initialValue: syncAutomation.data?.autoSyncAppleDevicesShouldDisableDevices ?? true,
                    rules: [],
                },
            ];
        }
        case AutomationType.AutoSyncAppleProvisioningProfilesDevices: {
            const syncAutomation = automation as AutomationAutoSyncAppleProvisioningProfilesDevices;

            return [
                ...baseFields,
                {
                    label: `Profile types`,
                    name: 'autoSyncAppleProvisioningProfilesDevicesProfileTypes',
                    fieldType: FieldType.Select,
                    initialValue: syncAutomation.data?.autoSyncAppleProvisioningProfilesDevicesProfileTypes ?? [],
                    data: syncableProvisioningProfileTypesForPlatform(platform).map((type) => {
                        return {
                            value: type,
                            displayValue: displayTextForProvisioningProfileTypeWithPlatform(type),
                        };
                    }),
                    required: true,
                    rules: [
                        {
                            validator: (_, value) => {
                                if (value.length === 0) {
                                    return Promise.reject('Please select at least one profile type');
                                }
                                return Promise.resolve();
                            },
                        },
                    ],
                    helpMessage: `Runway will sync the associated devices of selected profile types only`,
                    inputProps: {
                        mode: 'multiple',
                    },
                },
                {
                    label: `User groups`,
                    name: 'autoSyncAppleProvisioningProfilesDevicesUserGroups',
                    fieldType: FieldType.Select,
                    initialValue: syncAutomation.data?.autoSyncAppleProvisioningProfilesDevicesUserGroups ?? [],
                    data: Object.values(orgUserGroups)
                        .filter((group) => !group.disabled)
                        .map((group) => {
                            return {
                                value: group.id,
                                displayValue: displayTextForUserGroup(group),
                            };
                        }),
                    required: false,
                    rules: [],
                    helpMessage: `Runway will only sync the devices of app users with at least one of the selected user groups. Leave blank to sync devices for all app users.`,
                    inputProps: {
                        mode: 'multiple',
                    },
                },
                {
                    label: '',
                    data: `Remove devices for users that are removed from apps in Runway`,
                    name: 'autoSyncAppleProvisioningProfilesDevicesShouldRemoveDevices',
                    fieldType: FieldType.Checkbox,
                    initialValue:
                        syncAutomation.data?.autoSyncAppleProvisioningProfilesDevicesShouldRemoveDevices ?? true,
                    rules: [],
                },
            ];
        }
        case AutomationType.AutoSelectLatestBuild: {
            const autoSelectLatestBuildAutomation = automation as AutomationAutoSelectLatestBuild;
            const autoSelectTrack = autoSelectLatestBuildAutomation.data?.track;
            const shouldRenderRegressionStepsToConsiderField =
                autoSelectLatestBuildStrategy == AutoSelectLatestBuildStrategy.LatestPassedRegression &&
                regressionTestStepConfigIds.length > 1;
            return [
                ...baseFields,
                {
                    label: 'Build selection preference:',
                    name: 'strategy',
                    fieldType: FieldType.Select,
                    data: Object.values(getAutoSelectLatestBuildStrategyFieldData(appStoreType)),
                    placeholder: '',
                    initialValue: autoSelectLatestBuildStrategy,
                    rules: [{ required: true }],
                    onChange: (e) => {
                        setAutoSelectLatestBuildStrategy(e);
                    },
                },
                shouldRenderRegressionStepsToConsiderField && {
                    fieldType: FieldType.Custom,
                    data: {
                        selectedStepConfigIds: regressionStepsToConsider,
                        regressionTestStepConfigs,
                        regressionTestStepConfigIds,
                    },
                    renderField: (data) => {
                        return (
                            <Form.Item
                                label="Regression test step(s) to include:"
                                name="regressionStepsToConsider"
                                rules={[{ required: true }]}
                                initialValue={data.selectedStepConfigIds}
                                tooltip={{
                                    title: (
                                        <Text style={{ color: runwayColors.white }}>
                                            The selected step(s) must all have a passing build in order for the build to
                                            be auto-selected.
                                        </Text>
                                    ),
                                    icon: (
                                        <Space style={{ marginLeft: 8 }}>
                                            <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                                        </Space>
                                    ),
                                }}
                            >
                                <Select
                                    style={{ width: '100%' }}
                                    allowClear
                                    mode="multiple"
                                    placeholder="No regression test steps selected"
                                    onChange={(value) => setRegressionStepsToConsider(value)}
                                >
                                    {Object.values(data.regressionTestStepConfigIds).map((configId: string) => (
                                        <Select.Option value={configId} key={configId}>
                                            {data.regressionTestStepConfigs[configId].stepName}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        );
                    },
                },
                isGooglePlatform(platform) && {
                    label: 'Only select APK/AABs that are already available on the following track',
                    name: 'track',
                    fieldType: FieldType.Input,
                    helpMessage: "Optional. Choose from 'alpha', 'beta', 'internal', or another custom track",
                    initialValue: autoSelectTrack,
                },
                appStoreType === AppStoreType.Google && {
                    name: 'updateTrackReleaseWithPatternedName',
                    fieldType: FieldType.Custom,
                    initialValue: autoSelectLatestBuildAutomation.data?.updateTrackReleaseWithPatternedName,
                    renderField: () => (
                        <Form.Item
                            label="Update track release with name"
                            name="updateTrackReleaseWithPatternedName"
                            style={{ marginBottom: 0 }}
                            extra="Optional. Update the track release name each time an APK/AAB is auto-selected. You should only use this if your track release name changes per build, for example if you want the name to contain build number in addition to release version."
                            rules={[
                                {
                                    validator: (rule, value) => {
                                        if (!value) {
                                            return Promise.resolve();
                                        }

                                        const pattern = value as string;

                                        return validatePattern(
                                            pattern,
                                            'Release name',
                                            RequireAtLeastOneOfTokensForAndroidTrackReleaseName,
                                            disallowedTokensForForAndroidTrackReleaseName(),
                                        );
                                    },
                                },
                            ]}
                        >
                            <Input placeholder="e.g. {version}.{appStoreBuildNumber}" autoComplete="off" allowClear />
                        </Form.Item>
                    ),
                },
                {
                    data: 'Only run this automation when there is a match between an App store build and CI build',
                    name: 'shouldRequireBuildMatch',
                    fieldType: FieldType.Checkbox,
                    initialValue: autoSelectLatestBuildAutomation.data?.shouldRequireBuildMatch ?? false,
                    rules: [],
                },
            ].filter(Boolean);
        }
        case AutomationType.AutoPullSubmissionFromReview: {
            const pullSubmissionAutomation = automation as AutomationPullSubmissionFromReview;
            const atLeastOneTriggerSelectedRule = (form) => ({
                validator: () => {
                    const anyTriggerSelected =
                        form.getFieldValue('pullOnReleaseSkipped') ||
                        form.getFieldValue('pullOnFixOrFixRequestAccepted');
                    if (!anyTriggerSelected) {
                        return Promise.reject('Select at least one trigger.');
                    }
                    return Promise.resolve();
                },
            });
            const clearAtLeastOneTriggerError = () => {
                form?.setFields([{ name: 'pullOnFixOrFixRequestAccepted', errors: [] }]);
            };
            return [
                ...baseFields,
                {
                    label: 'Pull a submission from review if...',
                    data: 'The release is skipped',
                    name: 'pullOnReleaseSkipped',
                    fieldType: FieldType.Checkbox,
                    initialValue: pullSubmissionAutomation.data?.pullOnReleaseSkipped ?? false,
                    rules: [],
                    style: { marginBottom: 0 },
                    onChange: clearAtLeastOneTriggerError,
                },
                {
                    label: '',
                    data: 'A fix is added / fix request is approved',
                    name: 'pullOnFixOrFixRequestAccepted',
                    fieldType: FieldType.Checkbox,
                    initialValue: pullSubmissionAutomation.data?.pullOnFixOrFixRequestAccepted ?? false,
                    rules: [atLeastOneTriggerSelectedRule],
                    style: { marginTop: 0, marginBottom: 0 },
                    onChange: clearAtLeastOneTriggerError,
                    extraFormItemProps: { validateTrigger: [] },
                },
            ];
        }
        case AutomationType.AutoSubmitRelease: {
            const submitReleaseAutomation = automation as AutomationAutoSubmitRelease;
            const shouldShowReleaseToFullPercentageCheckboxOption =
                isGooglePlatform(platform) && isGoogleBetaIntegration(betaTesting?.id);

            const helpMessage = helperTextForAutoSubmitStrategy(autoSubmitStrategy, appStoreType);
            const warningMessage = warningTextForAutoSubmitStrategy(autoSubmitStrategy, appStoreType);

            const baseFieldAndSubmitField: FormFieldData[] = [
                ...baseFields,
                {
                    label: 'Submit for review:',
                    fieldType: FieldType.Custom,
                    style: { wordWrap: 'break-word' },
                    name: 'submitStrategy',
                    initialValue: autoSubmitStrategy,
                    helpMessage:
                        warningMessage ?
                            <>
                                {' '}
                                <div
                                    style={{
                                        color: antGrey.grey7,
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        maxWidth: '100%',
                                    }}
                                >
                                    {helpMessage}
                                </div>
                                <Text
                                    style={{
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        maxWidth: '100%',
                                    }}
                                    type="warning"
                                >
                                    {warningMessage}
                                </Text>
                            </>
                        :   helpMessage,
                    renderField: (data) => {
                        return (
                            <Select style={{ width: '100%' }} onChange={(value) => onSelectAutoSubmitStrategy(value)}>
                                {data.map((option) => {
                                    return (
                                        <Select.Option value={option.value} key={option.value}>
                                            {option.displayValue}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        );
                    },
                    data: AllAutoSubmitStrategies.map((strategy) => {
                        return {
                            value: strategy,
                            displayValue: displayTextForAutoSubmitStrategy(strategy),
                        };
                    }),
                    rules: [],
                },
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    submitReleaseAutomation,
                    appId,
                    platform,
                    appStoreType,
                    {
                        fieldKeyPrefix: 'primaryRequiredSteps',
                        submitStrategyFieldName: 'submitStrategy',
                        shouldUseCustomRequiredStepsFieldName: 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix: ['customRequiredSteps'],
                        releaseTypesFieldName: 'primaryReleaseTypes',
                        shouldUseCustomRequiredStepsInitialValue:
                            submitReleaseAutomation.data?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: submitReleaseAutomation.data?.customRequiredSteps,
                    },
                ),
                // For app stores that support phased release (e.g., Google, Huawei) but do not support auto-release,
                // we show the checkbox in the auto-submit automation (not auto-release).
                ...(hasSupportForPhasedRelease(appStoreType) && !hasSupportForAutoRelease(appStoreType) ?
                    [buildPreviousReleaseRolloutFields('auto-submit', submitReleaseAutomation.data, form)]
                :   []),
            ];

            if (shouldShowReleaseToFullPercentageCheckboxOption) {
                const testingTrack = (betaTesting as IntegrationGoogleBeta)?.data?.testingTrack;

                const BoldText = ({ text }) => <strong>{text}</strong>;
                BoldText.propTypes = {
                    text: PropTypes.string.isRequired,
                };
                const betaTrackName = testingTrack ? <BoldText text={testingTrack} /> : 'default beta';

                const data = (
                    <>
                        {'Release to 100% on the '}
                        {betaTrackName}
                        {' track prior to submission'}
                    </>
                );
                return [
                    ...baseFieldAndSubmitField,
                    {
                        label: '',
                        data: data,
                        name: 'shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission',
                        fieldType: FieldType.Checkbox,
                        initialValue:
                            submitReleaseAutomation.data?.shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission ??
                            false,
                        rules: [],
                    },
                ];
            }

            return baseFieldAndSubmitField;
        }
        case AutomationType.AutoRelease: {
            const autoReleaseAutomation = automation as AutomationAutoRelease;
            const currentlySelectedStrategy = autoReleaseAutomation?.data?.strategy ?? AutoReleaseStrategy.OnDate;
            return [
                ...baseFields,
                {
                    label: 'Release:',
                    fieldType: FieldType.Select,
                    style: { wordWrap: 'break-word' },
                    name: 'strategy',
                    initialValue: currentlySelectedStrategy,
                    data: AllAutoReleaseStrategies.map((strategy) => {
                        return {
                            value: strategy,
                            displayValue: displayTextForAutoReleaseStrategy(strategy),
                        };
                    }),
                    rules: [],
                },
                ...buildAutoReleaseAndAutoSubmitRequiredStepsFields(
                    autoReleaseAutomation,
                    appId,
                    platform,
                    appStoreType,
                    {
                        fieldKeyPrefix: 'primaryRequiredSteps',
                        submitStrategyFieldName: 'strategy',
                        shouldUseCustomRequiredStepsFieldName: 'shouldUseCustomRequiredSteps',
                        customRequiredStepsFieldNamePrefix: ['customRequiredSteps'],
                        releaseTypesFieldName: 'primaryReleaseTypes',
                        shouldUseCustomRequiredStepsInitialValue:
                            autoReleaseAutomation.data?.shouldUseCustomRequiredSteps,
                        customRequiredStepsInitialValue: autoReleaseAutomation.data?.customRequiredSteps,
                    },
                ),
                // We only show the checkbox for auto-release if the app store supports it
                ...(hasSupportForAutoRelease(appStoreType) ?
                    [buildPreviousReleaseRolloutFields('auto-release', autoReleaseAutomation.data, form)]
                :   []),
            ];
        }
        case AutomationType.AutoCreateReleaseChannels: {
            const autoCreateReleaseChannels = automation as AutomationAutoCreateReleaseChannels;
            const autoArchiveChannelConfig = {
                label: '',
                data: (
                    <div>
                        Archive release channels when the release rollout is complete
                        <Tooltip title="Release-specific channels will be automatically archived once the release is rolled out to 100% of users.">
                            <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                        </Tooltip>
                    </div>
                ),
                initialValue: autoCreateReleaseChannels.data?.archiveChannelsWhenReleaseCompleted ?? false,
                name: 'archiveChannelsWhenReleaseCompleted',
                fieldType: FieldType.Checkbox,
                rules: [],
            };

            const autoAddUsersConfig = {
                label: 'Auto-add users',
                initialValue: autoCreateReleaseChannels.data?.inviteUsers ?? [],
                data: appUsers.map((user) => {
                    return user.email;
                }),
                name: 'inviteUsers',
                fieldType: FieldType.Custom,

                renderField: (data: string[]) => {
                    return (
                        <Select style={{ width: '100%' }} allowClear mode="multiple" placeholder="Select">
                            {data.map((email, index) => {
                                return (
                                    <Select.Option value={email} key={index}>
                                        {email}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    );
                },
                rules: [],
            };

            const autoAddGroupsConfig = {
                label: 'Auto-add user groups',
                initialValue: autoCreateReleaseChannels.data?.inviteGroups ?? [],
                data: Object.keys(orgUserGroups),
                name: 'inviteGroups',
                fieldType: FieldType.Custom,

                renderField: (data: UserGroupId[]) => {
                    return (
                        <Select style={{ width: '100%' }} allowClear mode="multiple" placeholder="Select">
                            {data.map((groupId, index) => {
                                const group = orgUserGroups[groupId];
                                return (
                                    <Select.Option value={groupId} key={index}>
                                        {displayTextForUserChecklistGroup(group)}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    );
                },
                rules: [],
            };

            if (!notificationsProvider || notificationsProvider.type !== IntegrationProviderType.AzureActiveDirectory) {
                return [...baseFields, autoArchiveChannelConfig, autoAddUsersConfig, autoAddGroupsConfig];
            }

            const teamsProvider = notificationsProvider as IntegrationProviderAzureActiveDirectory;
            const teamId = autoCreateReleaseChannels.data?.teamId;
            const channelLayoutType =
                autoCreateReleaseChannels.data?.channelLayoutType || MicrosoftTeamsChannelLayoutType.Post;
            const channelMembershipType =
                autoCreateReleaseChannels.data?.channelMembershipType || MicrosoftTeamsChannelMembershipType.Standard;
            return [
                ...baseFields,
                {
                    label: (
                        <span>
                            Team
                            <span style={{ marginLeft: 4 }}>
                                <TooltipInfoIcon tooltipContent="The Team that new release channels will be created in" />
                            </span>
                        </span>
                    ),
                    initialValue: teamId,
                    data: teamsProvider.data?.availableTeams ?? [],
                    name: 'teamId',
                    fieldType: FieldType.Custom,
                    renderField: (data: AzureActiveDirectoryTeam[]) => {
                        return (
                            <Select style={{ width: '100%' }}>
                                {data.map((team) => {
                                    return (
                                        <Select.Option value={team.id} key={team.id}>
                                            {team.name}
                                        </Select.Option>
                                    );
                                })}
                            </Select>
                        );
                    },
                    rules: [{ required: true }],
                },
                {
                    label: (
                        <span>
                            Channel layout
                            <span style={{ marginLeft: 4 }}>
                                <TooltipInfoIcon
                                    tooltipContent={
                                        <>
                                            <b>Posts:</b> Reorder by most recent reply. Best for forums and
                                            announcements.
                                            <br /> <br />
                                            <b>Threads:</b> Chat with replies on the side. Best for discussions.
                                        </>
                                    }
                                />
                            </span>
                        </span>
                    ),
                    initialValue: channelLayoutType,
                    name: 'channelLayoutType',
                    fieldType: FieldType.Custom,
                    renderField: () => {
                        return (
                            <Select style={{ width: '100%' }} placeholder="Select">
                                {Object.values(MicrosoftTeamsChannelLayoutType).map((type) => (
                                    <Select.Option value={type} key={type}>
                                        {MicrosoftTeamsChannelLayoutTypeDisplayNames[type]}
                                    </Select.Option>
                                ))}
                            </Select>
                        );
                    },
                    rules: [{ required: true }],
                },
                {
                    label: (
                        <span>
                            Channel privacy
                            <span style={{ marginLeft: 4 }}>
                                <TooltipInfoIcon
                                    tooltipContent={
                                        <>
                                            <b>Standard:</b> Visible to everyone in the Team. Microsoft Teams does not
                                            allow adding users to standard channels, so the auto-add settings below have
                                            no effect.
                                            <br /> <br />
                                            <b>Private:</b> Only visible to channel members. Runway will add the users
                                            and mapped user groups selected below.
                                        </>
                                    }
                                />
                            </span>
                        </span>
                    ),
                    initialValue: channelMembershipType,
                    name: 'channelMembershipType',
                    fieldType: FieldType.Custom,
                    renderField: () => {
                        return (
                            <Select style={{ width: '100%' }} placeholder="Select">
                                {Object.values(MicrosoftTeamsChannelMembershipType).map((type) => (
                                    <Select.Option value={type} key={type}>
                                        {MicrosoftTeamsChannelMembershipTypeDisplayNames[type]}
                                    </Select.Option>
                                ))}
                            </Select>
                        );
                    },
                    rules: [{ required: true }],
                },
                autoArchiveChannelConfig,
                autoAddUsersConfig,
                autoAddGroupsConfig,
            ];
        }

        case AutomationType.AutoSyncSlackPilotUserGroup: {
            const autoSyncSlackPilotUserGroup = automation as AutomationAutoSyncSlackPilotUserGroup;
            // Slack user group handle: letters (a–z), 0–9, -, _; optional @ only at the start.
            const slackPilotHandlePattern = /^@?[a-z0-9_-]+$/i;
            const slackPilotHandlePatternMessage =
                'Use only letters (a–z), numbers (0–9), hyphens (-), and underscores (_).';
            return [
                ...baseFields,
                {
                    label: 'Release pilot handle',
                    helpMessage: (
                        <>
                            Runway will automatically manage the user group for this handle, ensuring the current
                            release pilot is its only member.
                        </>
                    ),
                    initialValue: autoSyncSlackPilotUserGroup.data?.userGroupHandle ?? '',
                    name: 'userGroupHandle',
                    fieldType: FieldType.Input,
                    dependencies: ['enabled'],
                    rules: [
                        ({ getFieldValue }) => ({
                            validator: (_, value) => {
                                const isEnabled = getFieldValue('enabled') === true;
                                const str = typeof value === 'string' ? value.trim() : '';
                                if (!isEnabled) {
                                    if (str !== '' && !slackPilotHandlePattern.test(str)) {
                                        return Promise.reject(new Error(slackPilotHandlePatternMessage));
                                    }
                                    return Promise.resolve();
                                }
                                if (str === '') {
                                    return Promise.reject(new Error('Release pilot handle is required'));
                                }
                                if (!slackPilotHandlePattern.test(str)) {
                                    return Promise.reject(new Error(slackPilotHandlePatternMessage));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ],
                },
                waitUntilKickedOffConfig(
                    autoSyncSlackPilotUserGroup.data?.shouldWaitUntilNextReleaseIsKickedOff,
                    AutomationType.AutoSyncSlackPilotUserGroup,
                ),
            ];
        }

        case AutomationType.AutoSyncTeamsPilotTag: {
            const autoSyncTeamsPilotTag = automation as AutomationAutoSyncTeamsPilotTag;
            return [
                ...baseFields,
                {
                    label: 'Release pilot tag',
                    helpMessage: (
                        <>
                            Runway will automatically manage the Teams tag with this name, ensuring the current release
                            pilot is its only member.
                        </>
                    ),
                    initialValue: autoSyncTeamsPilotTag.data?.tagName ?? '',
                    name: 'tagName',
                    fieldType: FieldType.Input,
                    dependencies: ['enabled'],
                    rules: [
                        ({ getFieldValue }) => ({
                            validator: (_, value) => {
                                const isEnabled = getFieldValue('enabled') === true;
                                const str = typeof value === 'string' ? value.trim() : '';
                                if (isEnabled && str === '') {
                                    return Promise.reject(new Error('Release pilot tag is required'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ],
                },
                waitUntilKickedOffConfig(
                    autoSyncTeamsPilotTag.data?.shouldWaitUntilNextReleaseIsKickedOff,
                    AutomationType.AutoSyncTeamsPilotTag,
                ),
            ];
        }

        case AutomationType.AutoDistributeReleaseSummary: {
            const distributeSummaryAutomation = automation as AutomationDistributeReleaseSummary;
            const emails = distributeSummaryAutomation.data?.emailAddresses ?? [];
            const rules = emailValidationRules(emails);
            rules.push({
                validator: (_, value) => {
                    if (value.length > 5) {
                        return Promise.reject('You can only enter up to five recipients');
                    }
                    return Promise.resolve();
                },
                message: 'You can only enter up to five recipients',
            });
            return [
                ...baseFields,
                {
                    label: 'Additional recipients',
                    name: 'emails',
                    helpMessage:
                        'Enter up to five additional recipients. Note that by default all app users will receive release summaries and can opt out independently.',
                    fieldType: FieldType.Custom,
                    showDivider: true,
                    initialValue: emails,
                    disabled: emails.length >= 5,
                    rules: rules,
                    renderField: () => {
                        return (
                            <Select
                                mode="tags"
                                placeholder="e.g. product@team.com"
                                allowClear
                                tokenSeparators={[',', '\n', ' ']}
                                style={{
                                    width: '100%',
                                }}
                            />
                        );
                    },
                },
            ];
        }

        case AutomationType.AutoTransitionIssueTrackingTickets: {
            if (!availableAutoTransitionTicketsStatuses || availableAutoTransitionTicketsStatuses?.length === 0) {
                return [...baseFields];
            }

            const autoTransitionIssueTrackingTickets = automation as AutoTransitionIssueTrackingTickets;
            const savedMilestoneStatuses = autoTransitionIssueTrackingTickets.data?.milestoneStatuses;
            const savedTransitions: {
                milestone: string;
                status?: string;
                transitionNewTicketsAfterKickoff?: boolean;
            }[] =
                savedMilestoneStatuses && Object.keys(savedMilestoneStatuses).length > 0 ?
                    allReleaseMilestones
                        .filter((milestone) => !!savedMilestoneStatuses[milestone])
                        .map((milestone) => ({
                            milestone,
                            status: savedMilestoneStatuses[milestone],
                            transitionNewTicketsAfterKickoff:
                                milestone === ReleaseMilestone.Kickoff ?
                                    autoTransitionIssueTrackingTickets.data?.transitionNewTicketsAfterKickoff
                                :   undefined,
                        }))
                :   [
                        {
                            milestone: ReleaseMilestone.ReleaseCompleted,
                            status: autoTransitionIssueTrackingTickets.data?.status,
                        },
                    ];
            return [
                ...baseFields,
                {
                    label: 'Status updates',
                    helpMessage:
                        'For each release milestone, the status to which associated tickets will be updated when the milestone is reached.',
                    name: 'milestoneTransitions',
                    fieldType: FieldType.List,
                    rules: [
                        {
                            validator: async (_, transitions) => {
                                if (!transitions?.length) {
                                    throw new Error('At least one transition is required');
                                }
                            },
                        },
                    ],
                    initialValue: savedTransitions,
                    nestedListFields: [
                        {
                            fieldType: FieldType.Custom,
                            style: { margin: 0 },
                            renderField: (data) => {
                                return renderTransitionMilestoneField(data, availableAutoTransitionTicketsStatuses);
                            },
                        },
                    ],
                    listChildrenWrapper: (children, { add }, errors) => {
                        const canAddMore = (children as React.ReactNode[]).length < allReleaseMilestones.length;
                        return (
                            <Space direction="vertical" style={{ width: '100%' }} size={16}>
                                {children}
                                <Form.ErrorList errors={errors?.errors} />
                                {canAddMore && (
                                    <Button
                                        icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                        onClick={() => add({ milestone: undefined, status: undefined })}
                                    >
                                        Add another status update
                                    </Button>
                                )}
                            </Space>
                        );
                    },
                } as FormFieldData,
            ];
        }
        case AutomationType.AutoResignRollbackBuild:
            return [
                {
                    helpMessage: baseFieldHelpMessage,
                    fieldType: FieldType.Custom,
                    renderField: () => {
                        return null;
                    },
                },
            ];
        case AutomationType.AutoPrepareRollbackRelease:
            return generatePrepareRollbackFields(
                baseField,
                automation,
                appStoreType,
                connectedCapabilities,
                stabilityIntegrations,
                platform,
                monitoringMetrics,
                createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.HealthMetrics),
                resigningStrategy,
                onSelectResigningStrategy,
                rebuildByCIUnavailableReason,
            );
        case AutomationType.BAAutoUploadBinaryArtifactToAppStore: {
            if (!artifactUploadOptions) {
                return [];
            }

            if (artifactUploadOptions.appIdentifiers.size > 0) {
                const isCustomCI = artifactUploadOptions.buildSystem?.id === IntegrationType.CustomCI;

                return generateAutoUploadBinaryArtifactToAppStoreFields(
                    baseField,
                    automation,
                    platform,
                    appStoreType,
                    artifactUploadOptions.destinationOptions,
                    null,
                    isCustomCI,
                );
            } else {
                return [
                    {
                        ...baseField,
                        disabled: true,
                    },
                    {
                        name: 'ciCdMessage',
                        showDivider: true,
                        fieldType: FieldType.Custom,
                        renderField: () => {
                            const platformIdentifier = identifierForAppPlatform(platform);
                            const message = `A Beta Testing or App Store ${platformIdentifier} must be configured in order to enable this automation. Configure by visiting Beta and/or App Store integration settings.`;
                            return <Text style={{ color: antGrey.grey7 }}>{message}</Text>;
                        },
                    },
                ];
            }
        }
        case AutomationType.BAAutoTriggerBuildSystemWorkflow: {
            const autoTriggerWorfklow = automation as AutomationBAAutoTriggerBuildSystemWorkflow;
            const timedTriggerEveryNHours = autoTriggerWorfklow.data?.timedTriggerEveryNHours ?? 12;
            const fields = [
                ...baseFields,
                {
                    fieldType: FieldType.Custom,
                    data: [
                        {
                            label: 'Smart mode – trigger based on bucket configuration',
                            value: TriggerWorkflowOption.SmartMode,
                        },
                        {
                            label: 'Trigger workflow every N hours',
                            value: TriggerWorkflowOption.TriggerEveryNHours,
                        },
                    ],
                    renderField: (data) => {
                        return (
                            <Select
                                options={data}
                                placeholder="Select"
                                style={{ width: '100%' }}
                                onChange={(value) => onSelectTriggerWorkflowOption(value as TriggerWorkflowOption)}
                            />
                        );
                    },
                    initialValue: triggerWorkflowOption ?? TriggerWorkflowOption.SmartMode,
                    label: 'Trigger workflow strategy',
                    name: 'triggerStrategy',
                    required: true,
                    rules: [{ required: true }],
                },
            ];

            if (triggerWorkflowOption === TriggerWorkflowOption.TriggerEveryNHours) {
                fields.push({
                    label: 'Trigger workflow every N hours',
                    fieldType: FieldType.Custom,
                    name: 'timedTriggerEveryNHours',
                    renderField: () => {
                        return (
                            <InputNumber
                                min={1}
                                max={168}
                                precision={0}
                                type="number"
                                addonAfter="hours"
                                defaultValue={timedTriggerEveryNHours}
                            />
                        );
                    },
                    initialValue: timedTriggerEveryNHours,
                    required: true,
                    rules: [{ required: true }],
                });
            }

            return fields;
        }
        case AutomationType.AutoCreateTestRuns:
            return generateAutoCreateTestRunsFields(baseField, automation, regressionTesting);
        case AutomationType.AutoCherryPickLocalizableStrings: {
            const cherryPickLocalizableStringsAutomation = automation as AutomationCherryPickLocalizableStrings;
            return [
                ...baseFields,
                ...generateBypassPullRequestsFields(cherryPickLocalizableStringsAutomation, {
                    orgId,
                    appId,
                    isGithubVCS,
                    createsMergeCommit: false,
                    canWaitForRequiredStatusChecks: true,
                    branchTargetForValues: () => 'releaseBranch',
                }),
                ...generateAssignPrToAutomationFields(cherryPickLocalizableStringsAutomation, {
                    includeFixOwner: false,
                    disableWhenBypassingPullRequests: true,
                }),
            ];
        }
        case AutomationType.AutoSyncTranslations: {
            const syncTranslationsAutomation = automation as AutomationSyncTranslations;
            const daysBeforeKickoff = syncTranslationsAutomation.data?.daysBeforeKickoffForUpload ?? 1;
            const daysBeforeSubmission = syncTranslationsAutomation.data?.daysBeforeSubmissionForExport ?? 1;

            const fields = [
                ...baseFields,
                {
                    label: 'Export translations to the',
                    name: 'exportStrategy',
                    fieldType: FieldType.Select,
                    initialValue:
                        syncTranslationsAutomation.data?.exportStrategy ??
                        AutoSyncTranslationsExportStrategy.ToReleaseBranch,
                    data: AllAutoSyncTranslationsExportStrategies.map((strategy) => {
                        const displayText = displayTextForSyncTranslationsExportStrategy(strategy);
                        return {
                            value: strategy,
                            displayValue: displayText,
                        };
                    }),
                    rules: [],
                },
                {
                    label: '',
                    data: 'Upload localizable strings for translation ahead of release kickoff',
                    name: 'autoSyncTranslationsBeforeKickoffEnabled',
                    fieldType: FieldType.Checkbox,
                    initialValue: autoSyncTranslationsBeforeKickoffEnabled ?? false,
                    onChange: (e) => {
                        onSelectAutoSyncTranslationsBeforeKickoffEnabled(e.target.checked);
                    },
                    rules: [],
                    defaultHelpMessage:
                        'Localizable string files needing translation on the working branch will be uploaded',
                },
            ];

            if (autoSyncTranslationsBeforeKickoffEnabled === true) {
                fields.push({
                    label: '',
                    name: 'daysBeforeKickoffForUpload',
                    fieldType: FieldType.Custom,
                    initialValue: daysBeforeKickoff,
                    rules: [],
                    renderField: () => {
                        return (
                            <InputNumber
                                min={1}
                                max={30}
                                precision={0}
                                type="number"
                                addonAfter="days before kickoff"
                                defaultValue={daysBeforeKickoff}
                            />
                        );
                    },
                });
            }

            fields.push({
                label: '',
                data: 'Export translations from translations provider ahead of release submission',
                name: 'autoSyncTranslationsBeforeSubmissionEnabled',
                helpMessage: (
                    <Text style={{ color: runwayColors.statusYellow }}>
                        An export will be triggered for all localizable string files with at least one key in an{' '}
                        <strong>Export needed</strong> state. Any incomplete string translations that may also be
                        included in the file will also be exported.
                    </Text>
                ),
                fieldType: FieldType.Checkbox,
                initialValue: autoSyncTranslationsBeforeSubmissionEnabled ?? false,
                rules: [],
                onChange: (e) => {
                    onSelectAutoSyncTranslationsBeforeSubmissionEnabled(e.target.checked);
                },
            });
            if (autoSyncTranslationsBeforeSubmissionEnabled === true) {
                fields.push({
                    label: '',
                    name: 'daysBeforeSubmissionForExport',
                    fieldType: FieldType.Custom,
                    initialValue: daysBeforeSubmission,
                    rules: [],
                    renderField: () => {
                        return (
                            <InputNumber
                                min={1}
                                max={30}
                                precision={0}
                                type="number"
                                addonAfter="days before submission"
                                defaultValue={daysBeforeSubmission}
                            />
                        );
                    },
                });
            }
            return fields;
        }
        case AutomationType.AutoAssignBetaBuilds:
        case AutomationType.BAAutoAssignBetaBuilds: {
            const autoAssignBetaBuildsAutomation = automation as
                | AutomationAssignBetaBuildGroups
                | AutomationBAAssignBetaBuildGroups;

            const selectBetaGroupField = (() => {
                if (!betaTesting || !betaTestingProvider) {
                    return buildDisabledBetaGroupField();
                }

                switch (betaTesting.id) {
                    case IntegrationType.TestFlight:
                        return buildTestFlightBetaGroupField(
                            betaTesting,
                            betaTestingProvider as IntegrationProviderApple,
                            autoAssignBetaBuildsAutomation.data?.selectedBetaGroupIds ?? [],
                        );
                    case IntegrationType.FirebaseBeta:
                        return buildFirebaseBetaGroupField(
                            betaTesting,
                            betaTestingProvider as IntegrationProviderGoogle,
                            autoAssignBetaBuildsAutomation.data?.selectedBetaGroupIds ?? [],
                        );
                    default:
                        return null;
                }
            })();
            return selectBetaGroupField ? [...baseFields, selectBetaGroupField] : [...baseFields];
        }
        case AutomationType.AutoPromoteBuildsToTestTrack: {
            const autoPromoteBuildsToTestTrackAutomation = automation as AutomationPromoteBuildsToTestTrack;
            const integrationDataTestingTrack = (betaTesting as IntegrationGoogleBeta)?.data?.testingTrack;

            return [
                ...baseFields,
                {
                    label: 'Testing Track',
                    name: 'testingTrack',
                    fieldType: FieldType.Input,
                    initialValue:
                        autoPromoteBuildsToTestTrackAutomation.data?.testingTrack ?? integrationDataTestingTrack,
                    rules: [{ required: true, message: 'Track selection required' }],
                    helpMessage: "Choose from 'alpha', 'beta', 'internal', or another custom testing track",
                },
            ];
        }
        case AutomationType.AutoSyncMetadataTranslations: {
            const syncMetadataTranslationsAutomation = automation as AutomationSyncMetadataTranslations;
            const daysBeforeSubmission = syncMetadataTranslationsAutomation.data?.daysBeforeSubmissionForExport ?? 1;

            const fields = [
                ...baseFields,
                {
                    label: '',
                    data: 'Export translated metadata ahead of release submission',
                    name: 'autoSyncMetadataTranslationsBeforeSubmissionEnabled',
                    helpMessage: (
                        <Text style={{ color: runwayColors.statusYellow }}>
                            An export will be triggered for any metadata fields in an <strong>Export needed</strong>{' '}
                            state. Some metadata fields may still have a status of{' '}
                            <strong>Waiting for translation</strong> when the export is triggered.
                        </Text>
                    ),
                    fieldType: FieldType.Checkbox,
                    initialValue: autoSyncMetadataTranslationsBeforeSubmissionEnabled ?? false,
                    rules: [],
                    onChange: (e) => {
                        onSelectAutoSyncMetadataTranslationsBeforeSubmissionEnabled(e.target.checked);
                    },
                },
            ];

            if (autoSyncMetadataTranslationsBeforeSubmissionEnabled === true) {
                fields.push({
                    label: '',
                    name: 'daysBeforeSubmissionForExport',
                    fieldType: FieldType.Custom,
                    initialValue: daysBeforeSubmission,
                    rules: [],
                    renderField: () => {
                        return (
                            <InputNumber
                                min={1}
                                max={30}
                                precision={0}
                                type="number"
                                addonAfter="days before submission"
                                defaultValue={daysBeforeSubmission}
                            />
                        );
                    },
                });
            }
            return fields;
        }
        case AutomationType.AutoSyncMetadataFromVCS: {
            const syncMetadataFromVCSAutomation = automation as AutomationSyncMetadataFromVCS;
            const metadataPath = syncMetadataFromVCSAutomation.data?.autoSyncMetadataFromVCSFilePath;

            const fields = [
                ...baseFields,
                {
                    label: 'Metadata file path',
                    name: 'autoSyncMetadataFromVCSFilePath',
                    fieldType: FieldType.Input,
                    initialValue: metadataPath,
                    placeholder: 'ProjectName/metadata',
                    rules: [{ required: true, message: 'Metadata path is required' }],
                    helpMessage: (
                        <Text style={{ color: antGrey.grey7 }}>
                            {`For more information on supported metadata keys and language keys, visit our `}
                            <Typography.Link
                                href={`https://docs.runway.team/automations/types-of-automations#sync-metadata-from-vcs`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                docs
                            </Typography.Link>
                            {`.`}
                        </Text>
                    ),
                },
            ];

            return fields;
        }
        case AutomationType.AutoApplyReviewAttachments: {
            const currentlyUploadedReviewAttachment = useSelector((state: RootState) =>
                selectDefaultReviewAttachmentFromAutomation(state, appId, automation.id),
            );

            return generateAutoApplyReviewAttachmentsFields(
                baseField,
                appId,
                orgId,
                currentlyUploadedReviewAttachment,
                automation.stepConfigId,
            );
        }
        case AutomationType.BAAutoUpdatePRWithArtifactLink: {
            const baAutoUpdatePRWithArtifactLinkAutomation = automation as AutomationBAAutoUpdatePRWithArtifactLink;
            return [
                ...baseFields,
                {
                    label: 'Commenting method',
                    name: 'prCommentStrategy',
                    fieldType: FieldType.Select,
                    initialValue:
                        baAutoUpdatePRWithArtifactLinkAutomation.data?.prCommentStrategy ??
                        PRCommentStrategy.UpdateExisting,
                    data: [
                        {
                            value: PRCommentStrategy.CreateNew,
                            displayValue: 'Post a new comment with every update',
                        },
                        {
                            value: PRCommentStrategy.UpdateExisting,
                            displayValue: 'Post a single comment and make edits with updates',
                        },
                    ],
                },
            ];
        }
        default:
            return [...baseFields];
    }
};

const waitUntilKickedOffConfig = (initialValue: boolean | undefined, automationType: AutomationType) => {
    const noun = automationType === AutomationType.AutoSyncSlackPilotUserGroup ? 'handle' : 'tag';
    return {
        label: '',
        data: (
            <div>
                Sync when the current release is kicked off
                <Tooltip
                    title={`If this option is turned off, the sync will happen as soon as the previous version has been released. In practice, this may mean that the ${noun} may reference the next release's pilot while the previous release is still rolling out.`}
                >
                    <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
                </Tooltip>
            </div>
        ),
        initialValue: initialValue ?? false,
        name: 'shouldWaitUntilNextReleaseIsKickedOff',
        fieldType: FieldType.Checkbox,
        rules: [],
    };
};

const automationUpdateRequestDataFromValues: (
    automation: AutomationTypesWithSettings,
    values: any,
    monitoringMetrics?: AppMonitoringHealthMetric[],
) => typeof automation.data = (automation, values, monitoringMetrics) => {
    switch (automation.type) {
        case AutomationType.AutoBumpVersion: {
            return {
                strategy: values.strategy,
                shouldCommitAndPushDirectlyToTargetBranch: values.shouldCommitAndPushDirectlyToTargetBranch,
                skipInvalidFiles: values.skipInvalidFiles,
                assignPrTo: values.assignPrTo,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateRunwayReleases: {
            return {
                destinations: values.destinations,
                delayUntilBackmergeMerged: values.delayUntilBackmergeMerged ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateIncidents: {
            const previousData = (automation as AutomationCreateIncidents).data;
            const unhealthyTrigger: UnhealthyMetricsTriggerConfig = {
                ...(previousData?.unhealthyMetricsTrigger ?? { enabled: false }),
                enabled: values.shouldTriggerOnUnhealthyMetrics ?? false,
                monitoringConditions: [],
                adoptionThreshold: undefined,
                phasedReleaseDayThreshold: undefined,
                stagedRolloutPercentageThreshold: undefined,
            };
            if (values.shouldTriggerOnUnhealthyMetrics) {
                if (Array.isArray(values.monitoringConditions)) {
                    unhealthyTrigger.monitoringConditions = values.monitoringConditions
                        .map(({ id }) => id)
                        .filter((id): id is string => !!id);
                }
                if (Array.isArray(values.conditions)) {
                    for (const condition of values.conditions) {
                        if (!condition?.id || condition.threshold == null) {
                            continue;
                        }
                        switch (condition.id) {
                            case MonitoringAutomationConditionType.Adoption:
                                unhealthyTrigger.adoptionThreshold = condition.threshold;
                                break;
                            case MonitoringAutomationConditionType.PhasedReleaseDay:
                                unhealthyTrigger.phasedReleaseDayThreshold = condition.threshold;
                                break;
                            case MonitoringAutomationConditionType.StagedRolloutPercentage:
                                unhealthyTrigger.stagedRolloutPercentageThreshold = condition.threshold;
                                break;
                        }
                    }
                }
            }
            const finalValues: AutomationCreateIncidentsData = {
                rolloutHaltedTrigger: {
                    ...(previousData?.rolloutHaltedTrigger ?? { enabled: false }),
                    enabled: values.shouldTriggerOnRolloutHalted ?? false,
                },
                reviewRejectionTrigger: {
                    ...(previousData?.reviewRejectionTrigger ?? { enabled: false }),
                    enabled: values.shouldTriggerOnReviewRejection ?? false,
                },
                unhealthyMetricsTrigger: unhealthyTrigger,
            };
            if (values.incidentIoSeverityId != null) {
                finalValues.integrationSpecificSettings = {
                    severityId: values.incidentIoSeverityId,
                };
            }
            if (values.pagerDutyServiceId != null || values.pagerDutyFromEmail != null) {
                finalValues.integrationSpecificSettings = {
                    serviceId: values.pagerDutyServiceId ?? '',
                    fromEmail: values.pagerDutyFromEmail ?? '',
                };
            }
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.AutoPromoteStablePhasedReleases:
        case AutomationType.AutoHaltUnstablePhasedReleases: {
            const finalValues: AutomationHaltPromotePhasedReleaseData = {
                monitoringConditions: [],
                checklistItems: [],
            };

            if (values.conditionGroups) {
                finalValues.conditionGroups = haltConditionGroupsFormValueToConfig(
                    values.conditionGroups,
                    monitoringMetrics,
                );

                return finalValues satisfies typeof automation.data;
            }

            if (values.conditions) {
                const adoptionThresholds: Record<string, number> = {};
                let legacyAdoptionThreshold: number | undefined;
                for (const condition of values.conditions) {
                    switch (condition.id) {
                        case MonitoringAutomationConditionType.Adoption:
                            if (condition.installationId) {
                                adoptionThresholds[condition.installationId] = condition.threshold;
                            } else {
                                legacyAdoptionThreshold = condition.threshold;
                            }
                            break;
                        case MonitoringAutomationConditionType.PhasedReleaseDay:
                            finalValues.phasedReleaseDayThreshold = condition.threshold;
                            break;
                        case MonitoringAutomationConditionType.StagedRolloutPercentage:
                            finalValues.stagedRolloutPercentageThreshold = condition.threshold;
                            break;
                    }
                }
                if (Object.keys(adoptionThresholds).length > 0) {
                    finalValues.adoptionThresholds = adoptionThresholds;
                } else if (legacyAdoptionThreshold !== undefined) {
                    finalValues.adoptionThreshold = legacyAdoptionThreshold;
                }
            }

            if (values.monitoringConditions) {
                finalValues.monitoringConditions = values.monitoringConditions.map(({ id }) => id);
                finalValues.metricMaxDataAgeMinutes = metricMaxDataAgeMinutesFromFormValue(
                    values.monitoringConditions,
                    monitoringMetrics,
                );
            }

            if (values.monitoringChecklistItems) {
                finalValues.checklistItems = values.monitoringChecklistItems;
            }

            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.AutoKickoffRelease: {
            return {
                allowKickoffWhenPreviousNotComplete: values.allowKickoffWhenPreviousNotComplete,
                shouldCommitAndPushDirectlyToTargetBranch: values.shouldCommitAndPushDirectlyToTargetBranch,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoTriggerCIWorkflow: {
            const triggerCIResult: AutoTriggerCIWorkflowData = {
                skipIfBuildAlreadyExists: values.skipIfBuildAlreadyExists ?? false,
            };
            if (values.conditionGroups) {
                triggerCIResult.conditionGroups = values.conditionGroups.map(
                    (group: TriggerCIWorkflowConditionGroup) => ({
                        id: group.id,
                        type: group.type,
                        ...(group.runwayPRTypes && { runwayPRTypes: group.runwayPRTypes }),
                        ...(group.relativeTimeTrigger && {
                            relativeTimeTrigger: group.relativeTimeTrigger,
                        }),
                        ...(group.completedStepsTrigger && {
                            completedStepsTrigger: group.completedStepsTrigger,
                        }),
                    }),
                );
            }
            return triggerCIResult satisfies typeof automation.data;
        }
        case AutomationType.AutoBackmergeReleaseBranches: {
            return {
                strategy: values.strategy,
                availableStrategies: automation.data?.availableStrategies ?? [], // Just to satisfy the type checker, as this comes from BE
                runwayPRTypesToSkip: values.runwayPRTypesToSkip,
                shouldBackmergeOnlyMergeCommits: values.shouldBackmergeOnlyMergeCommits,
                assignPrTo: values.assignPrTo,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyBetaBuildNotes: {
            const isCIVariable = values.strategy === BuildNotesAutomationStrategy.CIBuildVariable;
            const supportsFallback =
                betaBuildNotesStrategyUsesCIMatchedBuild(values.strategy) ||
                isAIBetaBuildNotesStrategy(values.strategy);
            return {
                strategy: values.strategy,
                ...(isCIVariable && {
                    ciBuildVariableKey: values.ciBuildVariableKey,
                }),
                ...(supportsFallback && {
                    fallbackStrategy: values.fallbackStrategy,
                }),
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoGenerateCIBuildDiffSummary: {
            return {
                showSummaryOnCIStep: values.showSummaryOnCIStep ?? false,
                notificationIdsToInclude: values.notificationIdsToInclude ?? [],
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncAppStoreUsers: {
            const roleEntries = values.rolesMap as RoleEntry[];
            const rolesMap = {};
            roleEntries.forEach((entry) => {
                const roleSyncData: RoleSyncData = { syncEnabled: entry.syncEnabled, roles: entry.appStoreRoles };

                if (!rolesMap[entry.userGroup.id]) {
                    rolesMap[entry.userGroup.id] = {};
                }

                rolesMap[entry.userGroup.id][IntegrationCapability.AppStore] = roleSyncData;
            });

            return {
                allowDeleteUsers: values.allowDeleteUsers,
                rolesMap: rolesMap,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoTagReleases: {
            return {
                fallbackToHeadIfNeeded: values.fallbackToHeadIfNeeded,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyMetadata: {
            return {
                releaseNotesSource: values.releaseNotesSource,
                promoTextSource: values.promoTextSource,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoUploadBinaryArtifactToAppStore: {
            const workflowSettings =
                values.uploadWorkflowSettings?.map((setting) => {
                    const workflowSetting: AppStoreArtifactUploadWorkflowSettings = {
                        workflowType: setting.workflowType ? setting.workflowType : WorkflowType.Staging, // we always need a WorkflowType, so default to staging if blank (for CustomCI)
                        fileNames: setting.fileNames,
                        destinationInstallationId: setting.destinationInstallationId,
                        trackName: setting.trackName ? sanitizeTrackName(setting.trackName) : null,
                        createNewTrackReleaseWithPatternedName: setting.createNewTrackReleaseWithPatternedName,
                    };
                    return workflowSetting;
                }) ?? [];

            const finalValues = {
                uploadWorkflowSettings: workflowSettings,
                uploadRule: values.uploadRule,
            };
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.AutoUploadDsymsToStabilityMonitoring: {
            const workflowSettings = values.uploadWorkflowSettings.map((setting) => {
                const workflowSetting: DsymsUploadWorkflowSettings = {
                    workflowType: setting.workflowType,
                    fileNames: [setting.fileName.trim() ?? `{*}.dSYM.zip`],
                    stabilityMonitoringInstallationIds: setting.stabilityMonitoringInstallationIds ?? [],
                };
                return workflowSetting;
            });

            return {
                uploadWorkflowSettings: workflowSettings,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSelectLatestBuild: {
            const track = values.track ? sanitizeTrackName(values.track) : null;
            const strategy = values.strategy;
            const regressionStepsToConsider = values.regressionStepsToConsider;
            const updateTrackReleaseWithPatternedName = values.updateTrackReleaseWithPatternedName;
            return {
                track,
                strategy,
                regressionStepsToConsider,
                updateTrackReleaseWithPatternedName,
                shouldRequireBuildMatch: values.shouldRequireBuildMatch ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCherryPickFromWorkingBranch: {
            return {
                tokens: values.tokens,
                strategy: values.strategy,
                shouldNotifyPRAuthors: values.shouldNotifyPRAuthors,
                allowFixesWithToken: values.allowFixesWithToken,
                requiresFixApprovalToCherryPick: values.requiresFixApprovalToCherryPick,
                skipPostingPRCommentsOnCherryPickSuccess: values.skipPostingPRCommentsOnCherryPickSuccess,
                skipPostingPRCommentsOnCherryPickMergeConflicts: values.skipPostingPRCommentsOnCherryPickMergeConflicts,
                matchTokenOn: values.matchTokenOn,
                assignPrTo: values.assignPrTo,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoPullSubmissionFromReview: {
            return {
                pullOnReleaseSkipped: values.pullOnReleaseSkipped ?? false,
                pullOnFixOrFixRequestAccepted: values.pullOnFixOrFixRequestAccepted ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSubmitRelease: {
            return {
                submitStrategy: values.submitStrategy,
                shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission:
                    values.shouldReleaseBetaTrackToFullPercentagePriorToAutoSubmission,
                shouldReleasePreviousSubmissionToAllUsersFirst: values.shouldReleasePreviousSubmissionToAllUsersFirst,
                shouldWaitForPreviousReleaseToBeFullyRolledOut: values.shouldWaitForPreviousReleaseToBeFullyRolledOut,
                shouldUseCustomRequiredSteps: values.shouldUseCustomRequiredSteps,
                customRequiredSteps: values.customRequiredSteps,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoRelease: {
            return {
                strategy: values.strategy,
                shouldReleasePreviousSubmissionToAllUsersFirst: values.shouldReleasePreviousSubmissionToAllUsersFirst,
                shouldWaitForPreviousReleaseToBeFullyRolledOut: values.shouldWaitForPreviousReleaseToBeFullyRolledOut,
                shouldUseCustomRequiredSteps: values.shouldUseCustomRequiredSteps,
                customRequiredSteps: values.customRequiredSteps,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateReleaseChannels:
            return {
                teamId: values.teamId,
                channelLayoutType: values.channelLayoutType,
                channelMembershipType: values.channelMembershipType,
                archiveChannelsWhenReleaseCompleted: values.archiveChannelsWhenReleaseCompleted,
                inviteGroups: values.inviteGroups,
                inviteUsers: values.inviteUsers,
            } satisfies typeof automation.data;
        case AutomationType.AutoSyncSlackPilotUserGroup:
            return {
                userGroupHandle: values.userGroupHandle ?? '',
                shouldWaitUntilNextReleaseIsKickedOff: values.shouldWaitUntilNextReleaseIsKickedOff ?? false,
            } satisfies typeof automation.data;
        case AutomationType.AutoSyncTeamsPilotTag:
            return {
                tagName: values.tagName ?? '',
                shouldWaitUntilNextReleaseIsKickedOff: values.shouldWaitUntilNextReleaseIsKickedOff ?? false,
            } satisfies typeof automation.data;
        case AutomationType.AutoStagedRollout: {
            const parsedTime = dayjs(values.autoStagedRolloutCustomHour);
            const autoStagedRolloutCustomHour = parsedTime.isValid() ? parsedTime.hour() : undefined;
            const autoStagedRolloutStartStrategy =
                values.autoStagedRolloutStartStrategy ??
                (automation as AutomationAutoStagedRollout).data?.autoStagedRolloutStartStrategy ??
                AndroidAutoRolloutStartStrategy.Manual;
            return {
                daysToPercent: values.daysToPercent?.map((dayToPercent) => {
                    return Number(dayToPercent);
                }),
                autoStagedRolloutBlackoutSegmentsByDay: encodeAutoStagedRolloutBlackoutSegmentsByDay(
                    values.autoStagedRolloutBlackoutSegmentsByDay,
                    values.autoStagedRolloutBlackoutTimezone,
                ),
                autoStagedRolloutBlackoutTimezone: values.autoStagedRolloutBlackoutTimezone,
                autoStagedRolloutStartStrategy: autoStagedRolloutStartStrategy,
                autoStagedRolloutCustomHour: autoStagedRolloutCustomHour,
                shouldAccountBlackoutsForHoursSinceLastIncrement:
                    values.shouldAccountBlackoutsForHoursSinceLastIncrement ?? false,
                shouldAccountHaltedPeriodsForHoursSinceLastIncrement:
                    values.shouldAccountHaltedPeriodsForHoursSinceLastIncrement ?? true,
                shouldContinueIncrementingAfterManualUpdate: values.shouldContinueIncrementingAfterManualUpdate ?? true,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncAppleDevices: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncAppleProvisioningProfilesDevices: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoTransitionIssueTrackingTickets: {
            const milestoneStatuses: Record<string, string> = {};
            for (const transition of values.milestoneTransitions ?? []) {
                if (!transition?.milestone || !transition?.status) {
                    continue;
                }
                milestoneStatuses[transition.milestone] = transition.status;
            }
            const kickoffTransition = values.milestoneTransitions?.find(
                (transition) => transition?.milestone === ReleaseMilestone.Kickoff,
            );
            return {
                status: milestoneStatuses[ReleaseMilestone.ReleaseCompleted],
                milestoneStatuses,
                transitionNewTicketsAfterKickoff: kickoffTransition?.transitionNewTicketsAfterKickoff ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoDistributeReleaseSummary:
            return {
                emailAddresses: values.emails,
            } satisfies typeof automation.data;
        case AutomationType.AutoCherryPickLocalizableStrings: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncTranslations: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncMetadataTranslations: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoSyncMetadataFromVCS: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoPrepareRollbackRelease: {
            const finalValues: AutomationPrepareRollbackReleaseData = {
                abandonRollbackMonitoringConditions:
                    values.monitoringConditions ? values.monitoringConditions.map(({ id }) => id) : [],
                shouldAutoSubmit: values.shouldAutoSubmit,
                strategy: values.strategy,
            };
            if (values.conditions) {
                const abandonRollbackAdoptionThresholds: Record<string, number> = {};
                let legacyAbandonRollbackAdoptionThreshold: number | undefined;
                for (const condition of values.conditions) {
                    switch (condition.id) {
                        case MonitoringAutomationConditionType.Adoption:
                            if (condition.installationId) {
                                abandonRollbackAdoptionThresholds[condition.installationId] = condition.threshold;
                            } else {
                                legacyAbandonRollbackAdoptionThreshold = condition.threshold;
                            }
                            break;
                        case MonitoringAutomationConditionType.PhasedReleaseDay:
                            finalValues.abandonRollbackPhasedReleaseDayThreshold = condition.threshold;
                            break;
                        case MonitoringAutomationConditionType.StagedRolloutPercentage:
                            finalValues.abandonRollbackStagedRolloutPercentageThreshold = condition.threshold;
                            break;
                    }
                }
                if (Object.keys(abandonRollbackAdoptionThresholds).length > 0) {
                    finalValues.abandonRollbackAdoptionThresholds = abandonRollbackAdoptionThresholds;
                } else if (legacyAbandonRollbackAdoptionThreshold !== undefined) {
                    finalValues.abandonRollbackAdoptionThreshold = legacyAbandonRollbackAdoptionThreshold;
                }
            }
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.BAAutoUploadBinaryArtifactToAppStore: {
            const workflowSettings =
                values.uploadWorkflowSettings?.map((setting) => {
                    const workflowSetting: AppStoreArtifactUploadWorkflowSettings = {
                        workflowType: setting.workflowType,
                        fileNames: setting.fileNames,
                        destinationInstallationId: setting.destinationInstallationId,
                        trackName: setting.trackName ? sanitizeTrackName(setting.trackName) : null,
                        createNewTrackReleaseWithPatternedName: setting.createNewTrackReleaseWithPatternedName,
                    };
                    return workflowSetting;
                }) ?? [];

            const finalValues = {
                uploadWorkflowSettings: workflowSettings,
                uploadRule: values.uploadRule,
            };
            return finalValues satisfies typeof automation.data;
        }
        case AutomationType.BAAutoTriggerBuildSystemWorkflow: {
            return {
                timedTriggerEveryNHours: values.timedTriggerEveryNHours ?? null,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoCreateTestRuns: {
            return {
                strategy:
                    values.useTestPlans ?
                        AutoCreateTestRunsStrategy.WithTestPlans
                    :   AutoCreateTestRunsStrategy.WithoutTestPlans,
                testPlansFilterSettings: values.testPlansFilterSettings,
                testRunsFilterSettings: values.testRunsFilterSettings,
                allowCreationWithoutPreviousMatch: values.allowCreationWithoutPreviousMatch ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoAssignBetaBuilds:
        case AutomationType.BAAutoAssignBetaBuilds: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyReviewAttachments: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoPromoteBuildsToTestTrack: {
            return {
                ...values,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoAddMissingFAs: {
            return {
                safeMode: (automation as AutomationAutoAddMissingFAs).data?.safeMode ?? false,
                withComponents: (automation as AutomationAutoAddMissingFAs).data?.withComponents ?? false,
                useWorkspaceLabels: values.useWorkspaceLabels ?? false,
            } satisfies typeof automation.data;
        }
        case AutomationType.AutoApplyLabelsToFixTickets: {
            return {
                fixLabels: values.fixLabels ?? [],
                approvedLabels: values.applyApprovedLabels ? (values.approvedLabels ?? []) : [],
                rejectedLabels: values.applyRejectedLabels ? (values.rejectedLabels ?? []) : [],
                useWorkspaceLabels: values.useWorkspaceLabels ?? false,
            } satisfies typeof automation.data;
        }
        default:
            return {
                ...values,
            };
    }
};

const requiredCapabilitiesComponent = (requiredArray: IntegrationCapability[]) => {
    return (
        <Space
            wrap
            split={
                <Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    {' '}
                    or{' '}
                </Text>
            }
        >
            {requiredArray.map((capability) => {
                return (
                    <div
                        style={{
                            borderColor: runwayColors.primary,
                            borderWidth: 1,
                            borderStyle: 'solid',
                            padding: `1px 8px 1px 8px`,
                            borderRadius: 2,
                            backgroundColor: colorWithAlpha(rwColors.primary, 0.08),
                        }}
                        key={`${requiredArray[0]}-div`}
                    >
                        <Space size={8} align="center" key={capability}>
                            <Icon
                                component={iconForCapability(capability)}
                                style={{
                                    fontSize: 12,
                                    color: runwayColors.primary,
                                }}
                            />
                            <Text
                                style={{
                                    color: runwayColors.primary,
                                    fontWeight: 400,
                                }}
                            >
                                {displayNameForCapability(capability)}
                            </Text>
                        </Space>
                    </div>
                );
            })}
        </Space>
    );
};

function generateDayRow(prefix: string, day: DayOfTheWeek) {
    const isBlackedOutKey: keyof AutoStagedRolloutBlackoutDay = 'isBlackedOut';
    return (
        <Form.Item shouldUpdate noStyle>
            {(form) => {
                const isBlackedOut = form.getFieldValue([prefix, day, isBlackedOutKey]);
                return (
                    <div
                        style={{
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'baseline',
                        }}
                    >
                        <Space align="center" size={10}>
                            <Form.Item name={[prefix, day, 'isBlackedOut']} noStyle valuePropName="checked">
                                <Checkbox>
                                    <Text strong={isBlackedOut}>{displayTextForDayOfTheWeek(day)}</Text>
                                </Checkbox>
                            </Form.Item>
                        </Space>

                        <Form.List name={[prefix, day, 'segments']}>
                            {(fields, { add, remove }) => (
                                <div
                                    style={{
                                        display: isBlackedOut ? 'flex' : 'none',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 8,
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 8,
                                        }}
                                    >
                                        {fields.length === 0 && (
                                            <Text
                                                type="secondary"
                                                disabled={!isBlackedOut}
                                                style={{
                                                    width: 206,
                                                }}
                                            >
                                                All day
                                            </Text>
                                        )}
                                        {fields.map((fieldData, i) => {
                                            return (
                                                <div
                                                    key={fieldData.key}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'baseline',
                                                        gap: 8,
                                                    }}
                                                >
                                                    <Form.Item
                                                        name={[fieldData.name, 'blackoutSegment']}
                                                        style={{
                                                            marginBottom: 0,
                                                        }}
                                                        rules={[
                                                            {
                                                                validator: async (_, segment) => {
                                                                    if (!isBlackedOut) {
                                                                        return Promise.resolve();
                                                                    }

                                                                    if (!segment || !segment[0] || !segment[1]) {
                                                                        return Promise.reject('Invalid segment');
                                                                    }

                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <TimePicker.RangePicker
                                                            disabled={!isBlackedOut}
                                                            placeholder={['Start', 'End']}
                                                            minuteStep={10}
                                                            order={false}
                                                            format="h:mm a"
                                                            style={{
                                                                width: 206,
                                                            }}
                                                        />
                                                    </Form.Item>
                                                    <Button
                                                        icon={
                                                            <DeleteOutlined
                                                                color={runwayColors.statusRed}
                                                                disabled={!isBlackedOut}
                                                            />
                                                        }
                                                        disabled={!isBlackedOut}
                                                        size="small"
                                                        danger
                                                        type="link"
                                                        onClick={() => remove(i)}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <Button
                                        icon={
                                            <ClockCircleOutlined
                                                color={runwayColors.primary}
                                                disabled={!isBlackedOut}
                                            />
                                        }
                                        disabled={!isBlackedOut}
                                        type="link"
                                        size="small"
                                        onClick={() => add()}
                                    >
                                        Add times
                                    </Button>
                                </div>
                            )}
                        </Form.List>
                    </div>
                );
            }}
        </Form.Item>
    );
}

const UPLOAD_BINARY_AVAILABLE_TOKENS = [
    PatternToken.Version,
    PatternToken.VersionConcise,
    PatternToken.ReleaseName,
    PatternToken.BuildCI,
    PatternToken.ReleasePilot,
    PatternToken.ReleaseBranchName,
    PatternToken.WorkingBranchName,
    PatternToken.Wildcard,
];

function generateAutoUploadBinaryArtifactToAppStoreFields(
    baseField: FormFieldData,
    automation: Automation,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    destinationOptions: AppStoreArtifactUploadDestinationTypeOption[],
    buildSystemData: BaseCIIntegrationData,
    isCustomCI: boolean,
) {
    const baseFieldWithConditionsValidation = {
        ...baseField,
        rules: [
            (form) => {
                return {
                    validator: (rule, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }

                        const uploadWorkflowSettings: AppStoreArtifactUploadWorkflowSettings[] =
                            form.getFieldValue('uploadWorkflowSettings') ?? [];
                        if (uploadWorkflowSettings.length === 0) {
                            const message = 'At least one rule is required to enable this automation';
                            globalMessage.error(message);
                            return Promise.reject(message);
                        } else {
                            const stagingWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Staging;
                            });
                            const prodWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Production;
                            });
                            if (stagingWorkflowSettings.length > 2 && prodWorkflowSettings.length > 1) {
                                const message =
                                    'A maximum of one release rule and two release candidate rules are allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (stagingWorkflowSettings.length > 2) {
                                const message = 'A maximum of two release candidate rules are allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (prodWorkflowSettings.length > 1) {
                                const message = 'A maximum of one release rule is allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else {
                                // Have the correct number of rules configured, checking for duplicates
                                // TODO:RUN-10317 duplicates checking..
                                if (stagingWorkflowSettings.length === 2) {
                                    if (
                                        stagingWorkflowSettings[0].destinationInstallationId ==
                                            stagingWorkflowSettings[1].destinationInstallationId &&
                                        stagingWorkflowSettings[0].workflowType ==
                                            stagingWorkflowSettings[1].workflowType &&
                                        stagingWorkflowSettings[0].fileNames.filter(
                                            (fileName) => stagingWorkflowSettings[1].fileNames.indexOf(fileName) < 0,
                                        ).length === 0
                                    ) {
                                        const message = 'Each rule must be unique';
                                        globalMessage.error(message);
                                        return Promise.reject(message);
                                    }
                                }
                                return Promise.resolve();
                            }
                        }
                    },
                };
            },
        ],
    };

    const appStoreUploadAutomation = automation as
        | AutomationAutoUploadBinaryArtifactToAppStore
        | BAAutomationAutoUploadBinaryArtifactToAppStore;

    const isBucketAutomation = automation.type === AutomationType.BAAutoUploadBinaryArtifactToAppStore;

    const savedSettings = appStoreUploadAutomation.data?.uploadWorkflowSettings;

    const uploadRulesOptions = AllAppStoreArtifactUploadRules.map((rule) => {
        const displayText = displayTextForAppStoreUploadRule(rule);

        return {
            value: rule,
            label: displayText,
        };
    });

    return [
        baseFieldWithConditionsValidation,
        {
            label: 'Upload behavior for multiple available builds',
            name: 'uploadRule',
            fieldType: FieldType.Custom,
            showDivider: true,
            initialValue: appStoreUploadAutomation.data?.uploadRule ?? AppStoreArtifactUploadRule.UploadNewestBuildOnly,
            data: uploadRulesOptions,
            rules: [{ required: true, message: 'Upload behavior is required' }],
            renderField: () => {
                return (
                    <Select
                        placeholder="Select an upload behavior"
                        style={{
                            width: '100%',
                        }}
                    >
                        {uploadRulesOptions.map((option) => {
                            return (
                                <Select.Option value={option.value} key={option.value}>
                                    {option.label}
                                </Select.Option>
                            );
                        })}
                    </Select>
                );
            },
        },
        {
            label: null,
            name: 'uploadWorkflowSettings',
            fieldType: FieldType.List,
            showDivider: true,
            initialValue: savedSettings,
            nestedListFields: [
                {
                    fieldType: FieldType.Custom,
                    style: { margin: 0 },
                    renderField: (data) => {
                        return renderUploadWorkflowSettingsField(
                            data,
                            platform,
                            appStoreType,
                            destinationOptions,
                            isBucketAutomation,
                            isCustomCI,
                            buildSystemData,
                        );
                    },
                },
            ],
            listChildrenWrapper: (children, { add }) => {
                const buttonText = (children as React.ReactNode[]).length === 0 ? 'Add rule' : 'Add another rule';
                return (
                    <Space
                        direction="vertical"
                        style={{
                            width: '100%',
                        }}
                        size={16}
                    >
                        {children}
                        <Form.Item shouldUpdate noStyle>
                            {() => {
                                return (
                                    <>
                                        <Button
                                            disabled={false}
                                            icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                            onClick={() => add()}
                                        >
                                            {buttonText}
                                        </Button>
                                    </>
                                );
                            }}
                        </Form.Item>
                    </Space>
                );
            },
        } as FormFieldData,
    ];
}

type StatusOption = [string, string];

type TransitionMilestoneFieldProps = {
    index: number;
    listOperations: {
        remove: (index: number) => void;
    };
    listFieldData: {
        name: number;
        key: number;
    };
    statusOptions: StatusOption[];
};

const TransitionMilestoneField: React.FC<TransitionMilestoneFieldProps> = ({
    index,
    listOperations: { remove },
    listFieldData,
    statusOptions,
}) => {
    const sortedStatusOptions = React.useMemo(() => [...statusOptions].sort(), [statusOptions]);

    return (
        <Form.Item shouldUpdate noStyle>
            {(form) => {
                const transitions: { milestone?: string }[] = form.getFieldValue('milestoneTransitions') ?? [];

                const milestonesUsedByOtherRows = transitions
                    .map((transition, transitionIndex) =>
                        transitionIndex === index ? undefined : transition?.milestone,
                    )
                    .filter(Boolean);

                return (
                    <Space direction="vertical" size={8} style={{ width: '100%' }}>
                        <Row gutter={8} align="top" style={{ width: '100%' }}>
                            <Col span={2}>
                                <div
                                    style={{
                                        lineHeight: '32px',
                                        color: runwayColors.darkTextGrey,
                                    }}
                                >
                                    On
                                </div>
                            </Col>

                            <Col span={7}>
                                <Form.Item
                                    {...listFieldData}
                                    name={[listFieldData.name, 'milestone']}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Milestone is required',
                                        },
                                    ]}
                                    style={{ marginBottom: 0 }}
                                >
                                    <Select placeholder="Select milestone">
                                        {allReleaseMilestones.map((milestone) => (
                                            <Select.Option
                                                value={milestone}
                                                key={milestone}
                                                disabled={milestonesUsedByOtherRows.includes(milestone)}
                                            >
                                                {releaseMilestoneLabels[milestone]}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={3}>
                                <div
                                    style={{
                                        lineHeight: '32px',
                                        color: runwayColors.darkTextGrey,
                                        whiteSpace: 'nowrap',
                                        textAlign: 'center',
                                    }}
                                >
                                    update to
                                </div>
                            </Col>

                            <Col span={10}>
                                <Form.Item
                                    {...listFieldData}
                                    name={[listFieldData.name, 'status']}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Status is required',
                                        },
                                    ]}
                                    style={{ marginBottom: 0 }}
                                >
                                    <Select
                                        placeholder="Select status"
                                        filterOption={filterOptionLabel}
                                        style={{ width: '100%' }}
                                        showSearch
                                    >
                                        {sortedStatusOptions.map((status) => (
                                            <Select.Option value={status[0]} key={status[0]} label={status[1]}>
                                                {status[1]}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={2}>
                                <Button
                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                    danger
                                    type="link"
                                    onClick={() => remove(index)}
                                />
                            </Col>
                        </Row>

                        {transitions[index]?.milestone === ReleaseMilestone.Kickoff && (
                            <Row gutter={8} style={{ width: '100%' }}>
                                <Col span={22}>
                                    <Form.Item
                                        name={[listFieldData.name, 'transitionNewTicketsAfterKickoff']}
                                        valuePropName="checked"
                                        style={{ marginBottom: 0 }}
                                    >
                                        <Checkbox>
                                            Update status of new tickets added to the release after kickoff
                                        </Checkbox>
                                    </Form.Item>
                                </Col>
                            </Row>
                        )}
                    </Space>
                );
            }}
        </Form.Item>
    );
};
const renderTransitionMilestoneField = (
    data: TransitionMilestoneFieldProps,
    statusOptions: StatusOption[],
): React.ReactNode => <TransitionMilestoneField {...data} statusOptions={statusOptions} />;

const renderUploadWorkflowSettingsField: (
    data: any,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    destinationOptions: AppStoreArtifactUploadDestinationTypeOption[],
    isBucketAutomation,
    isCustomCI,
    buildSystemData?: BaseCIIntegrationData,
) => React.ReactNode = (
    { index, listOperations: { remove }, listFieldData },
    platform,
    appStoreType,
    destinationOptions,
    isBucketAutomation,
    isCustomCI,
    buildSystemData,
) => {
    const needsWorkflowInfo = buildSystemData && !isBucketAutomation && !isCustomCI;
    const workflowOptions: AppStoreArtifactUploadWorkflowOption[] = [];

    if (needsWorkflowInfo) {
        if (buildSystemData.workflowName) {
            const stagingWorkflow: AppStoreArtifactUploadWorkflowOption = {
                id: WorkflowType.Staging,
                workflowDescription: 'Release candidate workflow',
                workflowName: buildSystemData.workflowName,
            };
            workflowOptions.push(stagingWorkflow);
        }
        if (buildSystemData.prodWorkflowName) {
            const prodWorkflow: AppStoreArtifactUploadWorkflowOption = {
                id: WorkflowType.Production,
                workflowDescription: 'Release workflow',
                workflowName: buildSystemData.prodWorkflowName,
            };
            workflowOptions.push(prodWorkflow);
        }
    }

    const appStoreTypesSupportingMultiUploads = [AppStoreType.Google];
    const supportsMultiUploads = appStoreTypesSupportingMultiUploads.includes(appStoreType);

    const filePlaceholder = placeholderForFileTypePlatform(platform, appStoreType);

    return (
        <Form.Item
            shouldUpdate
            noStyle
            style={{
                width: '100%',
            }}
        >
            {(form) => {
                return (
                    <>
                        <Space
                            direction="vertical"
                            style={{
                                width: '100%',
                                backgroundColor: antGrey.grey2,
                                borderRadius: 8,
                                padding: '20px 30px',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: 16,
                                }}
                            >
                                <Text strong style={{ fontSize: 16 }}>
                                    Rule {index + 1}
                                </Text>
                                <Button
                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                    danger
                                    type="link"
                                    onClick={() => remove(index)}
                                />
                            </div>
                            {needsWorkflowInfo && (
                                <Form.Item
                                    label="Workflow"
                                    style={{
                                        width: '100%',
                                    }}
                                    {...listFieldData}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select a workflow',
                                            type: 'string',
                                        },
                                    ]}
                                    required
                                    name={[listFieldData.name, 'workflowType']}
                                >
                                    <Select
                                        placeholder="Select a workflow"
                                        style={{
                                            width: '100%',
                                        }}
                                    >
                                        {workflowOptions.map((option) => {
                                            return (
                                                <Select.Option value={option.id} key={option.id}>
                                                    {option.workflowDescription}{' '}
                                                    <Text style={{ color: antGrey.grey7 }}>
                                                        — {option.workflowName}
                                                    </Text>
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                            )}
                            {!isBucketAutomation && (
                                <Form.Item
                                    label="File name"
                                    {...listFieldData}
                                    extra={
                                        <Space>
                                            {' '}
                                            <Text style={{ color: antGrey.grey7 }}>
                                                {!supportsMultiUploads ?
                                                    'The file name of the artifact that will be uploaded to the target destination for this rule.'
                                                :   'The file name(s) of the artifact(s) that will be uploaded to the target destination for this rule.'
                                                }
                                                Tokenized patterns and wildcards are supported.
                                            </Text>{' '}
                                            <Popover
                                                content={
                                                    <PatternTokenHelperTextComponent
                                                        availableTokens={UPLOAD_BINARY_AVAILABLE_TOKENS}
                                                    />
                                                }
                                            >
                                                <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                                            </Popover>
                                        </Space>
                                    }
                                    rules={
                                        !supportsMultiUploads ?
                                            [
                                                {
                                                    required: true,
                                                },
                                                {
                                                    required: true,
                                                    type: 'array',
                                                    validator: (_, fileNames) => {
                                                        if (!Array.isArray(fileNames)) {
                                                            return Promise.reject('Must provide one valid filename');
                                                        }
                                                        if (fileNames.length > 1) {
                                                            return Promise.reject('Only one filename allowed.');
                                                        }
                                                        for (const fileName of fileNames) {
                                                            const [isAcceptableFileName, msg] =
                                                                validateFileNameForAppStoreType(fileName, appStoreType);
                                                            if (isAcceptableFileName) {
                                                                return Promise.resolve();
                                                            } else {
                                                                return Promise.reject(msg);
                                                            }
                                                        }
                                                        return Promise.reject('Must provide one valid filename');
                                                    },
                                                },
                                            ]
                                        :   [
                                                {
                                                    required: true,
                                                },
                                                {
                                                    required: true,
                                                    validator: (_, fileNames) => {
                                                        for (const fileName of fileNames) {
                                                            const [isAcceptableFileName, msg] =
                                                                validateFileNameForAppStoreType(fileName, appStoreType);
                                                            if (isAcceptableFileName) {
                                                                return Promise.resolve();
                                                            } else {
                                                                return Promise.reject(msg);
                                                            }
                                                        }
                                                        return Promise.reject(
                                                            'Must provide at least one valid filename',
                                                        );
                                                    },
                                                },
                                            ]
                                    }
                                    name={[listFieldData.name, 'fileNames']}
                                >
                                    <Select
                                        mode="tags"
                                        allowClear
                                        tokenSeparators={[',', '\n']}
                                        dropdownStyle={{ display: 'none' }}
                                        style={{ width: '100%' }}
                                        placeholder={filePlaceholder}
                                    />
                                </Form.Item>
                            )}
                            <Form.Item
                                label="Destination"
                                required
                                shouldUpdate
                                {...listFieldData}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select a destination',
                                        type: 'string',
                                    },
                                ]}
                                name={[listFieldData.name, 'destinationInstallationId']}
                                extra={`The target destination for the artifact defined by this rule. Destination options are determined by your app's app store and beta integrations.${
                                    appStoreType === AppStoreType.Amazon ?
                                        `Runway will replace the APK with the highest version code in the current
                                           edit in the Amazon Developer Portal with the defined artifact.`
                                    : appStoreType === AppStoreType.Huawei ?
                                        'Uploading a build will also select it for submission in Huawei AppGallery.'
                                    : appStoreType === AppStoreType.Samsung ?
                                        'Uploading a build will also select it for submission in the Samsung Galaxy Store.'
                                    :   ''
                                }`}
                            >
                                <Select
                                    placeholder="Select a destination"
                                    style={{
                                        flex: 1,
                                        width: '100%',
                                    }}
                                >
                                    {destinationOptions.map((option) => {
                                        let disabled = false;
                                        if (
                                            form.getFieldValue('uploadWorkflowSettings')?.[index]?.workflowType ==
                                                WorkflowType.Production &&
                                            option.type == AppStoreArtifactUploadDestinationType.DestinationBetaTesting
                                        ) {
                                            disabled = true;
                                        }
                                        const destinationAlias = option.alias?.trim();

                                        return (
                                            <Select.Option value={option.id} key={option.id} disabled={disabled}>
                                                {option.name}
                                                {destinationAlias && (
                                                    <Text style={{ color: antGrey.grey7 }}> {destinationAlias}</Text>
                                                )}
                                                <Text style={{ color: antGrey.grey7 }}> — </Text>
                                                {option.identifier}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </Form.Item>
                            {appStoreType === AppStoreType.Google && (
                                <Form.Item
                                    label="Track"
                                    shouldUpdate
                                    {...listFieldData}
                                    name={[listFieldData.name, 'trackName']}
                                    extra="Builds will be added to the track and released to all users immediately."
                                    rules={[
                                        (form) => {
                                            return {
                                                validator: (_, selectedTrack) => {
                                                    const selectedDestinationInstallId =
                                                        form.getFieldValue('uploadWorkflowSettings')?.[index]
                                                            ?.destinationInstallationId;
                                                    const selectedDestination = destinationOptions.find(
                                                        (option) =>
                                                            !!selectedDestinationInstallId &&
                                                            option.id === selectedDestinationInstallId,
                                                    );
                                                    if (
                                                        selectedDestination &&
                                                        selectedDestination.type ===
                                                            AppStoreArtifactUploadDestinationType.DestinationAppStore &&
                                                        selectedTrack === 'production'
                                                    ) {
                                                        return Promise.reject(
                                                            `The production track cannot be selected with the ${selectedDestination.name} destination.`,
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            };
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder="Select a track"
                                        style={{
                                            width: '100%',
                                        }}
                                        allowClear
                                    >
                                        {destinationOptions.map((option) => {
                                            if (
                                                form.getFieldValue('uploadWorkflowSettings')?.[index]
                                                    ?.destinationInstallationId === option.id
                                            ) {
                                                const trackNames = option.availableTracks;
                                                return (
                                                    trackNames &&
                                                    trackNames.map((track) => {
                                                        return (
                                                            <Select.Option value={track} key={track}>
                                                                {track}
                                                            </Select.Option>
                                                        );
                                                    })
                                                );
                                            }
                                            return null;
                                        })}
                                    </Select>
                                </Form.Item>
                            )}
                            {appStoreType === AppStoreType.Google && (
                                <Form.Item
                                    label="Create new track release with name"
                                    shouldUpdate
                                    {...listFieldData}
                                    name={[listFieldData.name, 'createNewTrackReleaseWithPatternedName']}
                                    extra="Optionally create a new track release per upload using the supplied naming pattern. If left blank, Runway will use an existing track release matching the version in question."
                                    rules={[
                                        {
                                            validator: (rule, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }

                                                const pattern = value as string;

                                                return validatePattern(
                                                    pattern,
                                                    'Release name',
                                                    RequireAtLeastOneOfTokensForAndroidTrackReleaseName,
                                                    disallowedTokensForForAndroidTrackReleaseName(),
                                                );
                                            },
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder="e.g. {version}.{appStoreBuildNumber}"
                                        autoComplete="off"
                                        allowClear
                                    />
                                </Form.Item>
                            )}
                        </Space>
                    </>
                );
            }}
        </Form.Item>
    );
};

function generateAutoUploadDsymsToStabilityMonitoringFields(
    baseField: FormFieldData,
    automation: Automation,
    buildSystemData: BaseCIIntegrationData,
    destinationOptions: DsymUploadDestinationOption[],
) {
    const baseFieldWithConditionsValidation = {
        ...baseField,
        rules: [
            (form) => {
                return {
                    validator: (rule, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }

                        const uploadWorkflowSettings: DsymsUploadWorkflowSettings[] =
                            form.getFieldValue('uploadWorkflowSettings') ?? [];
                        if (uploadWorkflowSettings.length === 0) {
                            const message = 'At least one setting is required to enable this automation';
                            globalMessage.error(message);
                            return Promise.reject(message);
                        } else {
                            const stagingWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Staging;
                            });
                            const prodWorkflowSettings = uploadWorkflowSettings.filter((setting) => {
                                return setting.workflowType == WorkflowType.Production;
                            });
                            if (stagingWorkflowSettings.length > 1 && prodWorkflowSettings.length > 1) {
                                const message =
                                    'A maximum of one release and one release candidate settings are allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (stagingWorkflowSettings.length > 1) {
                                const message = 'A maximum of one release candidate setting is allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else if (prodWorkflowSettings.length > 1) {
                                const message = 'A maximum of one release setting is allowed';
                                globalMessage.error(message);
                                return Promise.reject(message);
                            } else {
                                return Promise.resolve();
                            }
                        }
                    },
                };
            },
        ],
    };

    const workflowOptions: DsymsUploadWorkflowOption[] = [];
    if (buildSystemData) {
        if (buildSystemData.workflowName) {
            const stagingWorkflow: DsymsUploadWorkflowOption = {
                id: WorkflowType.Staging,
                workflowDescription: 'Release candidate workflow',
                workflowName: buildSystemData.workflowName,
            };
            workflowOptions.push(stagingWorkflow);
        }
        if (buildSystemData.prodWorkflowName) {
            const prodWorkflow: DsymsUploadWorkflowOption = {
                id: WorkflowType.Production,
                workflowDescription: 'Release workflow',
                workflowName: buildSystemData.prodWorkflowName,
            };
            workflowOptions.push(prodWorkflow);
        }
    }

    const dsymsUploadAutomation = automation as AutomationAutoUploadDsymsToStabilityMonitoring;
    const savedSettings = dsymsUploadAutomation.data?.uploadWorkflowSettings;
    const defaultStabilityMonitoringInstallationIds = destinationOptions.map((option) => option.installationId);
    const uploadSettingsFields = [];
    if (savedSettings) {
        savedSettings.forEach((setting) => {
            uploadSettingsFields.push({
                workflowType: setting.workflowType,
                fileName: setting.fileNames?.[0] ?? `{*}.dSYM.zip`,
                stabilityMonitoringInstallationIds:
                    setting.stabilityMonitoringInstallationIds ?? defaultStabilityMonitoringInstallationIds,
            });
        });
    } else {
        uploadSettingsFields.push({
            workflowType: null,
            fileName: `{*}.dSYM.zip`,
            stabilityMonitoringInstallationIds: defaultStabilityMonitoringInstallationIds,
        });
    }

    const availableTokens: PatternToken[] = [
        PatternToken.Version,
        PatternToken.VersionConcise,
        PatternToken.ReleaseName,
        PatternToken.BuildCI,
        PatternToken.ReleasePilot,
        PatternToken.ReleaseBranchName,
        PatternToken.WorkingBranchName,
        PatternToken.Wildcard,
    ];

    return [
        baseFieldWithConditionsValidation,
        {
            label: null,
            name: 'uploadWorkflowSettings',
            fieldType: FieldType.List,
            showDivider: true,
            initialValue: uploadSettingsFields,
            nestedListFields: [
                {
                    fieldType: FieldType.Custom,
                    style: { margin: 0 },
                    renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                        return (
                            <Form.Item
                                shouldUpdate
                                noStyle
                                style={{
                                    width: '100%',
                                }}
                            >
                                {() => {
                                    return (
                                        <>
                                            <Space
                                                direction="vertical"
                                                size={14}
                                                style={{
                                                    width: '100%',
                                                    backgroundColor: antGrey.grey2,
                                                    borderRadius: 8,
                                                    padding: '20px 30px',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <Text>Rule {index + 1}</Text>
                                                    <Button
                                                        icon={
                                                            <DeleteOutlined style={{ color: runwayColors.statusRed }} />
                                                        }
                                                        danger
                                                        type="link"
                                                        onClick={() => remove(index)}
                                                    />
                                                </div>
                                                <Space
                                                    direction="vertical"
                                                    size={20}
                                                    style={{
                                                        width: '100%',
                                                        paddingTop: 8,
                                                    }}
                                                >
                                                    <Space align="center">
                                                        <Text
                                                            style={{
                                                                fontWeight: 600,
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            Workflow
                                                        </Text>
                                                        <Tooltip title="The type of CI/CD workflow whose dSYM file the setting will apply to">
                                                            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                                                        </Tooltip>
                                                    </Space>
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            gap: 8,
                                                            alignItems: 'center',
                                                            marginTop: -4,
                                                        }}
                                                    >
                                                        <Form.Item
                                                            noStyle
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            {...listFieldData}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please select a workflow',
                                                                    type: 'string',
                                                                },
                                                            ]}
                                                            name={[listFieldData.name, 'workflowType']}
                                                        >
                                                            <Select
                                                                placeholder="Select a workflow"
                                                                style={{
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {workflowOptions.map((option) => {
                                                                    return (
                                                                        <Select.Option
                                                                            value={option.id}
                                                                            key={option.id}
                                                                        >
                                                                            {option.workflowDescription}{' '}
                                                                            <Text style={{ color: antGrey.grey7 }}>
                                                                                — {option.workflowName}
                                                                            </Text>
                                                                        </Select.Option>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </Space>

                                                <Space
                                                    direction="vertical"
                                                    size={14}
                                                    style={{
                                                        width: '100%',
                                                        paddingTop: 8,
                                                    }}
                                                >
                                                    <Space align="center">
                                                        <Text
                                                            style={{
                                                                fontWeight: 600,
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            File name
                                                        </Text>
                                                        <Tooltip
                                                            title={
                                                                'The name of the dSYM zip file that will be uploaded to the target destination for this setting. The default value of {*}.dSYM.zip will be used if no file name is specified.'
                                                            }
                                                        >
                                                            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                                                        </Tooltip>
                                                    </Space>
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            gap: 8,
                                                            alignItems: 'center',
                                                            marginTop: -4,
                                                        }}
                                                    >
                                                        <Form.Item
                                                            noStyle
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            {...listFieldData}
                                                            rules={[
                                                                {
                                                                    type: 'string',
                                                                    validator: (_, fileName) => {
                                                                        if (
                                                                            !fileName ||
                                                                            (fileName.length > 4 &&
                                                                                fileName.endsWith('.zip')) ||
                                                                            (fileName.length > 5 &&
                                                                                (fileName.endsWith('.dsym') ||
                                                                                    fileName.endsWith('.dSYM')))
                                                                        ) {
                                                                            return Promise.resolve();
                                                                        } else {
                                                                            return Promise.reject(
                                                                                'dSYM filename must be of type .zip, .dsym, or .dSYM.',
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            ]}
                                                            name={[listFieldData.name, 'fileName']}
                                                        >
                                                            <Input allowClear style={{ width: '100%' }} />
                                                        </Form.Item>
                                                    </div>
                                                    <div style={{ marginTop: -10 }}>
                                                        <Text style={{ color: antGrey.grey7 }}>
                                                            Tokenized patterns and wildcards are supported.
                                                        </Text>{' '}
                                                        <Popover
                                                            content={
                                                                <PatternTokenHelperTextComponent
                                                                    availableTokens={availableTokens}
                                                                />
                                                            }
                                                        >
                                                            <InfoCircleOutlined style={{ color: antGrey.grey7 }} />
                                                        </Popover>
                                                    </div>
                                                </Space>

                                                <Space
                                                    direction="vertical"
                                                    size={14}
                                                    style={{
                                                        width: '100%',
                                                        paddingTop: 8,
                                                    }}
                                                >
                                                    <Space align="center">
                                                        <Text
                                                            style={{
                                                                fontWeight: 600,
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            Upload to
                                                        </Text>
                                                        <Tooltip title="Which stability monitoring integrations should receive dSYMs matching this rule. Options come from the stability monitoring integrations connected to this step's downstream rollout step(s).">
                                                            <InfoCircleOutlined style={{ color: antGrey.grey6 }} />
                                                        </Tooltip>
                                                    </Space>
                                                    <Form.Item
                                                        noStyle
                                                        {...listFieldData}
                                                        name={[
                                                            listFieldData.name,
                                                            'stabilityMonitoringInstallationIds',
                                                        ]}
                                                        rules={[
                                                            {
                                                                validator: (_, value) => {
                                                                    if (
                                                                        destinationOptions.length > 0 &&
                                                                        (!value || value.length === 0)
                                                                    ) {
                                                                        return Promise.reject(
                                                                            'Select at least one stability monitoring integration to upload to.',
                                                                        );
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            mode="multiple"
                                                            placeholder={
                                                                destinationOptions.length === 0 ?
                                                                    'No stability monitoring integrations connected to downstream rollout steps'
                                                                :   'Select stability monitoring integrations'
                                                            }
                                                            disabled={destinationOptions.length === 0}
                                                            style={{ width: '100%' }}
                                                        >
                                                            {destinationOptions.map((option) => {
                                                                const provenance =
                                                                    option.rolloutStepNames.length > 0 ?
                                                                        ` (used by ${option.rolloutStepNames.join(', ')})`
                                                                    :   '';
                                                                return (
                                                                    <Select.Option
                                                                        value={option.installationId}
                                                                        key={option.installationId}
                                                                    >
                                                                        {option.integrationName}
                                                                        <Text style={{ color: antGrey.grey7 }}>
                                                                            {provenance}
                                                                        </Text>
                                                                    </Select.Option>
                                                                );
                                                            })}
                                                        </Select>
                                                    </Form.Item>
                                                </Space>
                                            </Space>
                                        </>
                                    );
                                }}
                            </Form.Item>
                        );
                    },
                },
            ],
            listChildrenWrapper: (children, { add }) => {
                const buttonText = (children as React.ReactNode[]).length === 0 ? 'Add rule' : 'Add another rule';
                return (
                    <Space
                        direction="vertical"
                        style={{
                            width: '100%',
                        }}
                        size={16}
                    >
                        {children}
                        <Form.Item shouldUpdate noStyle>
                            {(form) => {
                                const currentUploadSettings = form.getFieldValue('uploadWorkflowSettings');
                                const disableButton = currentUploadSettings?.length > 1;
                                return (
                                    <>
                                        <Button
                                            disabled={disableButton}
                                            icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                            onClick={() =>
                                                add({
                                                    workflowType: null,
                                                    fileName: `{*}.dSYM.zip`,
                                                    stabilityMonitoringInstallationIds:
                                                        defaultStabilityMonitoringInstallationIds,
                                                })
                                            }
                                        >
                                            {buttonText}
                                        </Button>
                                    </>
                                );
                            }}
                        </Form.Item>
                    </Space>
                );
            },
        } as FormFieldData,
    ];
}

function generateAutoHaltOrPromoteFields(
    baseField: FormFieldData,
    automation: Automation,
    appStoreType: AppStoreType,
    connectedCapabilities: IntegrationCapability[],
    stabilityIntegrations: Integration[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
    healthMetricsLink?: string,
    monitoringChecklistItemTemplates?: ChecklistItemTemplate[],
    isWorkflowsRolloutStepEnabled?: boolean,
) {
    const autoPromoteOrAutoHaltAutomation = automation as
        | AutomationPromoteStablePhasedRelease
        | AutomationHaltUnstableRelease;
    const isAutoPromote = automation.type === AutomationType.AutoPromoteStablePhasedReleases;

    const monitoringConditionOptions: MonitoringConditionOption[] = automationConditionsForAutomationType(
        automation.type,
        appStoreType,
    ).map((type) => {
        return {
            id: type,
            title: displayTextForAutomationConditionType(type),
        };
    });

    const conditionFields = [];
    const perIntegrationAdoptionThresholds = autoPromoteOrAutoHaltAutomation.data?.adoptionThresholds;
    if (perIntegrationAdoptionThresholds && Object.keys(perIntegrationAdoptionThresholds).length > 0) {
        for (const [installationId, threshold] of Object.entries(perIntegrationAdoptionThresholds)) {
            if (!threshold) continue;
            conditionFields.push({
                id: MonitoringAutomationConditionType.Adoption,
                threshold,
                installationId,
            });
        }
    } else if (autoPromoteOrAutoHaltAutomation.data?.adoptionThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.Adoption,
            threshold: autoPromoteOrAutoHaltAutomation.data?.adoptionThreshold,
        });
    }

    if (autoPromoteOrAutoHaltAutomation.data?.phasedReleaseDayThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.PhasedReleaseDay,
            threshold: autoPromoteOrAutoHaltAutomation.data?.phasedReleaseDayThreshold,
        });
    }

    if (autoPromoteOrAutoHaltAutomation.data?.stagedRolloutPercentageThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.StagedRolloutPercentage,
            threshold: autoPromoteOrAutoHaltAutomation.data?.stagedRolloutPercentageThreshold,
        });
    }

    const baseFieldWithConditionsValidation = {
        ...baseField,
        rules: [
            (form) => {
                return {
                    validator: (_, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }

                        const conditions: unknown[] = form.getFieldValue('conditions') ?? [];
                        const monitoringConditions: unknown[] = form.getFieldValue('monitoringConditions') ?? [];
                        if (conditions.length === 0 || monitoringConditions.length === 0) {
                            return Promise.reject(
                                'At least one condition and one associated health metric are required to enable this automation.',
                            );
                        } else {
                            return Promise.resolve();
                        }
                    },
                };
            },
        ],
    };

    if (!isAutoPromote && isWorkflowsRolloutStepEnabled) {
        const baseFieldWithConditionGroupsValidation = {
            ...baseField,
            rules: [
                (form) => {
                    return {
                        validator: (_, value) => {
                            if (!value) {
                                return Promise.resolve();
                            }

                            const conditionGroups: HaltPhasedRolloutConditionGroupFormValue[] =
                                form.getFieldValue('conditionGroups') ?? [];
                            if (conditionGroups.length === 0) {
                                return Promise.reject(
                                    'At least one condition group is required to enable this automation.',
                                );
                            }

                            const hasInvalidGroup = conditionGroups.some(
                                (group) =>
                                    (group.conditions ?? []).length === 0 ||
                                    (group.monitoringConditions ?? []).length === 0,
                            );
                            if (hasInvalidGroup) {
                                return Promise.reject(
                                    'Each condition group requires at least one condition and one associated health metric.',
                                );
                            }

                            return Promise.resolve();
                        },
                    };
                },
            ],
        };

        return [
            baseFieldWithConditionGroupsValidation,
            generateHaltPhasedRolloutConditionGroupsField(
                autoPromoteOrAutoHaltAutomation.data?.conditionGroups ?? [],
                connectedCapabilities,
                monitoringConditionOptions,
                monitoringMetrics,
                healthMetricsLink,
                stabilityIntegrations,
            ),
        ];
    }

    return [
        baseFieldWithConditionsValidation,
        generateThresholdConditionsField(
            'conditions',
            'Apply this automation under the following conditions:',
            conditionFields,
            connectedCapabilities,
            monitoringConditionOptions,
            { stabilityIntegrations },
        ),
        ...(monitoringMetrics && monitoringMetrics.length > 0 ?
            [
                generateMonitoringConditionsField(
                    isAutoPromote ?
                        'Release to 100% of users if...'
                    :   'Halt rollout if any of these health metric conditions are not met:',
                    autoPromoteOrAutoHaltAutomation.data?.monitoringConditions ?? [],
                    isAutoPromote,
                    isAutoPromote ? 'AND' : 'OR',
                    monitoringMetrics,
                    {
                        isAutoPromote,
                        minutesByMetricId: autoPromoteOrAutoHaltAutomation.data?.metricMaxDataAgeMinutes,
                    },
                ),
                generateLinkToHealthMetricsField(
                    'Constraints for health metrics can be managed from',
                    healthMetricsLink,
                ),
            ]
        :   [
                generateLinkToHealthMetricsField(
                    'To add health metric conditions, you first need to add health metric constraints in',
                    healthMetricsLink,
                ),
            ]),
        // Auto-halt automation shouldn't depend on checklist items because it doesn't make sense to wait for approval to halt a bad rollout
        ...(isAutoPromote ?
            [
                generateMonitoringChecklistItemsField(
                    'Require checklist item completion for...',
                    monitoringChecklistItemTemplates,
                    autoPromoteOrAutoHaltAutomation.data?.checklistItems ?? [],
                ),
            ]
        :   []),
    ];
}

export type HaltPhasedRolloutConditionGroupFormValue = {
    id: string;
    name: string;
    conditions?: { id: MonitoringAutomationConditionType; threshold?: number; installationId?: string }[];
    monitoringConditions?: { id: string; maxDataAgeMinutes?: number; threshold?: number }[];
};

export type NotificationTriggerOption = {
    id: NotificationTriggerConditionType;
    title: string;
    input?: { min: number; max: number; precision: number; addonAfter?: string; descriptionText: string };
};

export type ConditionGroupsVariant = 'automation' | 'notification';

const conditionGroupBorderColor = (variant: ConditionGroupsVariant) =>
    variant === 'notification' ? antGrey.grey5 : antGrey.grey4;

const conditionRowBorderRadius = (variant: ConditionGroupsVariant) => (variant === 'notification' ? 4 : 8);

export const haltConditionGroupHasSelectedCondition = (group: HaltPhasedRolloutConditionGroupFormValue): boolean => {
    return (
        (group.conditions ?? []).some((condition) => !!condition?.id) ||
        (group.monitoringConditions ?? []).some((condition) => !!condition?.id)
    );
};

export const defaultHaltConditionGroupName = (index: number) => `Group ${index + 1}`;

const HALT_METRICS_SECTION_TITLE = 'halt if these health metric conditions are not met:';

export const haltConditionGroupsFormValueToConfig = (
    groups: HaltPhasedRolloutConditionGroupFormValue[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
): AutomationHaltPromotePhasedReleaseConditionGroup[] =>
    groups.map((group, index) => {
        const conditionGroup: AutomationHaltPromotePhasedReleaseConditionGroup = {
            id: group.id,
            name: group.name?.trim() || defaultHaltConditionGroupName(index),
            monitoringConditions: [],
            metricMaxDataAgeMinutes: metricMaxDataAgeMinutesFromFormValue(
                group.monitoringConditions,
                monitoringMetrics,
            ),
        };

        for (const condition of group.conditions ?? []) {
            switch (condition.id) {
                case MonitoringAutomationConditionType.Adoption:
                    if (condition.installationId && condition.threshold != null) {
                        conditionGroup.adoptionThresholds = {
                            ...(conditionGroup.adoptionThresholds ?? {}),
                            [condition.installationId]: condition.threshold,
                        };
                    }
                    break;
                case MonitoringAutomationConditionType.PhasedReleaseDay:
                    conditionGroup.phasedReleaseDayThreshold = condition.threshold;
                    break;
                case MonitoringAutomationConditionType.StagedRolloutPercentage:
                    conditionGroup.stagedRolloutPercentageThreshold = condition.threshold;
                    break;
            }
        }

        for (const item of group.monitoringConditions ?? []) {
            switch (item.id) {
                case NotificationTriggerConditionType.RolloutDay:
                    conditionGroup.triggerRolloutDayThreshold = item.threshold;
                    break;
                case NotificationTriggerConditionType.RolloutPercentage:
                    conditionGroup.triggerRolloutPercentageThreshold = item.threshold;
                    break;
                case NotificationTriggerConditionType.PreviousReleaseFullyRolledOut:
                    conditionGroup.triggerOnPreviousReleaseFullyRolledOut = true;
                    break;
                default:
                    conditionGroup.monitoringConditions.push(item.id);
            }
        }

        return conditionGroup;
    });

const conditionFieldsFromHaltConditionGroup = (
    group: AutomationHaltPromotePhasedReleaseConditionGroup,
): HaltPhasedRolloutConditionGroupFormValue['conditions'] => {
    const conditionFields = [];
    if (group.adoptionThresholds && Object.keys(group.adoptionThresholds).length > 0) {
        for (const [installationId, threshold] of Object.entries(group.adoptionThresholds)) {
            if (!threshold) continue;
            conditionFields.push({
                id: MonitoringAutomationConditionType.Adoption,
                threshold,
                installationId,
            });
        }
    }
    if (group.phasedReleaseDayThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.PhasedReleaseDay,
            threshold: group.phasedReleaseDayThreshold,
        });
    }
    if (group.stagedRolloutPercentageThreshold) {
        conditionFields.push({
            id: MonitoringAutomationConditionType.StagedRolloutPercentage,
            threshold: group.stagedRolloutPercentageThreshold,
        });
    }
    return conditionFields;
};

const triggerItemsFromHaltConditionGroup = (
    group: AutomationHaltPromotePhasedReleaseConditionGroup,
): HaltPhasedRolloutConditionGroupFormValue['monitoringConditions'] => {
    const items = [];
    if (group.triggerRolloutDayThreshold != null) {
        items.push({ id: NotificationTriggerConditionType.RolloutDay, threshold: group.triggerRolloutDayThreshold });
    }
    if (group.triggerRolloutPercentageThreshold != null) {
        items.push({
            id: NotificationTriggerConditionType.RolloutPercentage,
            threshold: group.triggerRolloutPercentageThreshold,
        });
    }
    if (group.triggerOnPreviousReleaseFullyRolledOut) {
        items.push({ id: NotificationTriggerConditionType.PreviousReleaseFullyRolledOut });
    }
    return items;
};

export const haltConditionGroupsToFormValue = (
    groups: AutomationHaltPromotePhasedReleaseConditionGroup[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
): HaltPhasedRolloutConditionGroupFormValue[] => {
    return groups.map((group, index) => ({
        id: group.id,
        name: group.name || defaultHaltConditionGroupName(index),
        conditions: conditionFieldsFromHaltConditionGroup(group),
        monitoringConditions: [
            ...triggerItemsFromHaltConditionGroup(group),
            ...(group.monitoringConditions
                ?.filter((id) => !monitoringMetrics || monitoringMetrics.some((metric) => metric.id === id))
                .map((id) => ({
                    id,
                    maxDataAgeMinutes: group.metricMaxDataAgeMinutes?.[id],
                })) ?? []),
        ],
    }));
};

export const generateHaltPhasedRolloutConditionGroupsField = (
    conditionGroups: AutomationHaltPromotePhasedReleaseConditionGroup[],
    connectedCapabilities: IntegrationCapability[],
    monitoringConditionOptions: MonitoringConditionOption[],
    monitoringMetrics?: AppMonitoringHealthMetric[],
    healthMetricsLink?: string,
    stabilityIntegrations?: Integration[],
    metricsSectionTitle: string = HALT_METRICS_SECTION_TITLE,
    extraTriggerOptions?: NotificationTriggerOption[],
    variant: ConditionGroupsVariant = 'automation',
): FormFieldData => {
    return {
        name: 'conditionGroupsField',
        fieldType: FieldType.Custom,
        skipFormItemWrapper: true,
        data: {
            formListName: 'conditionGroups',
            initialValue: haltConditionGroupsToFormValue(conditionGroups, monitoringMetrics),
        },
        renderField: ({ formListName, initialValue }) => (
            <HaltPhasedRolloutConditionGroupsField
                formListName={formListName}
                initialValue={initialValue}
                connectedCapabilities={connectedCapabilities}
                monitoringConditionOptions={monitoringConditionOptions}
                monitoringMetrics={monitoringMetrics}
                healthMetricsLink={healthMetricsLink}
                stabilityIntegrations={stabilityIntegrations}
                metricsSectionTitle={metricsSectionTitle}
                extraTriggerOptions={extraTriggerOptions}
                variant={variant}
            />
        ),
    };
};

const HaltPhasedRolloutConditionGroupsField: React.FC<{
    formListName: any;
    initialValue: HaltPhasedRolloutConditionGroupFormValue[];
    connectedCapabilities: IntegrationCapability[];
    monitoringConditionOptions: MonitoringConditionOption[];
    monitoringMetrics?: AppMonitoringHealthMetric[];
    healthMetricsLink?: string;
    stabilityIntegrations?: Integration[];
    metricsSectionTitle: string;
    extraTriggerOptions?: NotificationTriggerOption[];
    variant: ConditionGroupsVariant;
}> = ({
    formListName,
    initialValue,
    connectedCapabilities,
    monitoringConditionOptions,
    monitoringMetrics,
    healthMetricsLink,
    stabilityIntegrations,
    metricsSectionTitle,
    extraTriggerOptions,
    variant,
}) => {
    const isNotificationVariant = variant === 'notification';
    const buildNewGroup = (index: number): HaltPhasedRolloutConditionGroupFormValue => ({
        id: `condition-group-${Date.now()}-${index}`,
        name: defaultHaltConditionGroupName(index),
        conditions: [],
        monitoringConditions: [],
    });

    return (
        <Form.List
            name={formListName}
            initialValue={initialValue}
            rules={[
                {
                    validator: (_, groups: HaltPhasedRolloutConditionGroupFormValue[] | undefined) =>
                        (groups ?? []).every(haltConditionGroupHasSelectedCondition) ?
                            Promise.resolve()
                        :   Promise.reject(new Error('Each group needs at least one condition')),
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => {
                const groups = fields.map((field, index) => ({ field, index }));
                return (
                    <Space direction="vertical" style={{ width: '100%' }} size={16}>
                        {groups.length === 0 && (
                            <Button
                                block={isNotificationVariant}
                                icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                onClick={() => add(buildNewGroup(0))}
                            >
                                {extraTriggerOptions ? 'Add trigger logic group' : 'Add group'}
                            </Button>
                        )}
                        {groups.map(({ field, index }) => (
                            <React.Fragment key={field.key}>
                                <HaltPhasedRolloutConditionGroupCard
                                    groupField={field}
                                    groupIndex={index}
                                    formListName={formListName}
                                    metricsSectionTitle={metricsSectionTitle}
                                    extraTriggerOptions={extraTriggerOptions}
                                    variant={variant}
                                    onDuplicate={(group) =>
                                        add(
                                            {
                                                ...group,
                                                id: `condition-group-${Date.now()}`,
                                                name: `${group.name} copy`,
                                            },
                                            index + 1,
                                        )
                                    }
                                    onDelete={() => remove(index)}
                                    connectedCapabilities={connectedCapabilities}
                                    monitoringConditionOptions={monitoringConditionOptions}
                                    monitoringMetrics={monitoringMetrics}
                                    stabilityIntegrations={stabilityIntegrations}
                                />
                                {index < groups.length - 1 && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 12,
                                            color: antGrey.grey6,
                                            width: '100%',
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                borderTop: `1px solid ${conditionGroupBorderColor(variant)}`,
                                            }}
                                        />
                                        <Text style={{ color: antGrey.grey6, textTransform: 'uppercase' }}>or</Text>
                                        <div
                                            style={{
                                                flex: 1,
                                                borderTop: `1px solid ${conditionGroupBorderColor(variant)}`,
                                            }}
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                        {groups.length > 0 && (
                            <Button
                                block={isNotificationVariant}
                                icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                onClick={() => add(buildNewGroup(groups.length))}
                            >
                                {extraTriggerOptions ? 'Add trigger logic group' : 'Add group'}
                            </Button>
                        )}
                        <Form.ErrorList errors={errors} />
                        <div style={{ textAlign: isNotificationVariant ? 'center' : undefined }}>
                            {monitoringMetrics && monitoringMetrics.length > 0 ?
                                generateLinkToHealthMetricsField(
                                    'Constraints for health metrics can be managed from',
                                    healthMetricsLink,
                                ).renderField(null)
                            :   generateLinkToHealthMetricsField(
                                    'To add health metric conditions, you first need to add health metric constraints in',
                                    healthMetricsLink,
                                ).renderField(null)
                            }
                        </div>
                    </Space>
                );
            }}
        </Form.List>
    );
};

const HaltPhasedRolloutConditionGroupCard: React.FC<{
    groupField: any;
    groupIndex: number;
    formListName: any;
    metricsSectionTitle: string;
    extraTriggerOptions?: NotificationTriggerOption[];
    variant: ConditionGroupsVariant;
    onDuplicate: (group: HaltPhasedRolloutConditionGroupFormValue) => void;
    onDelete: () => void;
    connectedCapabilities: IntegrationCapability[];
    monitoringConditionOptions: MonitoringConditionOption[];
    monitoringMetrics?: AppMonitoringHealthMetric[];
    stabilityIntegrations?: Integration[];
}> = ({
    groupField,
    groupIndex,
    formListName,
    metricsSectionTitle,
    extraTriggerOptions,
    variant,
    onDuplicate,
    onDelete,
    connectedCapabilities,
    monitoringConditionOptions,
    monitoringMetrics,
    stabilityIntegrations,
}) => {
    return (
        <Form.Item shouldUpdate noStyle>
            {(form) => {
                const groupPath = [...(Array.isArray(formListName) ? formListName : [formListName]), groupField.name];
                const group = form.getFieldValue(groupPath) as HaltPhasedRolloutConditionGroupFormValue;
                const name = group?.name || defaultHaltConditionGroupName(groupIndex);

                return (
                    <div
                        style={{
                            border: `1px solid ${conditionGroupBorderColor(variant)}`,
                            borderRadius: 4,
                            background: runwayColors.white,
                        }}
                    >
                        <Form.Item hidden name={[groupField.name, 'id']} initialValue={group?.id}>
                            <Input />
                        </Form.Item>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '8px 12px',
                                borderBottom: `1px solid ${conditionGroupBorderColor(variant)}`,
                                backgroundColor: variant === 'notification' ? antGrey.grey2 : undefined,
                            }}
                        >
                            <Form.Item
                                name={[groupField.name, 'name']}
                                initialValue={name}
                                rules={[{ required: true, message: 'Group name is required' }]}
                                style={{ margin: 0, marginRight: 12 }}
                            >
                                <Input
                                    placeholder={defaultHaltConditionGroupName(groupIndex)}
                                    style={{ width: `${Math.max(name.length, 8) + 4}ch`, maxWidth: 400 }}
                                />
                            </Form.Item>
                            <Space size={4}>
                                <Button type="link" icon={<CopyOutlined />} onClick={() => onDuplicate(group)} />
                                <Button type="link" danger icon={<DeleteOutlined />} onClick={onDelete} />
                            </Space>
                        </div>
                        <div style={{ padding: 16 }}>
                            <Text
                                style={{
                                    ...titleStyle,
                                    fontSize: 12,
                                    fontWeight: 400,
                                }}
                            >
                                under the conditions:
                            </Text>
                            <NestedHaltThresholdConditions
                                groupField={groupField}
                                groupPath={groupPath}
                                variant={variant}
                                connectedCapabilities={connectedCapabilities}
                                monitoringConditionOptions={monitoringConditionOptions}
                                stabilityIntegrations={stabilityIntegrations}
                            />
                            <Divider style={{ margin: '16px 0' }} />
                            <Text
                                style={{
                                    ...titleStyle,
                                    fontSize: 12,
                                    fontWeight: 400,
                                }}
                            >
                                {metricsSectionTitle}
                            </Text>
                            <NestedHaltMonitoringConditions
                                groupField={groupField}
                                groupPath={groupPath}
                                monitoringMetrics={monitoringMetrics}
                                extraTriggerOptions={extraTriggerOptions}
                                variant={variant}
                            />
                        </div>
                    </div>
                );
            }}
        </Form.Item>
    );
};

const NestedHaltThresholdConditions: React.FC<{
    groupField: any;
    groupPath: any[];
    connectedCapabilities: IntegrationCapability[];
    monitoringConditionOptions: MonitoringConditionOption[];
    stabilityIntegrations?: Integration[];
    variant: ConditionGroupsVariant;
}> = ({ groupField, groupPath, connectedCapabilities, monitoringConditionOptions, stabilityIntegrations, variant }) => (
    <Form.List name={[groupField.name, 'conditions']}>
        {(fields, { add, remove }) => (
            <Space direction="vertical" style={{ width: '100%', marginTop: 10 }} size={12}>
                {fields.map((field, index) => (
                    <Form.Item shouldUpdate noStyle key={field.key}>
                        {(form) => {
                            const conditions = form.getFieldValue([...groupPath, 'conditions']) ?? [];
                            const usedConditionsMap =
                                conditions.reduce(
                                    (acc, condition) => {
                                        if (
                                            condition?.id &&
                                            condition.id !== MonitoringAutomationConditionType.Adoption
                                        ) {
                                            acc[condition.id] = true;
                                        }
                                        return acc;
                                    },
                                    {} as Record<string, boolean>,
                                ) ?? {};
                            const selectedInstallationId: string | undefined = form.getFieldValue([
                                ...groupPath,
                                'conditions',
                                field.name,
                                'installationId',
                            ]);
                            const usedAdoptionInstallations = new Set<string>(
                                (conditions ?? [])
                                    .filter(
                                        (condition, conditionIndex) =>
                                            conditionIndex !== field.name &&
                                            condition?.id === MonitoringAutomationConditionType.Adoption &&
                                            !!condition?.installationId,
                                    )
                                    .map((condition) => condition.installationId as string),
                            );
                            const selectedConditionId = form.getFieldValue([
                                ...groupPath,
                                'conditions',
                                field.name,
                                'id',
                            ]);
                            const selectedConditionThreshold = form.getFieldValue([
                                ...groupPath,
                                'conditions',
                                field.name,
                                'threshold',
                            ]);
                            const conditionInputData =
                                selectedConditionId ?
                                    inputFieldDataForMonitoringConditionType(selectedConditionId, false)
                                :   null;
                            const showStabilityIntegrationSelect =
                                selectedConditionId === MonitoringAutomationConditionType.Adoption &&
                                (stabilityIntegrations?.length ?? 0) > 0;
                            const hasRequiredCapability =
                                selectedConditionId ?
                                    hasRequiredCapabilityForConditionType(selectedConditionId, connectedCapabilities)
                                :   false;

                            return (
                                <>
                                    <Space
                                        direction="vertical"
                                        size={10}
                                        style={{
                                            width: '100%',
                                            backgroundColor: antGrey.grey2,
                                            borderRadius: conditionRowBorderRadius(variant),
                                            padding: '14px 16px',
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <NumericBadge value={index + 1} />
                                            <Form.Item
                                                noStyle
                                                name={[field.name, 'id']}
                                                rules={[{ required: true, message: 'Please select a condition' }]}
                                            >
                                                <Select
                                                    placeholder="Select a condition"
                                                    style={{ width: '100%', minWidth: 0 }}
                                                >
                                                    {monitoringConditionOptions.map((option) => (
                                                        <Select.Option
                                                            value={option.id}
                                                            key={option.id}
                                                            disabled={usedConditionsMap[option.id]}
                                                        >
                                                            {option.title}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                            <Button
                                                type="link"
                                                danger
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(index)}
                                            />
                                        </div>
                                        {conditionInputData &&
                                            (showStabilityIntegrationSelect ?
                                                <div
                                                    style={{
                                                        marginLeft: 44,
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        gap: 24,
                                                        alignItems: 'flex-start',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 4,
                                                            width: 170,
                                                        }}
                                                    >
                                                        <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                            {conditionInputData.descriptionText}
                                                        </Typography.Text>
                                                        <Form.Item
                                                            noStyle
                                                            name={[field.name, 'threshold']}
                                                            rules={conditionInputData.validationRules}
                                                        >
                                                            <InputNumber
                                                                placeholder="Threshold"
                                                                precision={conditionInputData.precision}
                                                                addonAfter={conditionInputData.addonAfter}
                                                                type="number"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </Form.Item>
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: 4,
                                                            width: 220,
                                                        }}
                                                    >
                                                        <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                            reported by
                                                        </Typography.Text>
                                                        <Form.Item
                                                            noStyle
                                                            name={[field.name, 'installationId']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        'Please select a stability monitoring integration',
                                                                    type: 'string',
                                                                },
                                                            ]}
                                                        >
                                                            <Select
                                                                placeholder="Select integration"
                                                                style={{ width: '100%' }}
                                                            >
                                                                {(stabilityIntegrations ?? []).map((integration) => (
                                                                    <Select.Option
                                                                        key={integration.installationId}
                                                                        value={integration.installationId}
                                                                        disabled={
                                                                            usedAdoptionInstallations.has(
                                                                                integration.installationId,
                                                                            ) &&
                                                                            integration.installationId !==
                                                                                selectedInstallationId
                                                                        }
                                                                    >
                                                                        {integration.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            :   <Space style={{ marginLeft: 44 }}>
                                                    <Form.Item
                                                        noStyle
                                                        name={[field.name, 'threshold']}
                                                        rules={conditionInputData.validationRules}
                                                    >
                                                        <InputNumber
                                                            placeholder="Threshold"
                                                            precision={conditionInputData.precision}
                                                            addonAfter={conditionInputData.addonAfter}
                                                            type="number"
                                                            style={{ width: 170 }}
                                                        />
                                                    </Form.Item>
                                                    <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                        {conditionInputData.descriptionText}
                                                    </Typography.Text>
                                                </Space>)}
                                        {!isNil(selectedConditionThreshold) &&
                                            selectedConditionId &&
                                            thresholdInformationForConditionType(
                                                selectedConditionThreshold,
                                                selectedConditionId,
                                                false,
                                            )}
                                        {selectedConditionId && !hasRequiredCapability && (
                                            <Alert
                                                className="setup-success-banner"
                                                style={{ marginTop: 8 }}
                                                message={
                                                    <Text>
                                                        This rule will not apply until you have the required integration
                                                        capability connected:{' '}
                                                        {displayTextForCapability(
                                                            requiredCapabilityForConditionType(selectedConditionId),
                                                        )}
                                                    </Text>
                                                }
                                                type="warning"
                                                showIcon
                                            />
                                        )}
                                    </Space>
                                    {index < fields.length - 1 && (
                                        <Typography.Text
                                            style={{ color: antGrey.grey6, display: 'block', marginTop: 12 }}
                                        >
                                            <strong>AND</strong>
                                        </Typography.Text>
                                    )}
                                </>
                            );
                        }}
                    </Form.Item>
                ))}
                <Button icon={<PlusOutlined style={{ color: runwayColors.primary }} />} onClick={() => add()}>
                    Add condition
                </Button>
            </Space>
        )}
    </Form.List>
);

const displayTextForMonitoringMetricOption = (metric: AppMonitoringHealthMetric): string =>
    fullDisplayTextForMonitoringMetric(metric) ?? displayTextForMonitoringMetric(metric, true);

const sortedMonitoringMetricsWithThresholds = (
    monitoringMetrics?: AppMonitoringHealthMetric[],
): AppMonitoringHealthMetric[] =>
    sortBy(monitoringMetrics?.filter((metric) => metric.thresholds.length > 0) ?? [], (metric) =>
        displayTextForMonitoringMetricOption(metric).toLocaleLowerCase(),
    );

const MonitoringMetricOptionContent: React.FC<{
    metric: AppMonitoringHealthMetric;
    title: string;
    showDescription?: boolean;
    showGeneratedNameTooltip?: boolean;
}> = ({ metric, title, showDescription, showGeneratedNameTooltip }) => {
    const [icon, iconAlt] = iconAndAltForIntegrationType(metric.integrationId);
    const generatedName = displayTextForMonitoringMetric({ ...metric, customDisplayName: undefined }, true);

    return (
        <Space align="center">
            {icon && <img src={icon} alt={iconAlt} width={20} height={20} />}
            {showGeneratedNameTooltip ?
                <Tooltip title={renamedMetricTooltip(metric.customDisplayName, generatedName)}>{title}</Tooltip>
            :   title}
            {showDescription && metric.description && (
                <MonitoringMetricDescriptionIcon description={metric.description} />
            )}
        </Space>
    );
};

type MaxDataAgeFieldConfig = {
    isAutoPromote: boolean;
    minutesByMetricId?: Record<string, number>;
};

const MaxDataAgeMinutesField: React.FC<{
    name: (string | number)[];
    path: (string | number)[];
    isAutoPromote: boolean;
    form: FormInstance;
}> = ({ name, path, isAutoPromote, form }) => {
    const isEnabled = form.getFieldValue(path) != null;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flexWrap: 'wrap',
                marginLeft: NUMERIC_BADGE_INDENT,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Checkbox
                    checked={isEnabled}
                    onChange={(e) =>
                        form.setFieldValue(path, e.target.checked ? DEFAULT_MAX_DATA_AGE_MINUTES : undefined)
                    }
                >
                    <Typography.Text style={{ color: isEnabled ? antGrey.grey9 : antGrey.grey7, fontSize: 12 }}>
                        {isAutoPromote ?
                            "Hold entire trigger unless this metric's data is newer than"
                        :   'Ignore this metric if its data is older than'}
                    </Typography.Text>
                </Checkbox>
                <ConfigProvider theme={{ components: { InputNumber: { fontSize: 12 } } }}>
                    <Form.Item noStyle name={name} rules={[{ validator: validatePositiveMaxDataAgeMinutes }]}>
                        <InputNumber
                            size="small"
                            disabled={!isEnabled}
                            min={1}
                            max={MAX_DATA_AGE_MINUTES_LIMIT}
                            precision={0}
                            type="number"
                            addonAfter="min"
                            placeholder={String(DEFAULT_MAX_DATA_AGE_MINUTES)}
                            style={{ width: 90 }}
                        />
                    </Form.Item>
                </ConfigProvider>
            </div>
            <TooltipInfoIcon
                tooltipContent={
                    <>
                        Set a value between 1 and {MAX_DATA_AGE_MINUTES_LIMIT} minutes to only consider this health
                        metric if the data received is newer than this. If the data is older, Runway will notify you and{' '}
                        {isAutoPromote ?
                            'wait until fresh data arrives to calculate whether to trigger the automation.'
                        :   'count this metric as met.'}
                    </>
                }
            />
        </div>
    );
};

const NestedHaltMonitoringConditions: React.FC<{
    groupField: any;
    groupPath: any[];
    monitoringMetrics?: AppMonitoringHealthMetric[];
    extraTriggerOptions?: NotificationTriggerOption[];
    variant: ConditionGroupsVariant;
}> = ({ groupField, groupPath, monitoringMetrics, extraTriggerOptions, variant }) => (
    <Form.List name={[groupField.name, 'monitoringConditions']}>
        {(fields, { add, remove }) => (
            <Space direction="vertical" style={{ width: '100%', marginTop: 10 }} size={12}>
                {fields.map((field, index) => (
                    <Form.Item shouldUpdate noStyle key={field.key}>
                        {(form) => {
                            const conditions = form.getFieldValue([...groupPath, 'conditions']) ?? [];
                            const currentMonitoringConditions =
                                form.getFieldValue([...groupPath, 'monitoringConditions']) ?? [];
                            const usedMonitoringConditionsMap =
                                currentMonitoringConditions.reduce(
                                    (acc, condition) => {
                                        if (condition?.id) acc[condition.id] = true;
                                        return acc;
                                    },
                                    {} as Record<string, boolean>,
                                ) ?? {};
                            const selectedMetricConditionId = form.getFieldValue([
                                ...groupPath,
                                'monitoringConditions',
                                field.name,
                                'id',
                            ]);
                            const selectedMetric = monitoringMetrics?.find((m) => m.id === selectedMetricConditionId);
                            const selectedTrigger = extraTriggerOptions?.find(
                                (option) => option.id === selectedMetricConditionId,
                            );

                            return (
                                <>
                                    <Space
                                        direction="vertical"
                                        size={10}
                                        style={{
                                            width: '100%',
                                            backgroundColor: antGrey.grey2,
                                            borderRadius: conditionRowBorderRadius(variant),
                                            padding: '14px 16px',
                                        }}
                                    >
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <NumericBadge value={conditions.length + index + 1} />
                                            <Form.Item
                                                noStyle
                                                name={[field.name, 'id']}
                                                rules={[
                                                    { required: true, message: 'Please select a monitoring condition' },
                                                ]}
                                            >
                                                <Select
                                                    placeholder={
                                                        extraTriggerOptions ? 'Select a condition' : (
                                                            'Select a monitoring condition'
                                                        )
                                                    }
                                                    style={{ width: '100%', minWidth: 0 }}
                                                    optionLabelProp="label"
                                                >
                                                    {(extraTriggerOptions ?? []).map((option) => (
                                                        <Select.Option
                                                            value={option.id}
                                                            key={option.id}
                                                            disabled={usedMonitoringConditionsMap[option.id]}
                                                            label={option.title}
                                                        >
                                                            {option.title}
                                                        </Select.Option>
                                                    ))}
                                                    {sortedMonitoringMetricsWithThresholds(monitoringMetrics).map(
                                                        (metric) => {
                                                            const title = displayTextForMonitoringMetricOption(metric);
                                                            return (
                                                                <Select.Option
                                                                    value={metric.id}
                                                                    key={metric.id}
                                                                    disabled={usedMonitoringConditionsMap[metric.id]}
                                                                    label={
                                                                        <MonitoringMetricOptionContent
                                                                            metric={metric}
                                                                            title={title}
                                                                            showGeneratedNameTooltip
                                                                        />
                                                                    }
                                                                >
                                                                    <MonitoringMetricOptionContent
                                                                        metric={metric}
                                                                        title={title}
                                                                        showDescription
                                                                    />
                                                                </Select.Option>
                                                            );
                                                        },
                                                    )}
                                                </Select>
                                            </Form.Item>
                                            <Button
                                                type="link"
                                                danger
                                                icon={<DeleteOutlined />}
                                                onClick={() => remove(index)}
                                            />
                                        </div>
                                        {selectedTrigger?.input && (
                                            <Space style={{ marginLeft: NUMERIC_BADGE_INDENT }}>
                                                <Form.Item
                                                    noStyle
                                                    name={[field.name, 'threshold']}
                                                    rules={[
                                                        { required: true, message: 'Please enter a threshold' },
                                                        {
                                                            type: 'number',
                                                            min: selectedTrigger.input.min,
                                                            message: `Threshold must be at least ${selectedTrigger.input.min}`,
                                                        },
                                                        {
                                                            type: 'number',
                                                            max: selectedTrigger.input.max,
                                                            message: `Threshold must be at most ${selectedTrigger.input.max}`,
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber
                                                        placeholder="Threshold"
                                                        precision={selectedTrigger.input.precision}
                                                        addonAfter={selectedTrigger.input.addonAfter}
                                                        type="number"
                                                        style={{ width: 170 }}
                                                    />
                                                </Form.Item>
                                                <Typography.Text style={{ color: antGrey.grey7, fontSize: 12 }}>
                                                    {selectedTrigger.input.descriptionText}
                                                </Typography.Text>
                                            </Space>
                                        )}
                                        {selectedMetric && selectedMetric.thresholds.length > 1 && (
                                            <Space direction="vertical" style={{ marginTop: 8 }}>
                                                {selectedMetric.thresholds.map((threshold, i) => (
                                                    <ExtendedThresholdDescription
                                                        key={threshold.value + threshold.condition + i}
                                                        threshold={mapThresholdToFormValue(threshold)}
                                                        metricType={selectedMetric.type}
                                                        metricCategory={selectedMetric.category}
                                                        selectedEventId={selectedMetric.eventName}
                                                        unit={unitForMonitoringMetric(selectedMetric)}
                                                        shouldIndent
                                                    />
                                                ))}
                                            </Space>
                                        )}
                                        {isCustomObaaMetric(selectedMetric) && (
                                            <MaxDataAgeMinutesField
                                                name={[field.name, 'maxDataAgeMinutes']}
                                                path={[
                                                    ...groupPath,
                                                    'monitoringConditions',
                                                    field.name,
                                                    'maxDataAgeMinutes',
                                                ]}
                                                isAutoPromote={false}
                                                form={form}
                                            />
                                        )}
                                    </Space>
                                    {index < fields.length - 1 && (
                                        <Typography.Text
                                            style={{ color: antGrey.grey6, display: 'block', marginTop: 12 }}
                                        >
                                            <strong>OR</strong>
                                        </Typography.Text>
                                    )}
                                </>
                            );
                        }}
                    </Form.Item>
                ))}
                <Button icon={<PlusOutlined style={{ color: runwayColors.primary }} />} onClick={() => add()}>
                    {extraTriggerOptions ? 'Add condition' : 'Add health metric condition'}
                </Button>
            </Space>
        )}
    </Form.List>
);

const NumericBadge: React.FC<{ value: number }> = ({ value }) => {
    return (
        <div
            style={{
                width: 24,
                flexShrink: 0,
                borderRadius: 12,
                backgroundColor: runwayColors.primary,
                color: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 6px',
            }}
        >
            {value}
        </div>
    );
};

function generatePrepareRollbackFields(
    baseField: FormFieldData,
    automation: Automation,
    appStoreType: AppStoreType,
    connectedCapabilities: IntegrationCapability[],
    stabilityIntegrations: Integration[],
    platform: AppPlatform,
    monitoringMetrics?: AppMonitoringHealthMetric[],
    healthMetricsLink?: string,
    resigningStrategy?: RollbackResigningStrategy,
    onSelectResigningStrategy?: (value: RollbackResigningStrategy) => void,
    rebuildByCIUnavailableReason?: string | null,
) {
    const isApplePlatform = getIsApplePlatform(platform);
    const autoPrepareRollbackAutomation = automation as AutomationPrepareRollbackRelease;

    const monitoringConditionOptions: MonitoringConditionOption[] = automationConditionsForAutomationType(
        automation.type,
        appStoreType,
    ).map((type) => {
        return {
            id: type,
            title: displayTextForAutomationConditionType(type),
        };
    });

    const thresholdFields = [];
    const perIntegrationAbandonAdoptionThresholds =
        autoPrepareRollbackAutomation.data?.abandonRollbackAdoptionThresholds;
    if (perIntegrationAbandonAdoptionThresholds && Object.keys(perIntegrationAbandonAdoptionThresholds).length > 0) {
        for (const [installationId, threshold] of Object.entries(perIntegrationAbandonAdoptionThresholds)) {
            if (!threshold) continue;
            thresholdFields.push({
                id: MonitoringAutomationConditionType.Adoption,
                threshold,
                installationId,
            });
        }
    } else if (autoPrepareRollbackAutomation.data?.abandonRollbackAdoptionThreshold) {
        thresholdFields.push({
            id: MonitoringAutomationConditionType.Adoption,
            threshold: autoPrepareRollbackAutomation.data?.abandonRollbackAdoptionThreshold,
        });
    }

    if (autoPrepareRollbackAutomation.data?.abandonRollbackPhasedReleaseDayThreshold) {
        thresholdFields.push({
            id: MonitoringAutomationConditionType.PhasedReleaseDay,
            threshold: autoPrepareRollbackAutomation.data?.abandonRollbackPhasedReleaseDayThreshold,
        });
    }

    if (autoPrepareRollbackAutomation.data?.abandonRollbackStagedRolloutPercentageThreshold) {
        thresholdFields.push({
            id: MonitoringAutomationConditionType.StagedRolloutPercentage,
            threshold: autoPrepareRollbackAutomation.data?.abandonRollbackStagedRolloutPercentageThreshold,
        });
    }

    const baseFields = [
        baseField,
        {
            label: 'Re-signing strategy',
            fieldType: FieldType.Custom,
            name: 'strategy',
            initialValue: resigningStrategy,
            renderField: (data) => {
                return (
                    <Select style={{ width: '100%' }} onChange={(value) => onSelectResigningStrategy(value)}>
                        {data.map((option) => {
                            return (
                                <Select.Option
                                    value={option.value}
                                    key={option.value}
                                    disabled={option.disabled}
                                    title={option.disabledReason}
                                >
                                    {option.displayValue}
                                    {option.disabledReason && (
                                        <Text style={{ color: antGrey.grey7 }}> — {option.disabledReason}</Text>
                                    )}
                                </Select.Option>
                            );
                        })}
                    </Select>
                );
            },
            data: AllRollbackResigningStrategies.map((strategy) => {
                return {
                    value: strategy,
                    displayValue: displayTextForResigningStrategy(strategy),
                    disabled: strategy === RollbackResigningStrategy.CIResign && !!rebuildByCIUnavailableReason,
                    disabledReason:
                        strategy === RollbackResigningStrategy.CIResign ? rebuildByCIUnavailableReason : null,
                };
            }),
            rules: [
                {
                    validator: (_, value) => {
                        if (value === RollbackResigningStrategy.CIResign && rebuildByCIUnavailableReason) {
                            return Promise.reject(new Error(rebuildByCIUnavailableReason));
                        }

                        return Promise.resolve();
                    },
                },
            ],
        },
    ];

    if (isApplePlatform) {
        baseFields.push({
            label: '',
            data: 'Submit automatically when all rollback release steps are ready (green)',
            name: 'shouldAutoSubmit',
            fieldType: FieldType.Checkbox,
            initialValue: autoPrepareRollbackAutomation.data?.shouldAutoSubmit ?? false,
            rules: [],
        });
    }

    return [
        ...baseFields,
        generateThresholdConditionsField(
            'conditions',
            'Automatically discard rollback if the target version meets the following rollout conditions:',
            thresholdFields,
            connectedCapabilities,
            monitoringConditionOptions,
            { allow100PercentRolloutPercentage: true, stabilityIntegrations },
        ),
        ...(monitoringMetrics && monitoringMetrics.length > 0 ?
            [
                generateMonitoringConditionsField(
                    'Automatically discard rollback if the target version meets the following stability conditions:',
                    autoPrepareRollbackAutomation.data?.abandonRollbackMonitoringConditions ?? [],
                    true,
                    'AND',
                    monitoringMetrics,
                ),
                generateLinkToHealthMetricsField(
                    'Constraints for health metrics can be managed from',
                    healthMetricsLink,
                ),
            ]
        :   [
                generateLinkToHealthMetricsField(
                    'To add health metric conditions, you first need to add health metric constraints in',
                    healthMetricsLink,
                ),
            ]),
    ];
}

const generateLinkToHealthMetricsField: (title: string, link?: string) => FormFieldData = (title, link) => {
    return {
        fieldType: FieldType.Custom,
        renderField: () => {
            return (
                <Typography.Text
                    style={{
                        color: antGrey.grey8,
                        fontSize: 12,
                    }}
                >
                    {title} <Link to={link}>App Settings {'>'} Health metrics</Link>
                </Typography.Text>
            );
        },
    };
};

// TODO: Move this logic to a separate file to be properly shared with other components
export const generateThresholdConditionsField: (
    fieldName: string,
    title: string,
    conditionFields: any[],
    connectedCapabilities: IntegrationCapability[],
    monitoringConditionOptions: MonitoringConditionOption[],
    settings?: {
        allow100PercentRolloutPercentage?: boolean;
        ignoreThresholdIfPhasedReleaseIsMissing?: boolean;
        marginBottom?: number;
        stabilityIntegrations?: Integration[];
    },
) => FormFieldData = (
    fieldName,
    title,
    conditionFields,
    connectedCapabilities,
    monitoringConditionOptions,
    settings = {},
) => {
    const {
        allow100PercentRolloutPercentage,
        ignoreThresholdIfPhasedReleaseIsMissing,
        marginBottom,
        stabilityIntegrations,
    } = settings;
    const stabilityIntegrationOptions = stabilityIntegrations ?? [];
    return {
        label: title,
        name: fieldName,
        fieldType: FieldType.List,
        initialValue: conditionFields,
        nestedListFields: [
            {
                fieldType: FieldType.Custom,
                style: { margin: 0 },
                renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                    return (
                        <Form.Item shouldUpdate noStyle style={{ width: '100%' }}>
                            {(form) => {
                                const currentConditions = form.getFieldValue(fieldName);
                                const usedConditionsMap =
                                    currentConditions?.reduce(
                                        (acc, condition) => {
                                            if (
                                                condition?.id &&
                                                condition.id !== MonitoringAutomationConditionType.Adoption
                                            ) {
                                                acc[condition.id] = true;
                                            }
                                            return acc;
                                        },
                                        {} as Record<string, boolean>,
                                    ) ?? {};

                                const selectedConditionId = form.getFieldValue([fieldName, listFieldData.name, 'id']);
                                const selectedInstallationId: string | undefined = form.getFieldValue([
                                    fieldName,
                                    listFieldData.name,
                                    'installationId',
                                ]);

                                const usedAdoptionInstallations = new Set<string>(
                                    (currentConditions ?? [])
                                        .filter(
                                            (c, i) =>
                                                i !== listFieldData.name &&
                                                c?.id === MonitoringAutomationConditionType.Adoption &&
                                                !!c?.installationId,
                                        )
                                        .map((c) => c.installationId as string),
                                );

                                const isAdoptionRow =
                                    selectedConditionId === MonitoringAutomationConditionType.Adoption;
                                const showStabilityIntegrationSelect =
                                    isAdoptionRow && stabilityIntegrationOptions.length > 0;

                                const selectedConditionThreshold = form.getFieldValue([
                                    fieldName,
                                    listFieldData.name,
                                    'threshold',
                                ]);

                                const conditionInputData =
                                    selectedConditionId ?
                                        inputFieldDataForMonitoringConditionType(
                                            selectedConditionId,
                                            allow100PercentRolloutPercentage,
                                        )
                                    :   null;
                                const hasRequiredCapability =
                                    selectedConditionId ?
                                        hasRequiredCapabilityForConditionType(
                                            selectedConditionId,
                                            connectedCapabilities,
                                        )
                                    :   false;

                                return (
                                    <>
                                        <Space
                                            direction="vertical"
                                            size={14}
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 8,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    gap: 8,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <NumericBadge value={index + 1} />
                                                <Form.Item
                                                    noStyle
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    {...listFieldData}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please select a condition',
                                                            type: 'string',
                                                        },
                                                    ]}
                                                    name={[listFieldData.name, 'id']}
                                                >
                                                    <Select
                                                        placeholder="Select a condition"
                                                        style={{
                                                            width: '100%',
                                                            minWidth: 0,
                                                        }}
                                                    >
                                                        {monitoringConditionOptions.map((option) => {
                                                            return (
                                                                <Select.Option
                                                                    value={option.id}
                                                                    key={option.id}
                                                                    disabled={usedConditionsMap[option.id]}
                                                                >
                                                                    {option.title}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </Form.Item>

                                                <Button
                                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                    danger
                                                    type="link"
                                                    onClick={() => remove(index)}
                                                />
                                            </div>
                                            {conditionInputData && (
                                                <>
                                                    {showStabilityIntegrationSelect ?
                                                        // Stack label-above-input when the integration select is also
                                                        // rendered — otherwise the three inline texts get squeezed and
                                                        // wrap vertically next to the inputs.
                                                        <div
                                                            style={{
                                                                marginLeft: 44,
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                gap: 24,
                                                                alignItems: 'flex-start',
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: 4,
                                                                    width: 170,
                                                                }}
                                                            >
                                                                <Typography.Text
                                                                    style={{
                                                                        color: antGrey.grey7,
                                                                        fontSize: 12,
                                                                        lineHeight: '20px',
                                                                        marginBottom: 0,
                                                                    }}
                                                                >
                                                                    {conditionInputData.descriptionText}
                                                                </Typography.Text>
                                                                <Form.Item
                                                                    noStyle
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    {...listFieldData}
                                                                    name={[listFieldData.name, 'threshold']}
                                                                    rules={conditionInputData.validationRules}
                                                                >
                                                                    <InputNumber
                                                                        placeholder="Threshold"
                                                                        precision={conditionInputData.precision}
                                                                        addonAfter={conditionInputData.addonAfter}
                                                                        type="number"
                                                                        style={{
                                                                            width: '100%',
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    gap: 4,
                                                                    width: 220,
                                                                }}
                                                            >
                                                                <Typography.Text
                                                                    style={{
                                                                        color: antGrey.grey7,
                                                                        fontSize: 12,
                                                                        lineHeight: '20px',
                                                                        marginBottom: 0,
                                                                    }}
                                                                >
                                                                    reported by
                                                                </Typography.Text>
                                                                <Form.Item
                                                                    noStyle
                                                                    {...listFieldData}
                                                                    name={[listFieldData.name, 'installationId']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message:
                                                                                'Please select a stability monitoring integration',
                                                                            type: 'string',
                                                                        },
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        placeholder="Select integration"
                                                                        style={{ width: '100%' }}
                                                                    >
                                                                        {stabilityIntegrationOptions.map(
                                                                            (integration) => (
                                                                                <Select.Option
                                                                                    key={integration.installationId}
                                                                                    value={integration.installationId}
                                                                                    disabled={
                                                                                        usedAdoptionInstallations.has(
                                                                                            integration.installationId,
                                                                                        ) &&
                                                                                        integration.installationId !==
                                                                                            selectedInstallationId
                                                                                    }
                                                                                >
                                                                                    {integration.name}
                                                                                </Select.Option>
                                                                            ),
                                                                        )}
                                                                    </Select>
                                                                </Form.Item>
                                                            </div>
                                                        </div>
                                                    :   <Space
                                                            style={{
                                                                marginLeft: 44,
                                                            }}
                                                        >
                                                            <Form.Item
                                                                noStyle
                                                                style={{
                                                                    width: '100%',
                                                                }}
                                                                {...listFieldData}
                                                                name={[listFieldData.name, 'threshold']}
                                                                rules={conditionInputData.validationRules}
                                                            >
                                                                <InputNumber
                                                                    placeholder="Threshold"
                                                                    precision={conditionInputData.precision}
                                                                    addonAfter={conditionInputData.addonAfter}
                                                                    type="number"
                                                                    style={{
                                                                        width: 170,
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                            <Typography.Text
                                                                style={{
                                                                    color: antGrey.grey7,
                                                                    fontSize: 12,
                                                                }}
                                                            >
                                                                {conditionInputData.descriptionText}
                                                            </Typography.Text>
                                                        </Space>
                                                    }
                                                    {!isNil(selectedConditionThreshold) &&
                                                        selectedConditionId &&
                                                        thresholdInformationForConditionType(
                                                            selectedConditionThreshold,
                                                            selectedConditionId,
                                                            ignoreThresholdIfPhasedReleaseIsMissing,
                                                        )}
                                                    {selectedConditionId && !hasRequiredCapability && (
                                                        <Alert
                                                            className="setup-success-banner"
                                                            style={{ margin: 8 }}
                                                            message={
                                                                <Text>
                                                                    This rule will not apply until you have the required
                                                                    integration capability connected:{' '}
                                                                    {displayTextForCapability(
                                                                        requiredCapabilityForConditionType(
                                                                            selectedConditionId,
                                                                        ),
                                                                    )}
                                                                </Text>
                                                            }
                                                            type="warning"
                                                            showIcon
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </Space>
                                        {!(index === currentConditions?.length - 1) && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingTop: 16,
                                                }}
                                            >
                                                <Typography.Text
                                                    style={{
                                                        color: antGrey.grey6,
                                                    }}
                                                >
                                                    <strong>AND</strong>
                                                </Typography.Text>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    );
                },
            },
        ],
        listChildrenWrapper: (children, { add }) => {
            return (
                <Space direction="vertical" style={{ width: '100%', marginBottom }} size={16}>
                    {children}
                    <Form.Item shouldUpdate noStyle>
                        {() => {
                            return (
                                <>
                                    <Button
                                        icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                        onClick={() => add()}
                                    >
                                        Add condition
                                    </Button>
                                </>
                            );
                        }}
                    </Form.Item>
                </Space>
            );
        },
    } as FormFieldData;
};

const generateMonitoringConditionsField: (
    title: string,
    monitoringConditions: string[],
    isPositive: boolean,
    booleanOp: 'AND' | 'OR',
    monitoringMetrics?: AppMonitoringHealthMetric[],
    maxDataAge?: MaxDataAgeFieldConfig,
) => FormFieldData = (title, monitoringConditions, isPositive, booleanOp, monitoringMetrics, maxDataAge) => {
    return {
        label: title,
        name: 'monitoringConditions',
        fieldType: FieldType.List,
        showDivider: true,
        initialValue:
            monitoringConditions
                ?.filter((id) => monitoringMetrics?.find((metric) => metric.id === id)?.thresholds?.length > 0)
                .map((id) => ({ id, maxDataAgeMinutes: maxDataAge?.minutesByMetricId?.[id] })) ?? [],
        rules: [],
        nestedListFields: [
            {
                fieldType: FieldType.Custom,
                style: { margin: 0 },
                renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                    return (
                        <Form.Item
                            shouldUpdate
                            noStyle
                            style={{
                                width: '100%',
                            }}
                        >
                            {(form) => {
                                const currentConditionsLength = form.getFieldValue('conditions')?.length ?? 0;

                                const currentMonitoringConditions = form.getFieldValue(['monitoringConditions']);
                                const usedMonitoringConditionsMap =
                                    currentMonitoringConditions?.reduce(
                                        (acc, condition) => {
                                            if (condition?.id) {
                                                acc[condition.id] = true;
                                            }
                                            return acc;
                                        },
                                        {} as Record<string, boolean>,
                                    ) ?? {};
                                const selectedMetricConditionId = form.getFieldValue([
                                    'monitoringConditions',
                                    listFieldData.name,
                                    'id',
                                ]);

                                const selectedMetric = monitoringMetrics?.find(
                                    (m) => m.id === selectedMetricConditionId,
                                );

                                return (
                                    <>
                                        <Space
                                            direction="vertical"
                                            size={14}
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 8,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    gap: 8,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <NumericBadge value={currentConditionsLength + index + 1} />
                                                <Form.Item
                                                    noStyle
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    {...listFieldData}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please select a monitoring condition',
                                                            type: 'string',
                                                        },
                                                    ]}
                                                    name={[listFieldData.name, 'id']}
                                                >
                                                    <Select
                                                        placeholder="Select a monitoring condition"
                                                        style={{
                                                            width: '100%',
                                                            minWidth: 0,
                                                        }}
                                                        optionLabelProp="label"
                                                    >
                                                        {sortedMonitoringMetricsWithThresholds(monitoringMetrics).map(
                                                            (metric) => {
                                                                const title =
                                                                    displayTextForMonitoringMetricOption(metric);

                                                                return (
                                                                    <Select.Option
                                                                        value={metric.id}
                                                                        key={metric.id}
                                                                        disabled={
                                                                            usedMonitoringConditionsMap[metric.id]
                                                                        }
                                                                        label={
                                                                            <MonitoringMetricOptionContent
                                                                                metric={metric}
                                                                                title={title}
                                                                                showGeneratedNameTooltip
                                                                            />
                                                                        }
                                                                    >
                                                                        <MonitoringMetricOptionContent
                                                                            metric={metric}
                                                                            title={title}
                                                                            showDescription
                                                                        />
                                                                    </Select.Option>
                                                                );
                                                            },
                                                        )}
                                                    </Select>
                                                </Form.Item>

                                                <Button
                                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                    danger
                                                    type="link"
                                                    onClick={() => remove(index)}
                                                />
                                            </div>
                                            {selectedMetric && selectedMetric.thresholds.length > 1 && (
                                                <Space
                                                    direction="vertical"
                                                    style={{
                                                        marginTop: 12,
                                                    }}
                                                >
                                                    {selectedMetric.thresholds.map((threshold, i) => {
                                                        return (
                                                            <ExtendedThresholdDescription
                                                                key={threshold.value + threshold.condition + i}
                                                                threshold={mapThresholdToFormValue(threshold)}
                                                                metricType={selectedMetric.type}
                                                                metricCategory={selectedMetric.category}
                                                                selectedEventId={selectedMetric.eventName}
                                                                unit={unitForMonitoringMetric(selectedMetric)}
                                                                shouldIndent
                                                            />
                                                        );
                                                    })}
                                                </Space>
                                            )}
                                            {maxDataAge && isCustomObaaMetric(selectedMetric) && (
                                                <MaxDataAgeMinutesField
                                                    name={[listFieldData.name, 'maxDataAgeMinutes']}
                                                    path={[
                                                        'monitoringConditions',
                                                        listFieldData.name,
                                                        'maxDataAgeMinutes',
                                                    ]}
                                                    isAutoPromote={maxDataAge.isAutoPromote}
                                                    form={form}
                                                />
                                            )}
                                        </Space>
                                        {!(index === currentMonitoringConditions?.length - 1) && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingTop: 16,
                                                }}
                                            >
                                                <Typography.Text
                                                    style={{
                                                        color: antGrey.grey6,
                                                    }}
                                                >
                                                    <strong>{booleanOp}</strong>
                                                </Typography.Text>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    );
                },
            },
        ],
        listChildrenWrapper: (children, { add }) => {
            return (
                <Space
                    direction="vertical"
                    style={{
                        width: '100%',
                    }}
                    size={16}
                >
                    {children}
                    <Button icon={<PlusOutlined style={{ color: runwayColors.primary }} />} onClick={() => add()}>
                        Add health metric condition
                    </Button>
                </Space>
            );
        },
    } as FormFieldData;
};

const generateMonitoringChecklistItemsField: (
    title: string,
    monitoringChecklistItemTemplates: ChecklistItemTemplate[],
    selectedChecklistItemsIds: string[],
) => FormFieldData = (title, monitoringChecklistItemTemplates, selectedChecklistItemsIds) => {
    return {
        label: title,
        name: 'monitoringChecklistItems',
        fieldType: FieldType.List,
        initialValue: selectedChecklistItemsIds,
        showDivider: true,
        nestedListFields: [
            {
                fieldType: FieldType.Custom,
                style: { margin: 0 },
                renderField: ({ index, listOperations: { remove }, listFieldData }) => {
                    return (
                        <Form.Item
                            shouldUpdate
                            noStyle
                            style={{
                                width: '100%',
                            }}
                        >
                            {(form) => {
                                const currentConditions = form.getFieldValue('monitoringChecklistItems');
                                const usedConditionsMap =
                                    currentConditions?.reduce(
                                        (acc, condition) => {
                                            if (condition) {
                                                acc[condition] = true;
                                            }
                                            return acc;
                                        },
                                        {} as Record<string, boolean>,
                                    ) ?? {};

                                const selectedConditionId = form.getFieldValue([
                                    'monitoringChecklistItems',
                                    listFieldData.name,
                                ]);
                                const selectedCondition = monitoringChecklistItemTemplates.find(
                                    (cliCondition) => cliCondition.id === selectedConditionId,
                                );

                                const selectedConditionTitle = selectedCondition?.title;
                                return (
                                    <>
                                        <Space
                                            direction="vertical"
                                            size={14}
                                            style={{
                                                width: '100%',
                                                backgroundColor: antGrey.grey2,
                                                borderRadius: 8,
                                                padding: '20px 30px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    gap: 8,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <NumericBadge value={index + 1} />
                                                <Form.Item
                                                    {...listFieldData}
                                                    noStyle
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please select a checklist item',
                                                            type: 'string',
                                                        },
                                                    ]}
                                                    name={listFieldData.name}
                                                    style={{ width: '100%' }}
                                                >
                                                    <Select
                                                        placeholder="Select a checklist item"
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                    >
                                                        {monitoringChecklistItemTemplates.map((option) => {
                                                            return (
                                                                <Select.Option
                                                                    value={option.id}
                                                                    key={option.id}
                                                                    disabled={usedConditionsMap[option.id]}
                                                                >
                                                                    {option.title}
                                                                </Select.Option>
                                                            );
                                                        })}
                                                    </Select>
                                                </Form.Item>
                                                <Button
                                                    icon={<DeleteOutlined style={{ color: runwayColors.statusRed }} />}
                                                    danger
                                                    type="link"
                                                    onClick={() => remove(index)}
                                                />
                                            </div>
                                            <Space
                                                style={{
                                                    marginLeft: 44,
                                                }}
                                            >
                                                {selectedCondition && (
                                                    <Typography.Text
                                                        style={{
                                                            color: antGrey.grey7,
                                                        }}
                                                    >
                                                        <strong
                                                            style={{
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            Checklist item &quot;{selectedConditionTitle}&quot;
                                                        </strong>{' '}
                                                        is{' '}
                                                        <strong
                                                            style={{
                                                                color: antGrey.grey8,
                                                            }}
                                                        >
                                                            completed
                                                        </strong>
                                                    </Typography.Text>
                                                )}
                                            </Space>
                                        </Space>
                                        {!(index === currentConditions?.length - 1) && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    paddingTop: 16,
                                                }}
                                            >
                                                <Typography.Text
                                                    style={{
                                                        color: antGrey.grey6,
                                                    }}
                                                >
                                                    <strong>AND</strong>
                                                </Typography.Text>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        </Form.Item>
                    );
                },
            },
        ],
        listChildrenWrapper: (children, { add }) => {
            return (
                <Space
                    direction="vertical"
                    style={{
                        width: '100%',
                    }}
                    size={16}
                >
                    {children}
                    <Form.Item shouldUpdate noStyle>
                        {() => {
                            return (
                                <>
                                    <Button
                                        icon={<PlusOutlined style={{ color: runwayColors.primary }} />}
                                        onClick={() => add()}
                                    >
                                        Add checklist item condition
                                    </Button>
                                </>
                            );
                        }}
                    </Form.Item>
                </Space>
            );
        },
    } as FormFieldData;
};

const hasRequiredCapabilityForConditionType: (
    type: MonitoringAutomationConditionType,
    connectedCapabilities: IntegrationCapability[],
) => boolean = (type, capabilities) => {
    const requiredCapability = requiredCapabilityForConditionType(type);

    return capabilities.includes(requiredCapability);
};

const requiredCapabilityForConditionType: (type: MonitoringAutomationConditionType) => IntegrationCapability = (
    type,
) => {
    switch (type) {
        case MonitoringAutomationConditionType.Adoption:
            return IntegrationCapability.StabilityMonitoring;
        case MonitoringAutomationConditionType.PhasedReleaseDay:
        case MonitoringAutomationConditionType.StagedRolloutPercentage:
            return IntegrationCapability.AppStore;
    }
};

const thresholdInformationForConditionType: (
    threshold: number,
    type: MonitoringAutomationConditionType,
    ignoreThresholdIfPhasedReleaseIsMissing: boolean,
) => React.ReactNode = (threshold, type, ignoreThresholdIfPhasedReleaseIsMissing) => {
    let text = null;
    switch (type) {
        case MonitoringAutomationConditionType.Adoption:
            text = (
                <Typography.Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Release adoption
                    </strong>{' '}
                    is {'>= '}
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        {threshold}%
                    </strong>
                </Typography.Text>
            );
            break;
        case MonitoringAutomationConditionType.PhasedReleaseDay:
            text = (
                <Typography.Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Phased release
                    </strong>{' '}
                    must reach{' '}
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Day {threshold}
                    </strong>
                    {ignoreThresholdIfPhasedReleaseIsMissing && (
                        <span style={{ marginLeft: 4 }}>
                            <TooltipInfoIcon tooltipContent="If there is no phased release / staged rollout enabled, this requirement will be ignored." />
                        </span>
                    )}
                </Typography.Text>
            );
            break;
        case MonitoringAutomationConditionType.StagedRolloutPercentage:
            text = (
                <Typography.Text
                    style={{
                        color: antGrey.grey7,
                    }}
                >
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        Staged rollout percentage
                    </strong>{' '}
                    is {'>= '}
                    <strong
                        style={{
                            color: antGrey.grey8,
                        }}
                    >
                        {threshold}%
                    </strong>
                </Typography.Text>
            );
    }

    return (
        <Space
            style={{
                marginLeft: 44,
            }}
        >
            {text}
        </Space>
    );
};

const inputFieldDataForMonitoringConditionType: (
    conditionType: MonitoringAutomationConditionType,
    allow100PercentRollout: boolean,
) => InputFieldDataWithValidation = (conditionType, allow100PercentRollout) => {
    let data: InputFieldDataWithValidation = {};

    switch (conditionType) {
        case MonitoringAutomationConditionType.Adoption:
            data = {
                max: 99.9999,
                min: 0,
                addonAfter: '%',
                descriptionText: 'session adoption',
            };
            break;
        case MonitoringAutomationConditionType.PhasedReleaseDay:
            data = {
                precision: 0,
                max: 7,
                min: 0,
                step: 1,
                descriptionText: 'phased release day',
            };
            break;
        case MonitoringAutomationConditionType.StagedRolloutPercentage:
            data = {
                max: allow100PercentRollout ? 100 : 99,
                min: 0,
                addonAfter: '%',
                descriptionText: 'staged rollout percentage',
            };
            break;
    }

    return {
        ...data,
        validationRules: [
            {
                min: data.min as number,
                message: `Threshold must be greater than ${data.min}`,
                type: 'number',
            },
            {
                max: data.max as number,
                message: `Threshold must be less than ${data.max}`,
                type: 'number',
            },
            { required: true, message: 'Please enter a threshold' },
        ],
    };
};

function generateSkipInvalidFilesAutomationFields(automation: AutomationBumpVersion): FormFieldData[] {
    return [
        {
            name: 'skipInvalidFiles',
            fieldType: FieldType.Checkbox,
            initialValue: automation.data?.skipInvalidFiles ?? false,
            rules: [],
            data: checkboxLabelWithTooltip(
                'Skip missing files',
                `If enabled, the bump version operation will skip any configured file that can't be fetched from the target branch, rather than failing the entire bump.`,
            ),
        },
    ];
}

function checkboxLabelWithTooltip(label: string, tooltip: React.ReactNode): React.ReactNode {
    return (
        <div>
            {label}
            <Tooltip title={tooltip}>
                <InfoCircleOutlined style={{ color: antGrey.grey7, marginLeft: 8 }} />
            </Tooltip>
        </div>
    );
}

const BYPASS_PULL_REQUESTS_FIELD_KEY = 'shouldCommitAndPushDirectlyToTargetBranch';

const ASSIGN_PR_TO_TOOLTIP =
    'Choose who Runway should assign to the pull requests it opens. Has no effect when the chosen user has no linked version control account.';

const AssignPrToSelect: React.FC<{
    options: { value: RunwayPRAssignee; displayValue: string }[];
    namespace?: string;
    value?: RunwayPRAssignee;
    onChange?: (value: RunwayPRAssignee) => void;
}> = ({ options, namespace, ...selectProps }) => {
    const bypassingPullRequests = !!Form.useWatch(
        namespace ? [namespace, BYPASS_PULL_REQUESTS_FIELD_KEY] : BYPASS_PULL_REQUESTS_FIELD_KEY,
    );

    return (
        <Select {...selectProps} disabled={bypassingPullRequests}>
            {options.map((option) => (
                <Select.Option value={option.value} key={option.value}>
                    {option.displayValue}
                </Select.Option>
            ))}
        </Select>
    );
};

function generateAssignPrToAutomationFields(
    automation:
        | AutomationBumpVersion
        | AutomationCherryPickLocalizableStrings
        | AutomationBackmergeReleaseBranches
        | AutomationCherryPickFromWorkingBranch,
    options: { includeFixOwner: boolean; disableWhenBypassingPullRequests?: boolean },
): FormFieldData[] {
    const selectOptions = [
        { value: RunwayPRAssignee.None, displayValue: 'Leave PR unassigned' },
        { value: RunwayPRAssignee.ReleasePilot, displayValue: 'Assign PR to release pilot' },
        ...(options.includeFixOwner ?
            [{ value: RunwayPRAssignee.FixOwner, displayValue: 'Assign PR to the fix owner or code author' }]
        :   []),
    ];

    const selectField: Pick<FormFieldData, 'fieldType' | 'data' | 'renderField'> =
        options.disableWhenBypassingPullRequests ?
            {
                fieldType: FieldType.Custom,
                renderField: (_data: unknown, namespace?: string) => (
                    <AssignPrToSelect options={selectOptions} namespace={namespace} />
                ),
            }
        :   { fieldType: FieldType.Select, data: selectOptions };

    return [
        {
            label: 'Pull request assignee',
            name: 'assignPrTo',
            tooltip: `${ASSIGN_PR_TO_TOOLTIP} ${
                options.disableWhenBypassingPullRequests ?
                    'Unavailable while pull requests are bypassed, since Runway commits directly to the target branch instead of opening one.'
                :   'Still applies when pull requests are bypassed, since Runway falls back to opening one if it cannot commit directly.'
            }`,
            initialValue: automation.data?.assignPrTo ?? RunwayPRAssignee.None,
            rules: [],
            ...selectField,
        },
    ];
}

function generateBypassPullRequestsFields(
    automation: AutomationBumpVersion | AutomationKickoffRelease | AutomationCherryPickLocalizableStrings,
    checkContext: {
        orgId: string;
        appId: string;
        isGithubVCS: boolean;
        createsMergeCommit: boolean;
        canWaitForRequiredStatusChecks: boolean;
        branchTargetForValues: (values: Record<string, unknown>) => VCSDirectPushBranchTarget | null;
        disabledReasonForValues?: (values: Record<string, unknown>) => string | undefined;
    },
): FormFieldData[] {
    return [
        {
            name: 'shouldCommitAndPushDirectlyToTargetBranch',
            fieldType: FieldType.Checkbox,
            initialValue: automation.data?.shouldCommitAndPushDirectlyToTargetBranch ?? false,
            rules: [],
            data: checkboxLabelWithTooltip('Bypass pull requests', bypassPullRequestsTooltip(checkContext.isGithubVCS)),
        },
        ...(checkContext.isGithubVCS ?
            [
                {
                    name: 'vcsDirectPushCheck',
                    fieldType: FieldType.Custom,
                    initialValue: null,
                    rules: [],
                    skipFormItemWrapper: true,
                    renderField: (_data: unknown, namespace?: string) => {
                        return (
                            <Form.Item shouldUpdate noStyle>
                                {({ getFieldsValue }) => {
                                    const allValues = getFieldsValue();
                                    const values = namespace ? (allValues[namespace] ?? {}) : allValues;
                                    const branchTarget = checkContext.branchTargetForValues(values);
                                    const disabledReason =
                                        !values.shouldCommitAndPushDirectlyToTargetBranch ?
                                            'Enable Bypass pull requests first.'
                                        :   checkContext.disabledReasonForValues?.(values);

                                    return (
                                        <VCSDirectPushCheck
                                            orgId={checkContext.orgId}
                                            appId={checkContext.appId}
                                            branchTarget={branchTarget}
                                            disabledReason={disabledReason}
                                            createsMergeCommit={checkContext.createsMergeCommit}
                                            canWaitForRequiredStatusChecks={checkContext.canWaitForRequiredStatusChecks}
                                        />
                                    );
                                }}
                            </Form.Item>
                        );
                    },
                },
            ]
        :   []),
    ];
}

function bypassPullRequestsTooltip(isGithubVCS: boolean): React.ReactNode {
    const docsLink = (
        <Typography.Link
            href={`https://docs.runway.team/integrations/version-control/github#ensure-runway-can-run-status-checks-if-needed`}
            target="_blank"
            rel="noreferrer"
        >
            here
        </Typography.Link>
    );

    // GitHub gets the shorter copy because the prerequisites test does the explaining. Everywhere else
    // still needs the full description, since there is nothing to click.
    if (isGithubVCS) {
        return (
            <>
                {`Information on how to set this up for each type of VCS integration is available `}
                {docsLink}
                {'. Use the action below to test your existing setup.'}
            </>
        );
    }

    return (
        <>
            {`If your repository has branch protection enabled for the target branch AND those branch protections include requiring pull requests to merge or restricting push access to your target branch, you'll need to update your branch protection rules to allow Runway to bypass requirements. Detailed instructions on how to set this up for each type of VCS integration are available `}
            {docsLink}
            {'.'}
        </>
    );
}

function defaultHelpMessage(automationType: AutomationType): string {
    if (isAppLevelAutomationConfig(automationType)) {
        return 'This setting will apply to all releases for this app.';
    }

    switch (automationType) {
        case AutomationType.AutoResignRollbackBuild:
            return 'This automation applies to rollback releases only.';
        default:
            // All other autos have the ability to select which release types to apply the automation to
            return '';
    }
}

function generateAutoCreateTestRunsFields(baseField: FormFieldData, automation: Automation, integration: Integration) {
    const createTestRunsAutomation = automation as AutomationAutoCreateTestRuns;
    let shouldUseTestPlans = false;
    if (createTestRunsAutomation?.data) {
        shouldUseTestPlans = createTestRunsAutomation.data.strategy === AutoCreateTestRunsStrategy.WithTestPlans;
    } else {
        // This concept applies only to TestRail
        const testRailIntegration = integration as IntegrationTestRail;
        if (testRailIntegration?.data?.selectedProject) {
            shouldUseTestPlans = !testRailIntegration.data.selectedProject.isSingleSuite;
        }
    }

    const supportsCreationWithoutPreviousMatch = integration?.id === IntegrationType.BrowserStack;

    const fields: FormFieldData[] = [
        baseField,
        {
            label: '',
            data: 'Use test plans',
            name: 'useTestPlans',
            fieldType: FieldType.Checkbox,
            initialValue: shouldUseTestPlans,
            rules: [],
            extraFormItemProps: { style: { marginBottom: supportsCreationWithoutPreviousMatch ? 0 : 10 } },
        },
        ...(supportsCreationWithoutPreviousMatch ?
            [
                {
                    label: '',
                    data: 'Create new test runs even when no previous match is found',
                    name: 'allowCreationWithoutPreviousMatch',
                    fieldType: FieldType.Checkbox,
                    initialValue: createTestRunsAutomation.data?.allowCreationWithoutPreviousMatch ?? false,
                    rules: [],
                    extraFormItemProps: { style: { marginTop: 0, marginBottom: 10 } },
                },
            ]
        :   []),
        {
            fieldType: FieldType.WrappedGroup,
            groupedFields: [
                {
                    label: '',
                    name: 'testRunsFilterSettings',
                    fieldType: FieldType.Custom,
                    rules: [{ required: true, message: 'At least one filter is required' }],
                    initialValue:
                        createTestRunsAutomation.data?.testRunsFilterSettings?.length ?
                            createTestRunsAutomation.data?.testRunsFilterSettings
                        :   [{}],
                    renderField: () => (
                        <AutoCreateTestRuns.TestRunsFilterSettings
                            rootFieldName="testRunsFilterSettings"
                            integrationType={integration?.id}
                        />
                    ),
                },
                {
                    label: '',
                    name: 'testPlansFilterSettings',
                    fieldType: FieldType.Custom,
                    rules: [{ required: true, message: 'At least one filter is required' }],
                    initialValue:
                        createTestRunsAutomation.data?.testPlansFilterSettings?.length ?
                            createTestRunsAutomation.data?.testPlansFilterSettings
                        :   [{}],
                    renderField: () => (
                        <AutoCreateTestRuns.TestPlansFilterSettings
                            rootFieldName="testPlansFilterSettings"
                            integrationType={integration?.id}
                        />
                    ),
                },
            ],
            groupChildrenWrapper: (_, fields, renderFields) => {
                return (
                    <Form.Item noStyle dependencies={['useTestPlans']}>
                        {(form) => {
                            const useTestPlans = form.getFieldValue('useTestPlans');
                            const noTestPlanFieldName = 'testRunsFilterSettings';

                            const filteredFields = fields.filter((field) => {
                                if (useTestPlans) {
                                    return field.name !== noTestPlanFieldName;
                                }
                                return field.name === noTestPlanFieldName;
                            });

                            return renderFields(filteredFields);
                        }}
                    </Form.Item>
                );
            },
        },
    ];

    return fields;
}

type RoleEntry = {
    userGroup: UserGroup;
    appStoreRoles: GooglePlayConsolePermission[] | ASCRole[];
    syncEnabled: boolean;
};

function generateAutoSyncAppStoreUsersFields(
    baseField: FormFieldData,
    automation: AutomationSyncAppStoreUsers,
    appStoreName: string,
    appStoreType: AppStoreType,
    userGroups: UserGroup[],
) {
    const rolesEntries: RoleEntry[] = Object.entries(automation.data?.rolesMap ?? {}).map(([groupId, appStoreData]) => {
        return {
            userGroup: userGroups.find((group) => group.id === groupId),
            appStoreRoles: appStoreData.appStore.roles,
            syncEnabled: appStoreData.appStore.syncEnabled,
        };
    });

    let selectOptions: string[];
    switch (appStoreType) {
        case AppStoreType.Apple:
            selectOptions = Object.values(ASCRole);
            break;
        case AppStoreType.Google:
            selectOptions = Object.values(GooglePlayConsolePermission);
            break;
        default:
            selectOptions = [];
    }

    return [
        {
            ...baseField,
            helpMessage: null,
        },
        {
            label: '',
            fieldType: FieldType.List,
            name: 'rolesMap',
            initialValue: rolesEntries,
            nestedListFields: [
                {
                    fieldType: FieldType.Custom,
                    extraFormItemProps: {
                        noStyle: true,
                    },
                    renderField: ({ index, listFieldData }) => {
                        return (
                            <Form.Item shouldUpdate noStyle>
                                {() => {
                                    const entry = rolesEntries[index];

                                    return (
                                        <>
                                            <Divider style={{ margin: '12px 0' }} />
                                            <Row gutter={[8, 8]} justify={'space-around'} align={'middle'}>
                                                <Col span={6}>
                                                    <Text>{displayTextForUserGroup(entry.userGroup)}</Text>
                                                </Col>
                                                <Col span={14}>
                                                    <Form.Item
                                                        style={
                                                            {
                                                                width: '80%',
                                                                height: 'min-content',
                                                                margin: '0 0',
                                                            } as React.CSSProperties
                                                        }
                                                        name={[listFieldData.name, 'appStoreRoles']}
                                                    >
                                                        <Select mode="multiple" placeholder="Select user groups">
                                                            {selectOptions.map((group) => (
                                                                <Select.Option key={group} value={group}>
                                                                    {
                                                                        (getIsAppleAppStore(appStoreType) ?
                                                                            ROLE_TITLE_BY_ASCROLE
                                                                        :   ROLE_TITLE_BY_GPLAY_PERMISSION)[group]
                                                                    }
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={4} flex={'row'} style={{ justifyContent: 'center' }}>
                                                    <Form.Item
                                                        style={
                                                            {
                                                                width: 'min-content',
                                                                height: 'min-content',
                                                                margin: '0 auto 0 0',
                                                            } as React.CSSProperties
                                                        }
                                                        name={[listFieldData.name, 'syncEnabled']}
                                                    >
                                                        <Switch
                                                            defaultChecked={entry.syncEnabled}
                                                            style={{ margin: 'auto auto' }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </>
                                    );
                                }}
                            </Form.Item>
                        );
                    },
                },
            ],
            listChildrenWrapper: (children) => {
                return (
                    <div style={{ marginBottom: '30px' }}>
                        <Row gutter={[8, 8]} justify="space-around" align="middle">
                            <Col span={6} style={{ padding: '0' }}>
                                <Text strong>Runway user group</Text>
                            </Col>
                            <Col span={14}>
                                <Text strong>User group in {displayConsoleNameForAppStoreType(appStoreType)}</Text>
                            </Col>
                            <Col span={4}>
                                <Text strong>Sync enabled</Text>
                            </Col>
                        </Row>
                        {children}
                    </div>
                );
            },
        },
        {
            label: `Allow Runway to remove users from your app in ${appStoreName} when they are removed from your app in Runway`,
            name: 'allowDeleteUsers',
            fieldType: FieldType.Checkbox,
            initialValue: automation.data?.allowDeleteUsers ?? false,
            rules: [],
            data: 'Yes, allow',
        },
    ];
}

function buildDisabledBetaGroupField() {
    return {
        label: 'Default beta groups',
        name: 'selectedBetaGroupIds',
        fieldType: FieldType.Custom,
        initialValue: [],
        renderField: () => {
            return (
                <Select mode="multiple" placeholder="Select" disabled>
                    <Select.Option value="disabled" key="disabled" disabled>
                        Beta groups are disabled
                    </Select.Option>
                </Select>
            );
        },
        rules: [],
    };
}

function buildTestFlightBetaGroupField(
    betaTesting: IntegrationTestFlight,
    betaTestingProvider: IntegrationProviderApple,
    initialGroupIds: string[],
) {
    const appleProvider = betaTestingProvider as IntegrationProviderApple;
    const bundleId = betaTesting.data?.bundleId;
    const testFlightBetaGroups =
        bundleId ?
            appleProvider.data.availableApps.find((availableApp) => availableApp.bundleId === bundleId)?.betaGroups
        :   [];

    return {
        label: 'Default beta testing groups',
        name: 'selectedBetaGroupIds',
        fieldType: FieldType.Custom,
        initialValue: initialGroupIds,
        data: testFlightBetaGroups ?? [],
        renderField: (data: BetaGroup[]) => {
            return (
                <Select mode="multiple" placeholder="Select" filterOption={filterOptionLabel}>
                    {data.map((group) => {
                        return (
                            <Select.Option
                                value={group.id}
                                key={group.id}
                                label={group.name}
                                disabled={!group.isEligibleAsDefaultBetaGroup}
                            >
                                {group.name}
                                {group.isExternal && <Text type="secondary">(external)</Text>}
                            </Select.Option>
                        );
                    })}
                </Select>
            );
        },
        rules: [{ required: true, message: 'Beta groups selection required' }],
    };
}

function buildFirebaseBetaGroupField(
    betaTesting: IntegrationFirebaseBeta,
    betaTestingProvider: IntegrationProviderGoogle,
    initialGroupIds: string[],
) {
    const firebaseProvider = betaTestingProvider as IntegrationProviderGoogle;
    const projectId = betaTesting.data?.projectId;
    const resourcesForProject =
        projectId ?
            firebaseProvider.data?.projectsResources?.find((info) => info.project.projectId === projectId)
        :   null;
    const availableBetaGroups = resourcesForProject?.availableBetaGroups ?? [];

    return {
        label: 'Default beta groups',
        name: 'selectedBetaGroupIds',
        fieldType: FieldType.Custom,
        initialValue: initialGroupIds,
        data: availableBetaGroups,
        renderField: (availableBetaGroups: FirebaseBetaGroup[]) => {
            return (
                <Select
                    allowClear
                    mode="multiple"
                    placeholder="Select default beta groups"
                    filterOption={filterOptionLabel}
                >
                    {availableBetaGroups?.map((group) => (
                        <Select.Option key={group.id} value={group.id} label={group.name}>
                            {group.name}
                        </Select.Option>
                    ))}
                </Select>
            );
        },
        rules: [{ required: true, message: 'Beta groups selection required' }],
    };
}

function generateAutoApplyReviewAttachmentsFields(
    baseField: FormFieldData,
    appId: string,
    orgId: string,
    currentlyUploadedReviewAttachment: FileStats,
    stepConfigId?: string,
) {
    const baseFieldWithFileIsUploadedValidation = {
        ...baseField,
        rules: [
            () => {
                return {
                    validator: (_, value) => {
                        if (!value) {
                            return Promise.resolve();
                        }
                        if (currentlyUploadedReviewAttachment) {
                            return Promise.resolve();
                        }
                        return Promise.reject('Review attachment is required');
                    },
                };
            },
        ],
    };

    return [
        baseFieldWithFileIsUploadedValidation,
        {
            label: 'Review attachment',
            name: 'reviewAttachment',
            fieldType: FieldType.Custom,
            initialValue: null,
            rules: [],
            renderField: () => {
                return (
                    <DefaultReviewAttachmentUpload
                        appId={appId}
                        orgId={orgId}
                        stepConfigId={stepConfigId}
                        currentlyUploadedReviewAttachment={currentlyUploadedReviewAttachment}
                    />
                );
            },
        },
    ];
}

function buildAutoReleaseAndAutoSubmitRequiredStepsFields(
    automation: AutomationAutoSubmitRelease | AutomationAutoRelease,
    appId: string,
    platform: AppPlatform,
    appStoreType: AppStoreType,
    config: {
        fieldKeyPrefix: string;
        submitStrategyFieldName: string | string[];
        shouldUseCustomRequiredStepsFieldName: string | string[];
        customRequiredStepsFieldNamePrefix: string[];
        releaseTypesFieldName: string | string[];
        shouldUseCustomRequiredStepsInitialValue?: boolean;
        customRequiredStepsInitialValue?: Record<ReleaseTypesForNonBlockingSteps, ReleaseStepType[]>;
    },
) {
    const hasSupportForRollbacks = automation.type === AutomationType.AutoSubmitRelease;
    const isStepConfigAutomation = !!automation.stepConfigId;
    if (!isStepConfigAutomation) {
        return [];
    }

    return [
        {
            name: `${config.fieldKeyPrefix}ToggleField`,
            fieldType: FieldType.Custom,
            skipFormItemWrapper: true,
            renderField: () => (
                <FormItem noStyle dependencies={[config.submitStrategyFieldName]}>
                    {(form) => {
                        const submitStrategy = form.getFieldValue(config.submitStrategyFieldName) as
                            | AutoSubmitStrategy
                            | undefined;
                        if (submitStrategy === AutoSubmitStrategy.AfterTargetDateEvenIfNotReady) {
                            return null;
                        }
                        return (
                            <FormItem
                                name={config.shouldUseCustomRequiredStepsFieldName}
                                valuePropName="checked"
                                initialValue={config.shouldUseCustomRequiredStepsInitialValue}
                                style={{ marginBottom: 10 }}
                            >
                                <Checkbox>Override default required steps</Checkbox>
                            </FormItem>
                        );
                    }}
                </FormItem>
            ),
        },
        {
            name: `${config.fieldKeyPrefix}ConfigField`,
            fieldType: FieldType.Custom,
            skipFormItemWrapper: true,
            renderField: () => (
                <FormItem
                    noStyle
                    dependencies={[
                        config.submitStrategyFieldName,
                        config.releaseTypesFieldName,
                        config.shouldUseCustomRequiredStepsFieldName,
                    ]}
                >
                    {(form) => {
                        const submitStrategy = form.getFieldValue(config.submitStrategyFieldName) as
                            | AutoSubmitStrategy
                            | undefined;
                        const shouldUseCustomRequiredSteps = form.getFieldValue(
                            config.shouldUseCustomRequiredStepsFieldName,
                        );

                        const releaseTypesForNonBlockingSteps = form.getFieldValue(
                            config.releaseTypesFieldName,
                        ) as ReleaseTypesForNonBlockingSteps[];

                        if (
                            !shouldUseCustomRequiredSteps ||
                            submitStrategy === AutoSubmitStrategy.AfterTargetDateEvenIfNotReady
                        ) {
                            return null;
                        }

                        const selectedReleaseTypes =
                            releaseTypesForNonBlockingSteps?.length ?
                                releaseTypesForNonBlockingSteps
                            :   [
                                    ReleaseTypesForNonBlockingSteps.Standard,
                                    ReleaseTypesForNonBlockingSteps.Hotfix,
                                    ...(hasSupportForRollbacks ? [ReleaseTypesForNonBlockingSteps.Rollback] : []),
                                ];

                        return selectedReleaseTypes.map((releaseType: ReleaseTypesForNonBlockingSteps) => (
                            <Flex vertical gap={6} style={{ marginBottom: 16 }}>
                                <FormItem
                                    key={releaseType}
                                    initialValue={config.customRequiredStepsInitialValue?.[releaseType] ?? []}
                                    label={`${capitalizeFirstLetter(releaseType)} releases`}
                                    name={[...config.customRequiredStepsFieldNamePrefix, releaseType]}
                                    style={{ marginBottom: 0 }}
                                    rules={[
                                        {
                                            validator: (_, value: ReleaseStepType[] | undefined) =>
                                                value && value.length > 0 ?
                                                    Promise.resolve()
                                                :   Promise.reject(new Error('Select at least one step')),
                                        },
                                    ]}
                                >
                                    <BlockingStepsSelector
                                        appId={appId}
                                        platform={platform}
                                        appStoreType={appStoreType}
                                        releaseType={releaseType}
                                    />
                                </FormItem>
                            </Flex>
                        ));
                    }}
                </FormItem>
            ),
        },
    ];
}
